var nurseslounge_lounge_overview = {
    init:function($params, cback){
        $params = $.extend({},$params, {tab:'init'});
        nurseslounge_lounge_overview.information_lounge_get('init', $params, function($data){
            switch ($data.data.lounge.lounge_type_id){
                case 1:
                    $params = $.extend({},$params, {typeName:'employers'});
                    break;
                case 2:
                    $params = $.extend({},$params, {typeName:'schools'});
                    break;
                case 3:
                    $params = $.extend({},$params, {typeName:'states'});
                    break;
                case 6:
                    $params = $.extend({},$params, {typeName:'nurseAssociations'});
                    break;
                case 8:
                    $params = $.extend({},$params, {typeName:'specialties'});
                    break;
                case 9:
                    $params = $.extend({},$params, {typeName:'thoughtLeaders'});
                    break;
            }
            nurseslounge_lounge_overview.information_administrator_edit($params, $data);
            nurseslounge_lounge_overview.information_location_video($data);
            nurseslounge_lounge_overview.information_virtual_tour($data);
            if(
                $data.data.lounge.lounge_type_id == 1 || //employer
                $data.data.lounge.lounge_type_id == 2 //school
            ){
                nurseslounge_lounge_overview.information_rating($params, $data);
            }
            try{
                google.maps.event.addListener(window, "load", nurseslounge_lounge_overview.information_location_map($data));
            }catch (e) {

            }
            if(cback != undefined){
                cback($data);
            }
        });
        nurseslounge_lounge_overview.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_lounge_overview.task_list_container(function($container){
            $params = $.extend({}, $params, {only:'owners'});
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_lounge_overview.claim_lounge_container(function($container){
            nurseslounge_lounge_overview.claim_lounge($container, $params);
        });
        nurseslounge_lounge_overview.information_meet_our_recruiters(function($config){
            nurseslounge_lounge_overview.information_meet_our_recruiters_engine($config);
        });
        nurseslounge_lounge_overview.report_container(function($container){
            nurseslounge_lounge_overview.report($container, $params);
        });
        nurseslounge_lounge_overview.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
    },
    information_lounge_get:function($action, $params, cback){
        $.ajax({
            url: "/lounge/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$.extend({},$params, {action:$action}),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-lounge-information-edit-modal").modal('hide');
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_rating:function($params, $data){
        var $typeId = $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id : 0;
        var $nursesloungeLoungeInformation = $("#nurseslounge-lounge-information");
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $loungeInformationRight = $nursesloungeLoungeInformation.find('.nurseslounge-lounge-information-right:first');
        var $ratingFirst = $loungeInformationRight.find('.rating-stars:first');
        var $ratingCount = $loungeInformationRight.find('.rating-count:first');
        var $addReviewFirst = $loungeInformationRight.find('.add-review:first');
        var $deleteReviewFirst = $loungeInformationRight.find('.delete-review:first');
        $ratingFirst.unbind().click(function(){
            router.navigate('/lounge/'+$params.key+'/ratingReviews');
        });
        $ratingCount.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_overview.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $addReviewFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_overview.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $deleteReviewFirst.unbind().click(function(){
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_lounge_overview.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
    },
    information_review:function($typeId, $params, $data, executed){
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $contentDiv = $reviewModal.find('.content:first');
        nurseslounge_lounge_overview.information_review_form($params, 'msg',function($chtml){
            $contentDiv.html($chtml).promise().done(function(){
                var $agreeCheckbox = $reviewModal.find('input[name="agree"]');
                var $startBtn = $reviewModal.find('.start-btn');
                $agreeCheckbox.unbind().click(function(){
                    if($agreeCheckbox.is(':checked')){
                        nurseslounge_lounge_overview.information_review_count_down(function(){
                            var $part;
                            switch($typeId){
                                case 1:
                                    $part = 'employer';
                                    break;
                                case 2:
                                    $part = 'school';
                                    break;
                            }
                            $params = $.extend({},$params, {type:$part});
                            nurseslounge_lounge_overview.information_review_form($params, $part,function($chtml){
                                var $userId = libs.memoryGet('user_id');
                                $contentDiv.html($chtml).promise().done(function(){
                                    if($part == 'employer'){
                                        nurseslounge_lounge_overview.information_review_employer_events($params, $data, null, function(){
                                            nurseslounge_myDashboard_accountSettings.coins({user_id:$userId});
                                            executed();
                                        });
                                    }
                                    if($part == 'school'){
                                        nurseslounge_lounge_overview.information_review_school_events($params, $data, null, function(){
                                            nurseslounge_myDashboard_accountSettings.coins({user_id:$userId});
                                            executed();
                                        });
                                    }
                                });
                            });
                        });
                    }else{
                        $startBtn.prop('disabled', true);
                    }
                });
                $reviewModal.modal('show');
            });
        });
    },
    information_remove_review:function($params, cback){
        $.ajax({
            url: "/lounge/reviews/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-lounge-information-edit-modal").modal('hide');
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_review_count_down:function(cback){
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $startBtn = $reviewModal.find('.start-btn');
        $startBtn.prop('disabled', false);
        $startBtn.unbind().click(function(){
            cback();
        });
    },
    information_review_form:function($params, $part, cback){
        $params = $.extend({},$params, {user_id:libs.memoryGet('user_id'),part:$part});
        $.ajax({
            type: 'POST',
            url: '/lounge/informationReviewView/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-lounge-information-edit-modal").modal('hide');
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                }
                cback($data);
            }
        });
    },

    information_review_employer_events:function($params, $data, cback, executed){
        var $lounge = $data.data.lounge;
        var $myReview = $lounge.my_review;
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $ratingStars = $reviewModal.find('.rating-stars:first');
        var $ratingCount = $reviewModal.find('.rating-count:first');
        var $overallInput = $reviewModal.find('input[name="overallRating"]');
        var $form = $reviewModal.find('form:first');
        //Fill
        var $loungeReview = libs.memoryGet('review');
        var $overallRatingVal = $loungeReview.overallRating ? $loungeReview.overallRating : $myReview && $myReview.overall_rating ? $myReview.overall_rating : 0;
        var $recommendToFriendVal = $loungeReview.recommendToFriend ? $loungeReview.recommendToFriend : $myReview && $myReview.recommend_to_friend ? $myReview.recommend_to_friend : '';
        var $jobTitle = $loungeReview.jobTitle ? $loungeReview.jobTitle : $myReview && $myReview.job_title ? $myReview.job_title : '';
        var $facility = $loungeReview.facility ? $loungeReview.facility : $myReview && $myReview.facility ? $myReview.facility : '';
        $facility = $facility == 'Other' && $loungeReview.otherFacility ? $loungeReview.otherFacility : $facility;
        var $prosCons = $loungeReview.prosCons ? $loungeReview.prosCons : $myReview && $myReview.pros_cons ? $myReview.pros_cons : '';
        var $otherFacilityDiv = $reviewModal.find('.other-facility');
        var $selectFacility = $reviewModal.find('select[name="facility"]');
        var $otherFacility = $reviewModal.find('input[name="otherFacility"]');
        if($recommendToFriendVal != ''){
            $reviewModal.find('input[name="recommendToFriend"][value='+$recommendToFriendVal+']').attr('checked', 'checked');
        }
        if($jobTitle != ''){
            $reviewModal.find('input[name="jobTitle"]').val($jobTitle);
        }
        if($prosCons != ''){
            $reviewModal.find('textarea[name="prosCons"]').val($prosCons);
        }
        if($facility != ''){
            var $facilityOption = $selectFacility.find('option');
            var $facilities = $.map($facilityOption ,function($option) {
                return $option.value;
            });
            var $facilityExist = $.inArray($facility, $facilities) != -1 ? true : false;
            if($facilityExist){
                if(!$otherFacilityDiv.hasClass('d-none')){
                    $otherFacilityDiv.addClass('d-none');
                }
                $selectFacility.val($facility);
            }else{
                if($otherFacilityDiv.hasClass('d-none')){
                    $otherFacilityDiv.removeClass('d-none');
                }
                $selectFacility.val('Other');
                $otherFacility.val($facility);
            }
        }
        $selectFacility.unbind().change(function(){
            var $that = $(this);
            var $val = $that.val();
            if($val != ''){
                if($val == 'Other'){
                    if($otherFacilityDiv.hasClass('d-none')){
                        $otherFacilityDiv.removeClass('d-none');
                    }
                }else{
                    if(!$otherFacilityDiv.hasClass('d-none')){
                        $otherFacilityDiv.addClass('d-none');
                    }
                }
                $otherFacility.val('');
            }
        });
        $ratingStars.html(nurseslounge_lounge_overview.add_stars($overallRatingVal));
        $ratingCount.html('<p>'+$overallRatingVal+' / 5 Star</p>');
        $overallInput.val($overallRatingVal);
        //Events
        nurseslounge_lounge_overview.information_review_employer_events_validate(function($form){
            $params = $.extend({}, $params, libs.getObjForm($form));
            nurseslounge_lounge_overview.information_form_request($params, function($data){
                executed();
            });
        });
        var $ratingStarsSvg = $ratingStars.find('svg');
        $ratingStarsSvg.unbind().click(function($event){
            var $that = $(this);
            var $left = $event.clientX - $that.offset().left;
            var $width = $that.width();
            var $leftColor = ($left * 100) / $width;
            var $rightColor = 100 - $leftColor;
            var $url = $that.attr('fill');
            $url = $url.replace('url(#','').replace(')','');
            var $percentReviewId = $url.replace('percentReview','');
            var $totalPercent = 500;
            var $actualPercent = 0;
            for(var $x=1;$x<=5;$x++){
                var $chtml = '';
                var $leftPercent;
                var $rightPercent;
                if($x == $percentReviewId){
                    //$leftPercent = $leftColor < 15 ? 0 : $leftColor > 85 ? 100 : $leftColor;
                    $leftPercent = $leftColor < 15 ? 0 : 100;
                    $rightPercent = $rightColor;
                    $actualPercent+= $leftPercent;
                }
                if($x < $percentReviewId){
                    $leftPercent = 100;
                    $rightPercent = 0;
                    //$actualPercent+= $leftPercent;
                    $actualPercent+= 100;
                }
                if($x > $percentReviewId){
                    $leftPercent = 0;
                    $rightPercent = 100;
                    //$actualPercent+= $leftPercent;
                    $actualPercent+= 0;
                }
                if($leftPercent > 10) {
                    $chtml += '' +
                        '<stop offset="' + $leftPercent + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
                }
                if($rightPercent > 10) {
                    $chtml += '' +
                        '<stop offset="' + $rightPercent + '%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
                }
                $("#percentReview"+$x).html($chtml);
            }
            var $selectedPercent = ($actualPercent/$totalPercent) * 5;
            $selectedPercent = Math.ceil($selectedPercent * 10) / 10;
            $selectedPercent > 0 ? $selectedPercent.toFixed(1) : 0;
            $ratingCount.html('<p>'+$selectedPercent+' / 5 Star</p>');
            $overallInput.val($selectedPercent);
            $form.find('.invalid-feedback').hide();
            $form.find('.error').removeClass('error');
            $form.find('.is-invalid').removeClass('is-invalid');
        });
        if(cback != undefined){
            cback();
        }
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percentReview'+$i+')">' +
                '   <defs>' +
                '       <linearGradient id="percentReview'+$i+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    information_review_employer_events_validate:function(cback){
        $.validator.addMethod("greaterThanZero", function($val) {
            return parseFloat($val) > 0;
        },'Must be greater than zero.');
        var $validator;
        try {
            $validator = $("#nurseslounge-lounge-information-review-modal form:first").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-lounge-information-review-modal form:first").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                overallRating: {
                    required: true,
                    greaterThanZero: true
                },
                recommendToFriend: {
                    required: true
                },
                jobTitle: {
                    required: true
                },
                facility: {
                    required: true
                },
                otherFacility: {
                    required: function(){
                        var $form = $("#nurseslounge-lounge-information-review-modal form:first");
                        return $form.find('select[name="facility"]').val() == 'Other';
                    }
                },
                prosCons: {
                    required: false
                }
            },
            messages: {
                overallRating: {
                    required: "The overall rating is not required",
                    greaterThanZero: "The overall rating must be greater than 0",
                },
                recommendToFriend: {
                    required: "The recommend to a friend is required"
                },
                jobTitle: {
                    required: "The job title is required"
                },
                facility: {
                    required: "The facility is required"
                },
                otherFacility: {
                    required: "The other facility is required"
                },
                prosCons: {
                    required: "The pros and cons is not required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_review_school_events:function($params, $data, cback, executed){
        var $userProfileId = $data.data.user_profile_id;
        var $lounge = $data.data.lounge;
        var $myReview = $lounge.my_review;
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $ratingStars = $reviewModal.find('.rating-stars:first');
        var $ratingCount = $reviewModal.find('.rating-count:first');
        var $overallInput = $reviewModal.find('input[name="overallRating"]');
        var $form = $reviewModal.find('form:first');
        //Fill
        var $loungeReview = libs.memoryGet('review');
        var $currentProfileId = $loungeReview.currentProfileId ? $loungeReview.currentProfileId : $myReview && $myReview.current_profile_id ? $myReview.current_profile_id : $userProfileId;
        var $jobTitle = $loungeReview.jobTitle ? $loungeReview.jobTitle : $myReview && $myReview.job_title ? $myReview.job_title : '';
        var $overallRatingVal = $loungeReview.overallRating ? $loungeReview.overallRating : $myReview && $myReview.overall_rating ? $myReview.overall_rating : 0;
        var $recommendToFriendVal = $loungeReview.recommendToFriend ? $loungeReview.recommendToFriend : $myReview && $myReview.recommend_to_friend ? $myReview.recommend_to_friend : '';
        var $schoolDegreeVal = $loungeReview.schoolDegree ? $loungeReview.schoolDegree : $myReview && $myReview.school_degree ? $myReview.school_degree : '';
        $schoolDegreeVal = $schoolDegreeVal == 'Other' && $loungeReview.otherSchoolDegree ? $loungeReview.otherSchoolDegree : $schoolDegreeVal;
        var $prosCons = $loungeReview.prosCons ? $loungeReview.prosCons : $myReview && $myReview.pros_cons ? $myReview.pros_cons : '';
        var $otherDegreeDiv = $reviewModal.find('.other-degree');
        var $schoolRelationship = $reviewModal.find('select[name="schoolRelationship"]');
        var $selectDegree = $reviewModal.find('select[name="schoolDegree"]');
        var $otherDegree = $reviewModal.find('input[name="otherSchoolDegree"]');
        var $nurseWrapperDiv = $reviewModal.find('.nurse-wrapper');
        var $nurseFacultyWrapperDiv = $reviewModal.find('.nurse-faculty-wrapper');
        if($recommendToFriendVal != ''){
            $reviewModal.find('input[name="recommendToFriend"][value='+$recommendToFriendVal+']').attr('checked', 'checked');
        }
        if($prosCons != ''){
            $reviewModal.find('textarea[name="prosCons"]').val($prosCons);
        }
        if($jobTitle != ''){
            $reviewModal.find('input[name="jobTitle"]').val($jobTitle);
        }
        if($schoolDegreeVal != ''){
            var $degreeOption = $selectDegree.find('option');
            var $degrees = $.map($degreeOption ,function($option) {
                return $option.value;
            });
            var $degreeExist = $.inArray($schoolDegreeVal, $degrees) != -1 ? true : false;
            if($degreeExist){
                if(!$otherDegreeDiv.hasClass('d-none')){
                    $otherDegreeDiv.addClass('d-none');
                }
                $selectDegree.val($schoolDegreeVal);
            }else{
                if($otherDegreeDiv.hasClass('d-none')){
                    $otherDegreeDiv.removeClass('d-none');
                }
                $selectDegree.val('Other');
                $otherDegree.val($schoolDegreeVal);
            }
        }
        $selectDegree.unbind().change(function(){
            var $that = $(this);
            var $val = $that.val();
            if($val != ''){
                if($val == 'Other'){
                    if($otherDegreeDiv.hasClass('d-none')){
                        $otherDegreeDiv.removeClass('d-none');
                    }
                }else{
                    if(!$otherDegreeDiv.hasClass('d-none')){
                        $otherDegreeDiv.addClass('d-none');
                    }
                }
                $otherDegree.val('');
            }
        });
        $ratingStars.html(nurseslounge_lounge_overview.add_stars($overallRatingVal));
        $ratingCount.html('<p>'+$overallRatingVal+' / 5 Star</p>');
        $overallInput.val($overallRatingVal);
        $schoolRelationship.unbind().change(function(){
            var $that = $(this);
            var $val = $that.val();
            $nurseFacultyWrapperDiv.hide();
            $nurseWrapperDiv.hide();
            switch($val){
                case 'nurse_faculty':
                    $nurseFacultyWrapperDiv.show();
                    break;
                case 'nurse':
                    $nurseWrapperDiv.show();
                    break;
            }
        });
        if($currentProfileId == 5){
            $schoolRelationship.val('nurse_faculty').change();
        }else{
            $schoolRelationship.val('nurse').change();
        }
        //Events
        nurseslounge_lounge_overview.information_review_school_events_validate(function($form){
            $params = $.extend({}, $params, libs.getObjForm($form));
            nurseslounge_lounge_overview.information_form_request($params, function($data){
                executed();
            });
        });
        var $ratingStarsSvg = $ratingStars.find('svg');
        $ratingStarsSvg.unbind().click(function($event){
            var $that = $(this);
            var $left = $event.clientX - $that.offset().left;
            var $width = $that.width();
            var $leftColor = ($left * 100) / $width;
            var $rightColor = 100 - $leftColor;
            var $url = $that.attr('fill');
            $url = $url.replace('url(#','').replace(')','');
            var $percentReviewId = $url.replace('percentReview','');
            var $totalPercent = 500;
            var $actualPercent = 0;
            for(var $x=1;$x<=5;$x++){
                var $chtml = '';
                var $leftPercent;
                var $rightPercent;
                if($x == $percentReviewId){
                    //$leftPercent = $leftColor < 15 ? 0 : $leftColor > 85 ? 100 : $leftColor;
                    $leftPercent = $leftColor < 15 ? 0 : 100;
                    $rightPercent = $rightColor;
                    $actualPercent+= $leftPercent;
                }
                if($x < $percentReviewId){
                    $leftPercent = 100;
                    $rightPercent = 0;
                    //$actualPercent+= $leftPercent;
                    $actualPercent+= 100;
                }
                if($x > $percentReviewId){
                    $leftPercent = 0;
                    $rightPercent = 100;
                    //$actualPercent+= $leftPercent;
                    $actualPercent+= 0;
                }
                if($leftPercent > 10) {
                    $chtml += '' +
                        '<stop offset="' + $leftPercent + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
                }
                if($rightPercent > 10) {
                    $chtml += '' +
                        '<stop offset="' + $rightPercent + '%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
                }
                $("#percentReview"+$x).html($chtml);
            }
            var $selectedPercent = ($actualPercent/$totalPercent) * 5;
            $selectedPercent = Math.ceil($selectedPercent * 10) / 10;
            $selectedPercent > 0 ? $selectedPercent.toFixed(1) : 0;
            $ratingCount.html('<p>'+$selectedPercent+' / 5 Star</p>');
            $overallInput.val($selectedPercent);
            $form.find('.invalid-feedback').hide();
            $form.find('.error').removeClass('error');
            $form.find('.is-invalid').removeClass('is-invalid');
        });
        if(cback != undefined){
            cback();
        }
    },
    information_review_school_events_validate:function(cback){
        $.validator.addMethod("greaterThanZero", function($val) {
            return parseFloat($val) > 0;
        },'Must be greater than zero.');
        var $validator;
        try {
            $validator = $("#nurseslounge-lounge-information-review-modal form:first").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-lounge-information-review-modal form:first").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                overallRating: {
                    required: true,
                    greaterThanZero: true
                },
                recommendToFriend: {
                    required: true
                },
                schoolDegree: {
                    required: function(){
                        return $("#nurseslounge-lounge-information-review-modal form:first .nurse-wrapper:first").is(':visible');
                    }
                },
                otherSchoolDegree: {
                    required: function(){
                        var $form = $("#nurseslounge-lounge-information-review-modal form:first");
                        return $form.find('select[name="schoolDegree"]').val() == 'Other';
                    }
                },
                jobTitle:{
                    required: function(){
                        return $("#nurseslounge-lounge-information-review-modal form:first .nurse-faculty-wrapper:first").is(':visible');
                    }
                },
                prosCons: {
                    required: false
                },
            },
            messages: {
                overallRating: {
                    required: "The overall rating is required",
                    greaterThanZero: "The overall rating must be greater than 0",
                },
                recommendToFriend: {
                    required: "The recommend to a friend is required"
                },
                schoolDegree: {
                    required: "The school degree is required"
                },
                otherSchoolDegree: {
                    required: "The other school degree is required"
                },
                jobTitle: {
                    required: "The job title is required"
                },
                prosCons: {
                    required: "The pros and cons is not required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_form_request:function($params, cback){
        $.ajax({
            url: "/lounge/reviews/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-lounge-information-edit-modal").modal('hide');
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                }
                cback($data);
            }
        });
    },

    information_location_map:function($data){
        var $location = $data && $data.data && $data.data.lounge && $data.data.lounge.location ? $data.data.lounge.location : null;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-lounge-information-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    information_location_video:function($data){
        var $lounge = $data.data.lounge;
        var $nursesloungeLoungeInformation = $("#nurseslounge-lounge-information");
        var $loungeInformationLeft = $nursesloungeLoungeInformation.find('.nurseslounge-lounge-information-left:first');
        var $youtubeVideo = $loungeInformationLeft.find('.youtube-video:first');
        var $myVideo = $loungeInformationLeft.find('.my-video:first');
        var $youtubePlayer;
        var $myPlayer;
        var $vimeoRegex = new RegExp ('(vimeo)','gi');
        var $youtubeRegex = new RegExp ('(youtube)','gi');
        if($lounge.video_url && $lounge.video_url != '' && $lounge.video_url.match($vimeoRegex)){
            var $url = $lounge.video_url.split('/');
            var $vimeoId = $url[$url.length - 1];
            var $vimeoPlayer = new Vimeo.Player($youtubeVideo[0], {
                id:$vimeoId,
                width: 680,
                loop: false,
                autoplay:true,
                muted:true
            });
        }
        if($lounge.video_url && $lounge.video_url != '' && $lounge.video_url.match($youtubeRegex)){
            var $url = new URL($lounge.video_url);
            window.YT.ready(function() {
                $youtubePlayer = new YT.Player($youtubeVideo[0], {
                    height: '360',
                    width: '100%',
                    videoId: $url.searchParams.get('v'),
                    events: {
                        'onReady': function () {
                            $youtubePlayer.mute();
                            $youtubePlayer.playVideo();
                        },
                        'onError': function () {
                            $youtubeVideo.hide();
                        }
                    }
                });
            });
        }
        if($lounge.video_root_lounge && $lounge.name){
            $myVideo.height(480);
            $myPlayer = new Artplayer({
                width: '100%',
                height: '480px',
                destroy:true,
                container: $myVideo[0],
                title: $lounge.name,
                url: $lounge.video_root_lounge,
                mutex: true,
                muted:true,
                play: true,
                controls: [
                    {
                        position: 'right',
                        html: 'Fullscreen',
                        click: function() {
                            nurseslounge_lounge_overview.information_location_video_fullscreen($myPlayer, $lounge, true);
                        },
                    },
                ],
                moreVideoAttr: {
                    crossOrigin: 'anonymous'
                }
            }).on('ready', function() {
                $myPlayer.player.pause = true;
                $myPlayer.player.play = true;
            }).on('pause', function(){
                $myPlayer.mask.show = false;
            });
        }
    },
    information_location_video_fullscreen:function($myPlayer, $lounge, $scroll){
        var $gallery;
        var $chtml = '' +
            '<div class="preview-video-container">' +
            '   <div class="video">' +
            '   </div>' +
            '</div>';
        $gallery = new PhotoSwipe($('#nurseslounge-lounge-information-video')[0], PhotoSwipeUI_Default,
            [
                {
                    html: $chtml
                }
            ],
            {
                index: 0,
                clickToCloseNonZoomable: false,
                closeOnScroll: false,
                closeOnVerticalDrag:false,
                closeElClasses: [],
                history:false
            }
        );
        $gallery.init();
        if($myPlayer){
            $myPlayer.player.pause = true;
        }
        var $container = $('#nurseslounge-lounge-information-video .preview-video-container');
        var $target = $container.find('.video:first');
        $target.width($(window).width());
        $target.height($(window).height());
        var $previewPlayer = new Artplayer({
            destroy:true,
            container: $target[0],
            title: $lounge.name,
            url: $lounge.video_root_lounge,
            mutex: true,
            muted:true,
            play: true
        }).on('ready', function() {
            $previewPlayer.player.pause = true;
            $previewPlayer.player.play = true;
            $previewPlayer.mask.show = false;
        }).on('pause', function(){
            $previewPlayer.mask.show = false;
        });
        $previewPlayer.mask.show = false;
        var $fullscreen = false;
        //var $api = $gallery.ui.getFullscreenAPI();
        //$api.enter();
        $("body").css('overflowY', 'hidden');
        $gallery.listen('close', function() {
            if($scroll){
                $("body").css('overflowY', 'scroll');
            }
            $container.remove();
            $previewPlayer.player.pause = true;
            $previewPlayer.destroy();
            if($myPlayer) {
                $myPlayer.player.play = true;
            }
        });
        $gallery.listen('beforeResize', function() {
            if($fullscreen){
                $target.height($(window).height());
            }else{
                $target.height($(window).height());
            }
            $fullscreen = !$fullscreen;
        });
    },

    information_virtual_tour:function($data){
        $(".virtualTourOverview").panorama({
            control_display: 'auto',
            direction: 'left',
            autostar: 1,
            container: $('.virtualTourOverviewContainer'),
            selectionEvent: function ($e, $start) {

            }
        });
    },

    information_administrator_edit:function($params, $data){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $isEmployer = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 1 : false;
        var $isSchool = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 2 : false;
        var $isSpecialty = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 8 : false;
        var $thoughtLeaders = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 9 : false;
        var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
        $isEmployer = !$isEmployer ? $params.typeName == 'employers' : $isEmployer;
        $isSchool = !$isSchool ? $params.typeName == 'schools' : $isSchool;
        $isSpecialty = !$isSpecialty ? $params.typeName == 'specialties' : $isSpecialty;
        $thoughtLeaders = !$thoughtLeaders ? $params.typeName == 'thoughtLeaders' : $thoughtLeaders;
        $credential = $credential.map(function($x){return parseInt($x);});
        var $createNewLoungeAccess = $.inArray(5, $credential) != -1 ? true : false;
        var $editNewLoungeAccess = $.inArray(6, $credential) != -1   ? true : false;
        var $deleteNewLoungeAccess = $.inArray(15, $credential) != -1  ? true : false;
        var $helpVideos = $.inArray(37, $credential) != -1  ? true : false;
        var $allowTabs = {
            'information': $.inArray(7, $credential) != -1 ? true : false,
            'otherNames': $.inArray(62, $credential) != -1 && !$thoughtLeaders ? true : false,
            'specialties': $.inArray(80, $credential) != -1 && $isSpecialty || $.inArray(80, $credential) != -1 && $thoughtLeaders ? true : false,
            'location':    $.inArray(8, $credential) != -1 && !$thoughtLeaders ? true : false,
            'multimedia':  $.inArray(9, $credential) != -1 ? true : false,
            'virtualTour':  $.inArray(83, $credential) != -1 && !$thoughtLeaders ? true : false,
            'recruiters':  $.inArray(10, $credential) != -1 && !$thoughtLeaders ? true : false,
            'owners':  $.inArray(11, $credential) != -1 ? true : false,
            'jobs':  $.inArray(12, $credential) != -1 && $isEmployer || $.inArray(12, $credential) != -1 && $isSchool ? true : false,
            'import':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
            'api':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
            'statistics':  $.inArray(14, $credential) != -1 ? true : false,
            'degrees':  $.inArray(17, $credential) != -1 && $isSchool ? true : false,
            'invite':  $.inArray(24, $credential) != -1 ? true : false,
            'inviteStatistics':  $.inArray(28, $credential) != -1 ? true : false,
            'inviteTemplates':  $.inArray(66, $credential) != -1 ? true : false,
            'createLogo':  $.inArray(67, $credential) != -1 ? true : false,
            'buyAds':  $.inArray(71, $credential) != -1 && $isSchool ? true : false,
            'sponsorDegrees':  $.inArray(75, $credential) != -1 && $isSchool ? true : false,
            'spotlightJobs':  $.inArray(77, $credential) != -1 && !$isSchool && !$thoughtLeaders ? true : false,
        };
        var $allowTabsFiltered = $allowTabs;
        $allowTabs = {};
        $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
        var $information = $("#nurseslounge-lounge-information");
        var $informationRight = $information.find('.nurseslounge-lounge-information-right:first .administrator:first');
        var $options = $informationRight.find('.option');
        $options.each(function(){
            var $that = $(this);
            var $action = $that.data('action');
            if(
                $createNewLoungeAccess && $action == 'create' ||
                $editNewLoungeAccess && $action == 'edit' ||
                $deleteNewLoungeAccess && $action == 'delete' ||
                $helpVideos && $action == 'help-videos' ||
                $helpVideos && $action == 'create-pin-it' ||
                $helpVideos && $action == 'create-event' ||
                $helpVideos && $action == 'send-invitation' ||
                $helpVideos && $action == 'examples-posts'
            ) {
                $that.unbind().click(function () {
                    var $tab = null;
                    $.each($allowTabs, function($i, $v){
                        if($v){
                            $tab = $i;
                            return false;
                        }
                    });
                    if(
                        $tab && $action == 'create' ||
                        $tab && $action == 'edit'
                    ){
                        nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, function () {
                            $modal.scrollTop(0);
                            $modal.modal('show');
                        });
                    }else
                    if($tab && $action == 'help-videos'){
                        window.open('https://www.home.nurseslounge.com/help-center', '_blank', '');
                    }else
                    if($tab && $action == 'create-pin-it'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=NedHuxskMV8');
                    }else
                    if($tab && $action == 'create-event'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=Dd4XKeHIAo0');
                    }else
                    if($tab && $action == 'send-invitation'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=FbQw8gA_KmU');
                    }else
                    if($tab && $action == 'examples-posts'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_images();
                    }else
                    if($action == 'delete'){
                        if(confirm('Are you sure you want to delete this lounge?')){
                            $params = $.extend({},$params, {action:$action,tab:$action});
                            nurseslounge_lounge_overview.information_administrator_tab_request($params, function($data){
                                if($data.status == 'success'){
                                    router.navigate('/lounges');
                                }
                            });
                        }
                    }
                });
            }
        });
        if($isEmployer){
            $modal.find('.nav-pills .nav-link[data-target="#otherNames"]').html("Facility Names");
        }else{
            $modal.find('.nav-pills .nav-link[data-target="#otherNames"]').html("Other Names");
        }
    },
    information_administrator_tab_open_video($video){
        var $modal = $("#nurseslounge-overview-menu-modal");
        var $videoDiv = $modal.find('.video:first');
        $videoDiv.replaceWith('<div class="video"></div>');
        $videoDiv = $modal.find('.video:first');
        var $urlVideo = new URL($video);
        var $videoId = $urlVideo.searchParams.get('v');
        var $youtubePlayer = libs.memoryGet('youtubePlayer');
        if($youtubePlayer){
            $youtubePlayer.destroy();
        }
        try{
            $youtubePlayer = new YT.Player($videoDiv[0], {
                height: '360',
                width: '100%',
                videoId: $videoId,
                playerVars: {'autoplay': 1, 'controls': 1},
                events: {
                    'onReady': function () {
                        $youtubePlayer.mute();
                        $youtubePlayer.playVideoAt(0);
                    },
                    'onError': function () {
                        $videoDiv.hide();
                        libs.memorySave('youtubePlayer', null);
                        nurseslounge_lounge_overview.information_administrator_tab_open_video($video);
                    }
                }
            });
        }catch ($e) {

        }
        libs.memorySave('youtubePlayer', $youtubePlayer);
        $modal.modal('show');
    },
    information_administrator_tab_open_images(){
        var $modal = $("#nurseslounge-overview-menu-modal");
        var $chtml = '<div class="video images">';
        for(var $i=1; $i<9; $i++){
            $chtml+='' +
                '<div class="row">' +
                '   <div class="col-12">' +
                '       <img src="/bimg/NursesLounge/example-post-'+$i+'.png">' +
                '   </div>' +
                '</div>';
        }
        $chtml+='</div>';
        var $videoDiv = $modal.find('.video:first');
        libs.checkImageLoad($($chtml).find('img'), function(){
            $videoDiv.replaceWith($chtml);
            $modal.modal('show');
        });
    },
    information_administrator_select_tab:function($action, $tab, $allowTabs, $params, cback){
        nurseslounge_lounge_overview.information_administrator_tabs_events($action, $tab, $allowTabs, $params,function(){
            $params = $.extend({},$params, {user_id:libs.memoryGet('user_id'),tab:$tab,action:$action});
            nurseslounge_lounge_overview.information_administrator_load($tab, $params, function(){
                switch ($tab) {
                        case 'information':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data){
                                if($data.data.purchase_clicks == 0 && $data.data.lounge.lounge_type_id == 1){
                                    nurseslounge_lounge_overview.information_administrator_tab_information_buy_clicks($params, function(){
                                        nurseslounge_lounge_overview.information_administrator_tab_information($action, $tab, $allowTabs, $params, $data, cback);
                                    });
                                }else{
                                    nurseslounge_lounge_overview.information_administrator_tab_information($action, $tab, $allowTabs, $params, $data, cback);
                                }
                            });
                        break;
                        case 'otherNames':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data){
                                nurseslounge_lounge_overview.information_administrator_tab_otherNames($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        break;
                        case 'specialties':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data){
                                nurseslounge_lounge_overview.information_administrator_tab_specialties($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        break;
                        case 'location':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_administrator_tab_location($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        break;
                        case 'multimedia':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_administrator_tab_multimedia($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        break;
                        case 'virtualTour':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_administrator_tab_virtual_tour($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        break;
                        case 'recruiters':
                            nurseslounge_lounge_overview.information_administrator_tab_recruiters($action, $tab, $allowTabs, $params, null, cback);
                        break;
                        case 'owners':
                            nurseslounge_lounge_overview.information_administrator_tab_owners($action, $tab, $allowTabs, $params, null, cback);
                        break;
                        case 'jobs':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_administrator_tab_jobs($action, $tab, $params, $data, cback);
                            });
                        break;
                        case 'degrees':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_administrator_tab_degrees($action, $tab, $params, $data, cback);
                            });
                        break;
                        case 'import':
                            nurseslounge_lounge_overview.information_administrator_tab_import($action, $tab, $params, null, cback);
                        break;
                        case 'api':
                            nurseslounge_lounge_overview.information_administrator_tab_api($action, $tab, $params, null, cback);
                        break;
                        case 'statistics':
                            //nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_administrator_tab_statistics($action, $tab, $params, null, cback);
                            //});
                        break;
                        case 'invite':
                            nurseslounge_lounge_overview.information_tab_invite($action, $tab, $params, null, cback);
                        break;
                        case 'inviteStatistics':
                            nurseslounge_lounge_overview.information_tab_invite_statistics($action, $tab, $params, null, cback);
                        break;
                        case 'inviteTemplates':
                            nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, null, cback);
                        break;
                        case 'createLogo':
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                nurseslounge_lounge_overview.information_tab_create_logo($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        break;
                        case 'buyAds':
                            nurseslounge_lounge_overview.information_tab_buy_ads($action, $tab, $allowTabs, $params, null, cback);
                        break;
                        case 'sponsorDegrees':
                            nurseslounge_lounge_overview.information_tab_sponsor_degrees($action, $tab, $allowTabs, $params, null, cback);
                        break;
                        case 'spotlightJobs':
                            nurseslounge_lounge_overview.information_tab_spotlight_jobs($action, $tab, $allowTabs, $params, null, cback);
                        break;
                }
            });
        });
    },
    information_administrator_tabs_events:function($action, $tab, $allowTabs, $params, cback){
        //Disable All
        $('#nurseslounge-lounge-information-edit-modal .nav-pills .nav-link').addClass('disabled').removeClass('active');
        $('#nurseslounge-lounge-information-edit-modal .lounge-information-modal-container .tab-pane .container').html('');
        //Events
        $('#nurseslounge-lounge-information-edit-modal .nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, Object.keys($allowTabs)) > -1){
                nurseslounge_lounge_overview.information_administrator_select_tab($action, $selectedTab, $allowTabs, $params, function(){
                    $("#nurseslounge-lounge-information-edit-modal").scrollTop(0);
                });
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $('#nurseslounge-lounge-information-edit-modal .nav-pills .nav-link[data-target="#'+$i+'"]').removeClass('disabled');
        });
        $('#nurseslounge-lounge-information-edit-modal .nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if($action == 'create'){
            $("#nurseslounge-lounge-information-edit-modal .modal-title").html('Create');
        }
        if($action == 'edit'){
            $("#nurseslounge-lounge-information-edit-modal .modal-title").html('<b>Click through the tabs to navigate your Lounge Manager.</b>');
        }
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_load:function($tab, $params, cback){
        nurseslounge_lounge_overview.information_administrator_edit_view_get($tab, $params, function($chtml){
            var $images = $($chtml).find('img');
            libs.checkImageLoad($images, function(){
                $("#"+$tab+" .container").html($chtml).promise().done(function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
        });
    },
    information_administrator_edit_view_get:function($tab, $params, cback){
        $params = $.extend({},$params,{user_id:libs.memoryGet('user_id'),tab:$tab});
        $.ajax({
            type: 'POST',
            url: '/lounge/informationView/get',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_administrator_tab_information_buy_clicks:function($params, cback){
        var $modal = $("#nurseslounge-lounge-overview-buy-clicks-modal");
        nurseslounge_lounge_overview.information_administrator_tab_information_buy_clicks_request($params, function($chtml){
            var $paymentForm = $modal.find('.payment-form');
            $paymentForm.html($chtml).promise().done(function(){
                nurseslounge_lounge_overview.information_administrator_tab_information_buy_clicks_events($params, cback);
                $modal.modal('show');
            });
        });
    },
    information_administrator_tab_information_buy_clicks_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/buyClicks/get',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });

    },
    information_administrator_tab_information_buy_clicks_events:function($params, cback){
        try{
            var $cardSaved = libs.memoryGet('nurseslounge_lounge_overview_card');
            if($cardSaved){
                $cardSaved.destroy();
            }
        }catch ($e){

        }
        var $modal = $("#nurseslounge-lounge-overview-buy-clicks-modal");
        var $paymentForm = $modal.find("form[name='stripe-form-popup']")
        var $paymentFormWrapper = $paymentForm.find('.payment-form-wrapper');
        var $onProgressWrapper = $paymentForm.find('.on-progress-checkmark-wrapper');
        var $successWrapper = $paymentForm.find('.success-checkmark-wrapper');
        var $inputClicks = $paymentForm.find('input[name="clicks"]');
        var $clicksAmount = $paymentForm.find('.clicks-amount');
        var $btnContinue = $paymentForm.find('.continue');
        var $submitButton = $paymentForm.find('button[type="submit"]');
        $paymentFormWrapper.show();
        $onProgressWrapper.hide();
        $successWrapper.hide();
        $submitButton.prop('disabled', false);
        $inputClicks.unbind().change(function(){
            $clicksAmount.html('clicks = $'+($inputClicks.val() * 3)+'.00');
        });
        var $card = stripe.elements();
        var $style = {
            base: {
                'lineHeight': '1.5',
                'fontSize': '1.09em',
                'color': '#00184A',
                'fontFamily': "sans-serif",
                'height':'100%',
                'fontWeight':'100',
                'opacity': '0.9',
                '::placeholder': {
                    'color':'#636c72',
                    'opacity':'0.9'
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            },
        };
        var $cardDom = $paymentForm.find('.card:first')[0];
        var $cardEle = $card.create('card', {style:$style});
        $cardEle.mount($cardDom);
        libs.memorySave('nurseslounge_lounge_overview_card', $cardEle);
        nurseslounge_lounge_overview.information_administrator_tab_information_buy_clicks_validate(function($form){
            var $objForm = libs.getObjForm($form);
            $submitButton.prop('disabled', true);
            $paymentFormWrapper.hide();
            $onProgressWrapper.show();
            stripe.createToken($cardEle, {
                name:$objForm.name,
                address_country:'US',
                currency:'usd'
            }).then(function($res) {
                if($res.token && $res.token.id){
                    var $newParams = $.extend({}, $objForm, $res, $params, {autocharge:0});
                    nurseslounge_lounge_overview.information_administrator_tab_jobs_stripe_request($newParams, function($data){
                        if($data.status == 'success'){
                            $paymentFormWrapper.hide();
                            $onProgressWrapper.hide();
                            $successWrapper.show();
                            $btnContinue.unbind().click(function(){
                                $paymentForm[0].reset();
                                $inputClicks.change();
                                $successWrapper.hide();
                                $modal.on('hidden.bs.modal',function($e){
                                    cback();
                                }).modal('hide');
                            });
                        }else{
                            var $validator = $paymentForm.validate();
                            $validator.showErrors({"card": $data.data.msg});
                            $paymentForm.find("input[name='card']").val('');
                            $submitButton.prop('disabled', false);
                            $onProgressWrapper.hide();
                            $paymentFormWrapper.show();
                        }
                    });
                }else{
                    $submitButton.prop('disabled', false);
                    $onProgressWrapper.hide();
                    $paymentFormWrapper.show();
                }
            });
        });
        $cardEle.on('change', function($e){
            if(!$e.complete && $e.error && $e.error.message){
                var $validator = $paymentForm.validate();
                $validator.showErrors({"card": $e.error.message});
                $paymentForm.find("input[name='card']").val('');
                $paymentForm.find('.invalid-feedback').hide();
                $paymentForm.find('.error').removeClass('error');
                $paymentForm.find('.is-invalid').removeClass('is-invalid');
            }else{
                $paymentForm.find("input[name='card']").val('complete');
            }
        });
    },
    information_administrator_tab_information_buy_clicks_validate:function(cback){
        $.validator.addMethod('minStrict', function ($val, $el, $par) {
            return $val > $par;
        });
        var $modal = $("#nurseslounge-lounge-overview-buy-clicks-modal");
        var $paymentForm = $modal.find("form[name='stripe-form-popup']")
        var $validator;
        try {
            $validator = $paymentForm.validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $paymentForm.validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                clicks: {
                    required: true,
                    minStrict: 99,
                    number: true
                },
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                },
                card: {
                    required: true
                }
            },
            messages: {
                clicks:{
                    required: "The clicks is required",
                    minStrict:"The clicks should be greater than 99",
                    number: "The clicks should be a number"
                },
                name:{
                    required: "The name is required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                card:{
                    required: "The card is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_administrator_tab_information:function($action, $tab, $allowTabs, $params, $data, cback){
        var $loungeSchoolClass = $data && $data.data && $data.data.lounge_school_class ? $data.data.lounge_school_class : null;
        var $loungeSchoolType = $data && $data.data && $data.data.lounge_school_type ? $data.data.lounge_school_type : null;
        var $loungeType = $data && $data.data && $data.data.lounge_type ? $data.data.lounge_type : null;
        var $lounge = $data && $data.data && $data.data.lounge ? $data.data.lounge : null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $information = $modal.find(".lounge-information-modal-container #information .container");
        var $informationForm = $information.find('form:first');
        var $overview = $informationForm.find('.overview');
        var $schoolClassDiv = $informationForm.find('.lounge-school-class');
        var $schoolTypeDiv = $informationForm.find('.lounge-school-type');
        $informationForm.find("input[name='phoneNumber']").mask('+(00) 000-000-0000');
        var $loungeTypeOptions = '';
        $loungeTypeOptions += '<option value="">Select the lounge type</option>';
        $.each($loungeType, function($i, $v){
            $loungeTypeOptions += '<option value="'+$i+'">'+$v+'</option>';
        });
        var $loungeClassOptions = '';
        $loungeClassOptions += '<option value="">Select available classroom settings</option>';
        var $loungeSchoolClassValue = '';
        $.each($loungeSchoolClass, function($i, $v){
            switch($v){
                case 'Campus Only':
                    $loungeSchoolClassValue = 'Campus Only: Degree Programs are only offered for on campus learning.';
                    break;
                case 'Online Only':
                    $loungeSchoolClassValue = 'Online Only: All Degree Programs offered are 100% online.';
                    break;
                case 'Hybrid':
                    $loungeSchoolClassValue = 'Both: Degrees offered for both campus learning and distance learning.';
                    break;
            }
            $loungeClassOptions += '<option value="'+$i+'">'+$loungeSchoolClassValue+'</option>';
        });
        var $loungeSchoolTypeOptions = '';
        $loungeSchoolTypeOptions += '<option value="">Choose the option that best fits your school</option>';
        var $loungeSchoolTypeValue = '';
        $.each($loungeSchoolType, function($i, $v){
            switch($v){
                case 'ADN/ASN School':
                    $loungeSchoolTypeValue = 'ADN School: The maximum degree level we offer is a 2-year nursing degree program such as ADN.';
                    break;
                case 'BS/BSN School':
                    $loungeSchoolTypeValue = 'BS/BSN School: We offer a minimum of a B.S. or Bachelor\'s Degree in Nursing.';
                    break;
                case 'Graduate School Only':
                    $loungeSchoolTypeValue = 'Graduate School Only: We only offer graduate degree programs.';
                    break;
            }
            $loungeSchoolTypeOptions += '<option value="'+$i+'">'+$loungeSchoolTypeValue+'</option>';
        });
        $informationForm.find("select[name='loungeType']").html($loungeTypeOptions).promise().done(function(){
            $(this).unbind().change(function(){
                if($(this).val() == '2'){
                    $schoolClassDiv.show();
                    $schoolTypeDiv.show();
                    $schoolClassDiv.parent().show();
                    $schoolTypeDiv.parent().show();
                }else{
                    $schoolClassDiv.hide();
                    $schoolTypeDiv.hide();
                    $schoolClassDiv.parent().hide();
                    $schoolTypeDiv.parent().hide();
                }
            });
        });
        $informationForm.find("select[name='loungeSchoolClass']").html($loungeClassOptions);
        $informationForm.find("select[name='loungeSchoolType']").html($loungeSchoolTypeOptions).promise().done(function(){
            nurseslounge_lounge_overview.information_administrator_tab_information_validate(function($form){
                var $formObj = libs.getObjForm($form);
                var $formOverview = $overview.summernote('code');
                var $newParams = $.extend({},$params, $formObj);
                $newParams = $.extend({},$newParams, {overview:$formOverview,action:$action,tab:$tab});
                $information.html('' +
                    '<div class="row">' +
                    '   <div class="col-sm-4 col-md-4 col-lg-4 offset-sm-4 offset-md-4 offset-lg-4 my-3 text-center loader-container">' +
                    '       <img src="/bimg/NursesLounge/loader.gif?" class="rounded img-fluid clear-img loader">' +
                    '   </div>' +
                    '</div>');
                nurseslounge_lounge_overview.information_administrator_tab_request($newParams, function($data){
                    var $action = $data.data.action;
                    var $key = $data.data.key;
                    $params = $.extend({},$params, {key:$key,action:$action});
                    if($data.status == 'success'){
                        if($newParams.action == 'create'){
                            router.navigate($data.data.link,true);
                            nurseslounge_lounge_overview.init($params, function ($data) {
                                nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                            });
                        }
                        if($newParams.action == 'edit'){
                            libs.refreshBoxFrom('.page-contents', $params, function(){
                                nurseslounge_lounge.submenu($params, function(){
                                    nurseslounge_lounge_overview.init($params, function($data){
                                        nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                                    });
                                });
                            });
                        }
                    }else{
                        $modal.modal('hide');
                    }
                });
            });
            try{
                $overview.summernote('destroy');
            }catch (e) {

            }
            var $stripTags = function ($context) {
                var $ui = $.summernote.ui;
                var $button = $ui.button({
                    contents: 'Remove Formatting',
                    tooltip: 'Strip Tags',
                    click: function () {
                        var $text = [];
                        var $code = $overview.summernote("code");
                        $($code).each(function(){
                            $text.push('<p>'+$(this).text()+'</p>');
                        });
                        $code = $text.join('');
                        $overview.summernote("code", $code);
                    }
                });
                return $button.render();
            }
            $overview.summernote({
                placeholder: 'Overview ...',
                height: '400px',
                width: '100%',
                focus: true,
                disableResizeEditor: true,
                dialogsInBody: true,
                dialogsFade: true,
                codeviewFilter: true,
                codeviewIframeFilter: true,
                spellCheck: true,
                disableGrammar: false,
                styleTags: [
                    'p',
                    'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
                ],
                fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
                fontSizeUnits: ['pt', 'px'],
                toolbar: [
                    ['style', ['style']],
                    ['font', ['fontname', 'fontsize', 'fontsizeunit']],
                    ['font', ['forecolor', 'backcolor']],
                    ['font', ['bold', 'italic', 'underline']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['para', ['height']],
                    ['hr', ['hr']],
                    ['stripTags', ['stripTags']]
                ],
                buttons: {
                    stripTags: $stripTags
                }
            });
            //Set values
            if($lounge.lounge_type_id) {
                $informationForm.find("select[name='loungeType']").val($lounge.lounge_type_id).attr('disabled', 'disabled');
            }
            if($lounge.school_class_id) {
                $informationForm.find("select[name='loungeSchoolClass']").val($lounge.school_class_id);
            }
            if($lounge.school_type_id) {
                $informationForm.find("select[name='loungeSchoolType']").val($lounge.school_type_id);
            }
            if($lounge.lounge_type_id == 2){
                $schoolClassDiv.show();
                $schoolTypeDiv.show();
                $schoolClassDiv.parent().show();
                $schoolTypeDiv.parent().show();
            }else{
                $schoolClassDiv.hide();
                $schoolTypeDiv.hide();
                $schoolClassDiv.parent().hide();
                $schoolTypeDiv.parent().hide();
            }
            if($lounge.name) {
                $informationForm.find("input[name='loungeName']").val($lounge.name);
            }
            if($lounge.description) {
                $overview.summernote('code', $lounge.description);
            }
            if($lounge.tagline) {
                $informationForm.find("input[name='tagline']").val($lounge.tagline);
            }
            if($lounge.url) {
                $informationForm.find("input[name='website']").val($lounge.url);
            }
            if($lounge.website_data){
                var $websiteData = $lounge.website_data;
                $informationForm.find('.website-thumb').hide();
                $informationForm.find(".website-thumb .logo img").attr('src', '/bimg/NursesLounge/wa-loader.gif');
                $informationForm.find(".website-thumb .logo").hide();
                $informationForm.find(".website-thumb .title").hide();
                $informationForm.find(".website-thumb .description").hide();
                if ($websiteData != null && $websiteData[1] != '') {
                    $informationForm.find(".website-thumb .logo img").attr('src', $websiteData[1]);
                    $informationForm.find(".website-thumb .logo").show();
                }
                if ($websiteData != null && $websiteData[3] != '') {
                    $informationForm.find(".website-thumb .title").html($websiteData[3]);
                    $informationForm.find(".website-thumb .title").show();
                }
                if ($websiteData != null && $websiteData[4] != '') {
                    $informationForm.find(".website-thumb .description").html($websiteData[4]);
                    $informationForm.find(".website-thumb .description").show();
                }
                if ($websiteData != null && $websiteData[1] != '' ||
                    $websiteData != null && $websiteData[3] != '' ||
                    $websiteData != null && $websiteData[4] != '') {
                    $informationForm.find('.website-thumb').show();
                }
            }
            if($lounge.email) {
                $informationForm.find("input[name='email']").val($lounge.email);
            }
            if($lounge.phone) {
                $informationForm.find("input[name='phoneNumber']").val($lounge.phone);
            }
        });
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_information_validate:function(cback){
        var $validator;
        try {
            $validator = $("#information form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#information form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                loungeType: {
                    required: true
                },
                loungeSchoolClass: {
                    required: function(){
                        return  $("#information form select[name='loungeType']").val() == 2
                    }
                },
                loungeSchoolType: {
                    required: function(){
                        return  $("#information form select[name='loungeType']").val() == 2
                    }
                },
                loungeName: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                tagline: {
                    required: false,
                    minlength: 3,
                    maxlength: 191
                },
                website: {
                    required: false,
                    minlength: 3,
                    maxlength: 191
                },
                email: {
                    required: false,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                }
            },
            messages: {
                loungeType:{
                    required: "The lounge type is required"
                },
                loungeSchoolClass: {
                    required: "The lounge school class is required"
                },
                loungeSchoolType: {
                    required: "The lounge school type is required"
                },
                loungeName: {
                    required: "The lounge name is required",
                    minlength: "The lounge name must have at least 3 characters",
                    maxlength: "The lounge name cannot exceed 191 characters"
                },
                tagline: {
                    required: "The tagline is not required",
                    minlength: "The tagline must have at least 3 characters",
                    maxlength: "The tagline cannot exceed 191 characters"
                },
                website: {
                    required: "The website is not required",
                    minlength: "The website must have at least 3 characters",
                    maxlength: "The website cannot exceed 191 characters"
                },
                email: {
                    required: "The email is not required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_administrator_tab_specialties:function($action, $tab, $allowTabs, $params, $data, cback){
        var $specialtiesVal = $data && $data.data && $data.data.lounge && $data.data.lounge.specialties ? $data.data.lounge.specialties : [];
        $specialtiesVal = libs.pluck($specialtiesVal, 'specialty_id');
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $specialtiesForm = $modal.find(".lounge-information-modal-container #specialties .container");
        var $specialties = $specialtiesForm.find("select[name='specialties']");
        try{
            $specialties.chosen('destroy');
        }catch (e) {}
        $specialties.chosen();
        $specialties.val($specialtiesVal).trigger("chosen:updated");
        $specialties.unbind();
        nurseslounge_lounge_overview.information_administrator_tab_specialties_validate(function($form){
            var $formObj = libs.getObjForm($form);
            var $newParams = $.extend({},$params, $formObj);
            nurseslounge_lounge_overview.information_administrator_tab_request($newParams, function($data){
                if($data.status == 'success'){
                    nurseslounge_lounge_overview.init($params, function($data){
                        nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                    });
                }else{
                    $modal.modal('hide');
                }
            });
        });
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_specialties_validate:function(cback){
        var $validator;
        try {
            $validator = $("#specialties form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#specialties form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                specialties: {
                    required: false
                }
            },
            messages: {
                specialties:{
                    required: "The specialties is not required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_administrator_tab_otherNames:function($action, $tab, $allowTabs, $params, $data, cback){
        var $lounge = $data && $data.data && $data.data.lounge ? $data.data.lounge : null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $otherNamesForm = $modal.find(".lounge-information-modal-container #otherNames .container");
        var $otherNames = $otherNamesForm.find("input[name='otherNames']");
        var $tagify = libs.memoryGet('nurseslounge_lounge_overview_tagify');
        if($tagify){
            try{
                $tagify.removeAllTags();
                $tagify.destroy();
                $otherNamesForm.find(".tagify__input--outside").remove();
            }catch ($e) {

            }
        }
        $tagify = new Tagify($otherNames[0]);
        $tagify.DOM.input.classList.add('tagify__input--outside');
        $tagify.DOM.scope.parentNode.insertBefore($tagify.DOM.input, $tagify.DOM.scope);
        if($lounge.lounge_name){
            if ($lounge.lounge_name.length > 0) {
                $.each($lounge.lounge_name, function ($i, $v) {
                    $tagify.addTags($v.name);
                });
            }
        }
        libs.memorySave('nurseslounge_lounge_overview_tagify', $tagify);
        nurseslounge_lounge_overview.information_administrator_tab_otherNames_validate(function($form){
            var $formObj = libs.getObjForm($form);
            if($formObj.otherNames != ''){
                $formObj = JSON.parse($formObj.otherNames);
            }
            var $newParams = $.extend({},$params, {otherNames:$formObj});
            $otherNamesForm.html('' +
                '<div class="row">' +
                '   <div class="col-sm-4 col-md-4 col-lg-4 offset-sm-4 offset-md-4 offset-lg-4 my-3 text-center loader-container">' +
                '       <img src="/bimg/NursesLounge/loader.gif?" class="rounded img-fluid clear-img loader">' +
                '   </div>' +
                '</div>');
            nurseslounge_lounge_overview.information_administrator_tab_request($newParams, function($data){
                if($data.status == 'success'){
                    nurseslounge_lounge_overview.init($params, function($data){
                        nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                    });
                }else{
                    $modal.modal('hide');
                }
            });
        });
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_otherNames_validate:function(cback){
        var $validator;
        try {
            $validator = $("#otherNames form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#otherNames form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                otherNames: {
                    required: false
                }
            },
            messages: {
                otherNames:{
                    required: "The lounge other names is not required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_administrator_tab_location:function($action, $tab, $allowTabs, $params, $data, cback){
        var $location = $data && $data.data && $data.data.lounge && $data.data.lounge.location ? $data.data.lounge.location : null;
        var $addressStateId = $data && $data.data && $data.data.address_state_id ? $data.data.address_state_id : null;
        var $states = $data && $data.data && $data.data.states ? $data.data.states :null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $locationContainer = $modal.find(".lounge-information-modal-container #location .container");
        var $locationForm = $locationContainer.find('form:first');
        nurseslounge_lounge_overview.information_administrator_tab_location_validate(function($form){
            var $formObj = libs.getObjForm($form);
            var $newParams = $.extend({},$params, $formObj);
            $newParams = $.extend({},$newParams, {action:$action,tab:$tab});
            $locationContainer.html('' +
                '<div class="row">' +
                '   <div class="col-sm-4 col-md-4 col-lg-4 offset-sm-4 offset-md-4 offset-lg-4 my-3 text-center loader-container">' +
                '       <img src="/bimg/NursesLounge/loader.gif?" class="rounded img-fluid clear-img loader">' +
                '   </div>' +
                '</div>');
            nurseslounge_lounge_overview.information_administrator_tab_request($newParams, function($data){
                if($data.status == 'success'){
                    libs.refreshBoxFrom('.page-contents', $params, function(){
                        nurseslounge_lounge.submenu($params, function(){
                            nurseslounge_lounge_overview.init($params, function($data){
                                nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                            });
                        });
                    });
                }else{
                    $modal.modal('hide');
                }
            });
        });
        var $stateArr = [];
        $.each($states, function($i, $v){
            $stateArr.push([$i, $v]);
        });
        $stateArr.sort(function($a, $b) {
            if($a[1] < $b[1]) { return -1; }
            if($a[1] > $b[1]) { return 1; }
            return 0;
        });
        var $stateChtml = '';
        $stateChtml += '<option value="">Select the state</option>';
        $.each($stateArr, function($i, $v){
            $stateChtml += '<option value="'+$v[0]+'">'+$v[1]+'</option>';
        });
        $locationForm.find('select[name="state"]').html($stateChtml).promise().done(function(){
            if($location && $location.address_street) {
                $locationForm.find('input[name="street"]').val($location.address_street);
            }
            if($location && $location.address_city) {
                $locationForm.find('input[name="city"]').val($location.address_city);
            }
            if($addressStateId) {
                $locationForm.find('select[name="state"]').val($addressStateId);
            }
            if($location && $location.address_zip_code) {
                $locationForm.find('input[name="zipCode"]').val($location.address_zip_code);
            }
            if($location && $location.address_latitude && $location.address_longitude) {
                nurseslounge_lounge_overview.information_administrator_tab_location_map($location, function () {
                    if ($location.address_is_unmappable == 0) {
                        $locationForm.find('.lat').html($location.address_latitude).show();
                        $locationForm.find('.lng').html($location.address_longitude).show();
                        $locationForm.find('#edit-location-map').show();
                    } else {
                        $locationForm.find('.lat').hide();
                        $locationForm.find('.lng').hide();
                        $locationForm.find('#edit-location-map').hide();
                    }
                });
            }
            if(cback != undefined){
                cback();
            }
        });
    },
    information_administrator_tab_location_validate:function(cback){
        var $validator;
        try {
            $validator = $("#location form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#location form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                street: {
                    required: false,
                    minlength: 3,
                    maxlength: 191
                },
                city: {
                    required: false,
                    minlength: 3,
                    maxlength: 191
                },
                state: {
                    required: true
                },
                zipCode: {
                    required: false,
                    minlength: 3,
                    maxlength: 191
                }
            },
            messages: {
                street: {
                    required: "The street is not required",
                    minlength: "The street must have at least 3 characters",
                    maxlength: "The street cannot exceed 191 characters"
                },
                city: {
                    required: "The city is not required",
                    minlength: "The city must have at least 3 characters",
                    maxlength: "The city cannot exceed 191 characters"
                },
                state: {
                    required: "The state is required"
                },
                zipCode: {
                    required: "The zip code is not required",
                    minlength: "The zip code must have at least 3 characters",
                    maxlength: "The zip code cannot exceed 191 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_administrator_tab_location_map:function($location, cback){
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            try{
                var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
                var $iconUrl =  './../../bimg/NursesLounge/active.png';
                var $map = new google.maps.Map(document.getElementById('edit-location-map'), {
                    center:$position,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoom: 15
                });
                $map.setTilt(0);
                var $marker = new google.maps.Marker({
                    position:$position,
                    map: $map,
                    animation: google.maps.Animation.DROP,
                    icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
                });
            }catch (e) {

            }
        }
        if(cback != undefined){
            cback();
        }
    },

    information_administrator_tab_multimedia:function($action, $tab, $allowTabs, $params, $data, cback){
        var $lounge = $data && $data.data && $data.data.lounge ? $data.data.lounge : null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $multimedia = $modal.find(".lounge-information-modal-container #multimedia .container");
        var $form = $multimedia.find('form');
        var $logoFileInput = $multimedia.find('input[name="logo"]');
        var $changeLogoButton = $multimedia.find('.logo-change:first');
        var $logoImage = $multimedia.find('.logo:first');
        var $thumbnailImg = $multimedia.find('.thumbnail-img:first');
        var $photoFileInput = $multimedia.find('input[name="photo"]');
        var $changePhotoButton = $multimedia.find('.photo-change:first');
        var $photoImage = $multimedia.find('.photo:first');
        var $youtubeVideo = $multimedia.find('input[name="youtubeVideo"]');
        var $myVideoFileInput = $multimedia.find('input[name="video"]');
        var $myVideoButton = $multimedia.find('.update-my-video');
        var $myVideoDelete = $multimedia.find('.delete-my-video');
        var $videoRoot = '';
        var $urlBindind;
        var $originalLogoImage = $logoImage;
        $logoFileInput.unbind().change(function(){
            var $that = this;
            $logoImage = $multimedia.find('.logo:first');
            libs.renderImage($that, $logoImage);
            var $image = $logoImage.cropme({
                "container": {
                    "width": $logoImage.width(),
                    "height": $logoImage.height()
                },
                "viewport": {
                    "width": $logoImage.width(),
                    "height": $logoImage.width(),
                    "type": "circle",
                    "border": {
                        "width": 0,
                        "enable": true,
                        "color": "#ffffff"
                    }
                },
                "zoom": {
                    "enable": true,
                    "mouseWheel": true,
                    "slider": false
                },
                "rotation": {
                    "slider": false,
                    "enable": false,
                    "position": "left"
                },
                "transformOrigin": "viewport"
            });
            $thumbnailImg.find('.cropme-wrapper').prependTo($thumbnailImg);
            if($($that)[0].files != ''){
                $changeLogoButton.unbind().click(function(){
                    $image.cropme('crop', {
                        type: 'base64'
                    }).then(function($imageBase64) {
                        $image.cropme('destroy');
                        $thumbnailImg.find('div:first').remove();
                        $thumbnailImg.prepend($originalLogoImage);
                        $logoImage = $multimedia.find('.logo:first');
                        $logoImage.attr('src', $imageBase64);
                        $changeLogoButton.unbind().click(function(){
                            $logoFileInput.click();
                        });
                    });
                });
            }else{
                $changeLogoButton.unbind().click(function(){
                    $logoFileInput.click();
                });
            }

        });
        $changeLogoButton.unbind().click(function(){
            $logoFileInput.click();
        });
        $photoFileInput.unbind().change(function(){
            libs.renderImage(this, $photoImage);
        });
        $changePhotoButton.unbind().click(function(){
            $photoFileInput.click();
        });
        $myVideoDelete.unbind().click(function(){
            var $myVideo = libs.memoryGet('my-video') ? libs.memoryGet('my-video') : false;
            try {
                $myVideo.destroy();
            } catch (e) {

            }
            $videoRoot = '';
            $myVideoButton.show();
            $myVideoDelete.hide();
        });
        $myVideoFileInput.unbind().change(function(){
            if(this.files && this.files[0]){
                var $formData = new FormData();
                $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                $formData.append('user_id', libs.memoryGet('user_id'));
                $formData.append('tab', $tab);
                $formData.append('key', $params.key);
                $formData.append('action', 'previewVideo');
                $formData.append('video', this.files[0]);
                nurseslounge_lounge_overview.information_administrator_tab_request_files($formData, function($data){
                    $videoRoot = $data.data.video_root;
                    nurseslounge_lounge_overview.information_administrator_tab_multimedia_videos('myVideo', $data.data);
                });
            }
        });
        $myVideoButton.unbind().click(function(){
            $myVideoFileInput.click();
        });
        $youtubeVideo.unbind().on('keypress keyup keydown blur', function(){
            var $text =  $(this).val();
            try{
                clearTimeout($urlBindind);
            }catch(e){

            }
            $urlBindind = setTimeout(function(){
                nurseslounge_lounge_overview.information_administrator_tab_multimedia_videos('youtubeVideoOrVimeo', {video_url:$text});
            }, 1500);
        });
        $form.unbind().on('submit', function($e){
            $e.preventDefault();
            var $formData = new FormData();
            $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
            $formData.append('user_id', libs.memoryGet('user_id'));
            $formData.append('tab', $tab);
            $formData.append('key', $params.key);
            $formData.append('action', $action);
            if($logoFileInput[0].files[0]){
                $formData.append('logo', $logoFileInput[0].files[0]);
            }
            if($photoFileInput[0].files[0]){
                $formData.append('photo', $photoFileInput[0].files[0]);
            }
            $formData.append('youtube_video', $youtubeVideo.val());
            $formData.append('my_video', $videoRoot);
            nurseslounge_lounge_overview.information_administrator_tab_request_files($formData, function($data){
                if($data.status == 'success') {
                    $(".nav.nav-underline [data-id='overview']").click();
                    libs.refreshBoxFrom(".top-nav-menu", $params, function () {
                        $("#nurseslounge-lounge .nav-underline a:eq(0)").addClass('active');
                        nurseslounge_lounge_header.followers($params);
                        libs.refreshBoxFrom(".page-contents", $params, function () {
                            nurseslounge_lounge.submenu($params, function(){
                                nurseslounge_lounge_overview.init($params, function($data){
                                    nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                                });
                            });
                        });
                    });
                }else{
                    $modal.modal('hide');
                }
            });
        });
        if ($lounge.video_url) {
            nurseslounge_lounge_overview.information_administrator_tab_multimedia_videos('youtubeVideoOrVimeo', $lounge);
        }
        if ($lounge.video_root_lounge) {
            nurseslounge_lounge_overview.information_administrator_tab_multimedia_videos('myVideo', $lounge);
        }
        if($lounge.video_url) {
            $youtubeVideo.val($lounge.video_url);
        }
        if($lounge.video_root) {
            $videoRoot = libs.isEmptyReturnNull($lounge.video_root) != null ? $lounge.video_root : '';
        }
        if($lounge.logo_root_lounge) {
            $multimedia.find('.logo').attr('src', $lounge.logo_root_lounge);
        }
        if($lounge.photo_root_lounge) {
            $multimedia.find('.photo').attr('src', $lounge.photo_root_lounge);
        }
        libs.checkImageLoad($multimedia.find('img'), function () {
            if (cback != undefined) {
                cback();
            }
        });
    },
    information_administrator_tab_multimedia_videos:function($type, $lounge){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $multimedia = $modal.find(".lounge-information-modal-container #multimedia .container");
        var $youtubeVideo = $multimedia.find('.youtube-video:first');
        var $myVideo = $multimedia.find('.my-video:first');
        var $myVideoDelete = $multimedia.find('.delete-my-video');
        var $myVideoButton = $multimedia.find('.update-my-video');
        var $youtubePlayer;
        switch($type){
            case 'youtubeVideoOrVimeo':
                var $vimeoRegex = new RegExp ('(vimeo)','gi');
                var $youtubeRegex = new RegExp ('(youtube)','gi');
                $youtubePlayer = libs.memoryGet('youtube-video') ? libs.memoryGet('youtube-video') : false;
                try {
                    $youtubePlayer.destroy();
                } catch (e) {

                }
                if($lounge.video_url && $lounge.video_url != '' && $lounge.video_url.match($vimeoRegex)){
                    var $url = $lounge.video_url.split('/');
                    var $vimeoId = $url[$url.length - 1];
                    var $vimeoPlayer = new Vimeo.Player($youtubeVideo[0], {
                        id:$vimeoId,
                        height: 360,
                        loop: false,
                        autoplay:true,
                        muted:true
                    });
                }
                if($lounge.video_url && $lounge.video_url != '' && $lounge.video_url.match($youtubeRegex)){
                    var $url = new URL($lounge.video_url);
                    window.YT.ready(function() {
                        $youtubePlayer = new YT.Player($youtubeVideo[0], {
                            height: '360',
                            width: '100%',
                            videoId: $url.searchParams.get('v'),
                            events: {
                                'onReady': function () {
                                    $youtubePlayer.mute();
                                    $youtubePlayer.playVideo();
                                },
                                'onError': function () {
                                    $youtubeVideo.hide();
                                }
                            }
                        });
                    });
                }
                libs.memorySave('youtube-video', $youtubePlayer);
            break;
            case 'myVideo':
                var $myPlayer = libs.memoryGet('my-video') ? libs.memoryGet('my-video') : false;
                try {
                    $myPlayer.destroy();
                } catch (e) {

                }
                $myPlayer = new Artplayer({
                    width: '100%',
                    height: '360px',
                    destroy:true,
                    container: $myVideo[0],
                    title: $lounge.name,
                    url: $lounge.video_root_lounge,
                    mutex: true,
                    muted:true,
                    play: true,
                    controls: [
                        {
                            position: 'right',
                            html: 'Fullscreen',
                            click: function() {
                                nurseslounge_lounge_overview.information_location_video_fullscreen($myPlayer, $lounge, false);
                            },
                        },
                    ],
                    moreVideoAttr: {
                        crossOrigin: 'anonymous'
                    }
                }).on('ready', function() {
                    $myPlayer.player.pause = true;
                    $myPlayer.player.play = true;
                    $myVideoButton.hide();
                    $myVideoDelete.show();
                }).on('pause', function(){
                    $myPlayer.mask.show = false;
                });
                libs.memorySave('my-video', $myPlayer);
            break;
        }
    },
    information_administrator_tab_request_files:function($formData, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/set',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_request:function($params, cback){
        $.ajax({
            url: "/lounge/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_administrator_tab_virtual_tour:function($action, $tab, $allowTabs, $params, $data, cback){
        var $virtualTourTitle = $data.data && $data.data.lounge && $data.data.lounge.virtual_tour ? $data.data.lounge.virtual_tour : null;
        var $virtualTourRootLounge = $data.data && $data.data.lounge && $data.data.lounge.virtual_tour_root_lounge ? $data.data.lounge.virtual_tour_root_lounge : null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $virtualTour = $modal.find(".lounge-information-modal-container #virtualTour .container");
        var $virtualTourWidget = $virtualTour.find('.virtualTour');
        var $updateImage = $virtualTour.find(".update-my-image");
        var $deleteImage = $virtualTour.find(".delete");
        var $title = $virtualTour.find("input[name='title']");
        var $file = $virtualTour.find("input[name='file']");
        $deleteImage.hide();
        if($virtualTourTitle && $virtualTourRootLounge) {
            $title.val($virtualTourTitle);
            $virtualTourWidget.html('').promise().done(function () {
                $virtualTourWidget.append('' +
                    '<room active="1" name="tour" title="' + $virtualTourTitle + '" src="' + $virtualTourRootLounge + '" width="2448" height="375" start="300"></room>')
                    .ready(function () {
                        $virtualTourWidget.panorama({
                            control_display: 'auto',
                            direction: 'left',
                            autostar: 1,
                            container: $('.virtualTourContainer'),
                            selectionEvent: function ($e, $start) {

                            }
                        });
                    });
            });
            $deleteImage.unbind().click(function(){
                nurseslounge_lounge_overview.information_administrator_tab_virtual_tour_delete($params, function(){
                    libs.refreshBoxFrom('.page-contents', $params, function(){
                        nurseslounge_lounge.submenu($params, function(){
                            nurseslounge_lounge_overview.init($params, function($data){
                                nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                            });
                        });
                    });
                });
            });
            $deleteImage.show();
        }
        $title.unbind().on('keyup keydown keypress',function(){
            $(".virtualTourContainer").find('.panorama-title').html($title.val());
        });
        $file.unbind().change(function(){
            var $reader = new FileReader();
            $reader.onload = function($e) {
                $virtualTourWidget.html('').append('' +
                    '<room active="1" name="tour" title="'+$title.val()+'" src="'+$e.target.result+'" width="2448" height="375" start="300"></room>')
                    .ready(function(){
                        $virtualTourWidget.panorama({
                            control_display: 'auto',
                            direction:'left',
                            autostar: 1,
                            container:$('.virtualTourContainer'),
                            selectionEvent:function($e, $start){

                            }
                        });
                    });
            };
            $reader.readAsDataURL(this.files[0]);
        });
        $updateImage.unbind().click(function(){
            $file.click();
        });
        nurseslounge_lounge_overview.information_administrator_tab_virtual_tour_validate(function($validator){
            if (!$file[0].files[0]) {
                $validator.showErrors({file: "Update a Panoramic Image"});
                return false;
            }
            var $formData = new FormData();
            $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
            $formData.append('user_id', $params.user_id);
            $formData.append('key', $params.key);
            $formData.append('title', $title.val());
            $formData.append('file', $file[0].files[0]);
            nurseslounge_lounge_overview.information_administrator_tab_virtual_tour_request($formData, function($data){
                libs.refreshBoxFrom('.page-contents', $params, function(){
                    nurseslounge_lounge.submenu($params, function(){
                        nurseslounge_lounge_overview.init($params, function($data){
                            nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, cback);
                        });
                    });
                });
            });
        });
        cback();
    },
    information_administrator_tab_virtual_tour_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-lounge-information-edit-modal .lounge-information-modal-container #virtualTour .container form").validate();
            $validator.destroy();
        } catch (e) {

        }
        $validator = $("#nurseslounge-lounge-information-edit-modal .lounge-information-modal-container #virtualTour .container form").validate({
            onsubmit: true,
            debug: true,
            rules: {
                title: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                file: {
                    required: false
                }
            },
            messages: {
                title: {
                    required: "The title is required",
                    minlength: "The title must have at least 3 characters",
                    maxlength: "The title cannot exceed 191 characters"
                },
                file: {
                    required: "The image is not required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function ($form) {
                cback($validator);
                return false;
            }
        });
    },
    information_administrator_tab_virtual_tour_request: function ($data, cback) {
        $.ajax({
            url: "/lounge/virualTour/update",
            type: "POST",
            cache: false,
            contentType: false,
            processData: false,
            data: $data,
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    cback();
                }
            }
        });
    },
    information_administrator_tab_virtual_tour_delete:function($params, cback){
        $.ajax({
            url: "/lounge/virualTour/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_administrator_tab_recruiters:function($action, $tab, $allowTabs, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $recruiters = $modal.find(".lounge-information-modal-container #recruiters .container");
        var $datatableSearchButton = $recruiters.find('.search');
        var $datatableFollowers = $recruiters.find('.datatable-followers');
        var $datatableRecruiters = $recruiters.find('.datatable-recruiters');
        var $datatableSearch = $recruiters.find("input[name='search']");
        var $datatableSearchBinding;
        nurseslounge_lounge_overview.information_administrator_tab_datatable(
            $datatableFollowers,
            "/lounge/followersRecruiters/datatable",
            "POST",
            $params,
            function(){
                $datatableFollowers.find('.add').unbind().click(function(){
                    var $id = $(this).data('id');
                    $params = $.extend({},$params, {action:"add",id:$id,tab:'recruiters'});
                    nurseslounge_lounge_overview.information_administrator_tab_recruiters_events($params, function($data){
                        if($data.status == 'success') {
                            libs.refreshBoxFrom(".page-contents", $params, function () {
                                nurseslounge_lounge.submenu($params, function(){
                                    nurseslounge_lounge_overview.init($params, function($data){
                                        dataTable.reload($datatableFollowers);
                                        dataTable.reload($datatableRecruiters);
                                    });
                                });
                            });
                        }
                    });
                });
            },function($nRow){
                return $nRow;
            }, function($datatableFollowersTable){
                nurseslounge_lounge_overview.information_administrator_tab_datatable(
                    $datatableRecruiters,
                    "/lounge/recruiters/datatable",
                    "POST",
                    $params,
                    function(){
                        $datatableRecruiters.find('.delete').unbind().click(function(){
                            var $id = $(this).data('id');
                            $params = $.extend({},$params, {action:"delete",id:$id,tab:'recruiters'});
                            nurseslounge_lounge_overview.information_administrator_tab_recruiters_events($params, function($data){
                                if($data.status == 'success'){
                                    libs.refreshBoxFrom(".page-contents", $params, function () {
                                        nurseslounge_lounge.submenu($params, function(){
                                            nurseslounge_lounge_overview.init($params, function($data){
                                                dataTable.reload($datatableFollowers);
                                                dataTable.reload($datatableRecruiters);
                                            });
                                        });
                                    });
                                }
                            });
                        });
                    },function($nRow){
                        return $nRow;
                    }, function($datatableRecruitersTable){
                        $datatableSearchButton.unbind().click(function () {
                            $datatableFollowersTable.search($datatableSearch.val());
                            $datatableRecruitersTable.search($datatableSearch.val());
                            $datatableFollowersTable.draw();
                            $datatableRecruitersTable.draw();
                        });
                        $datatableSearch.unbind().on('keypress keyup keydown blur', function () {
                            try{
                                clearTimeout($datatableSearchBinding);
                            }catch (e) {

                            }
                            $datatableSearchBinding = setTimeout(function(){
                                $datatableFollowersTable.search($datatableSearch.val());
                                $datatableRecruitersTable.search($datatableSearch.val());
                                $datatableFollowersTable.draw();
                                $datatableRecruitersTable.draw();
                            }, 1000);
                        });
                        if(cback != undefined){
                            cback();
                        }
                    });
                });
    },
    information_administrator_tab_recruiters_events:function($params, cback){
        $.ajax({
            url: "/lounge/recruiters/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_administrator_tab_owners:function($action, $tab, $allowTabs, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $owners = $modal.find(".lounge-information-modal-container #owners .container");
        var $datatableSearchButton = $owners.find('.search');
        var $datatableFollowers = $owners.find('.datatable-followers');
        var $datatableOwners = $owners.find('.datatable-owners');
        var $datatableSearch = $owners.find("input[name='search']");
        var $datatableSearchBinding;
        nurseslounge_lounge_overview.information_administrator_tab_datatable(
            $datatableFollowers,
            "/lounge/followersOwners/datatable",
            "POST",
            $params,
            function(){
                $datatableFollowers.find('.add').unbind().click(function(){
                    var $id = $(this).data('id');
                    $params = $.extend({},$params, {action:"add",id:$id,tab:'owners'});
                    nurseslounge_lounge_overview.information_administrator_tab_owners_events($params, function($data){
                        if($data.status == 'success') {
                            libs.refreshBoxFrom(".page-contents", $params, function () {
                                nurseslounge_lounge.submenu($params, function(){
                                    nurseslounge_lounge_overview.init($params, function($data){
                                        dataTable.reload($datatableFollowers);
                                        dataTable.reload($datatableOwners);
                                    });
                                });
                            });
                        }
                    });
                });
            },function($nRow){
                return $nRow;
            }, function($datatableFollowersTable){
                nurseslounge_lounge_overview.information_administrator_tab_datatable(
                    $datatableOwners,
                    "/lounge/owners/datatable",
                    "POST",
                    $params,
                    function(){
                        $datatableOwners.find('.delete').unbind().click(function(){
                            var $id = $(this).data('id');
                            $params = $.extend({},$params, {action:"delete",id:$id,tab:'owners'});
                            nurseslounge_lounge_overview.information_administrator_tab_owners_events($params, function($data){
                                if($data.status == 'success') {
                                    libs.refreshBoxFrom(".page-contents", $params, function () {
                                        nurseslounge_lounge.submenu($params, function(){
                                            nurseslounge_lounge_overview.init($params, function($data){
                                                dataTable.reload($datatableFollowers);
                                                dataTable.reload($datatableOwners);
                                            });
                                        });
                                    });
                                }
                            });
                        });
                    },function($nRow){
                        return $nRow;
                    }, function($datatableOwnersTable){
                        $datatableSearchButton.unbind().click(function () {
                            $datatableFollowersTable.search($datatableSearch.val());
                            $datatableOwnersTable.search($datatableSearch.val());
                            $datatableFollowersTable.draw();
                            $datatableOwnersTable.draw();
                        });
                        $datatableSearch.unbind().on('keypress keyup keydown blur', function () {
                            try{
                                clearTimeout($datatableSearchBinding);
                            }catch (e) {

                            }
                            $datatableSearchBinding = setTimeout(function(){
                                $datatableFollowersTable.search($datatableSearch.val());
                                $datatableOwnersTable.search($datatableSearch.val());
                                $datatableFollowersTable.draw();
                                $datatableOwnersTable.draw();
                            }, 1000);
                        });
                        if(cback != undefined){
                            cback();
                        }
                    });
            });
    },
    information_administrator_tab_owners_events:function($params, cback){
        $.ajax({
            url: "/lounge/owners/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    //Datatable for recruiters and owners
    information_administrator_tab_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $table = $($element).DataTable({
            "dom":  "<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "iDisplayLength": 3,
            "aLengthMenu": [[3],[3]],
            "sPaginationType": "full_numbers",
            "bInfo": false,
            "bLengthChange": false,
            "autoWidth": false,
            "responsive": true,
            "bDestroy": true,
            "cache": false,
            "pageLength": 3,
            "pagingType" : "full_numbers",
            "searching": true,
            "processing": true,
            "stateSave": false,
            "serverSide": true,
            "initComplete": function () {
                initComplete($table);
            },
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "ajax": {
                "data":$data,
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },

    information_administrator_tab_jobs:function($action, $tab, $params, $data, cback){
        nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_control_form($data, $params, function(){
            nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_graph_form($params, function(){
                nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_table_form($action, $params, $data, function(){
                    cback();
                });
            });
        });
    },
    information_administrator_tab_jobs_payment_control_form:function($data, $params, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $controlForm = $jobs.find("form[name='control-form']");
        var $buyMoreClicks = $controlForm.find(".buy-more-clicks");
        var $autoChargeToggleWrapper = $controlForm.find(".autocharge-toggle-wrapper");
        var $stripeForm = $jobs.find("form[name='stripe-form']");
        var $paymentFormWrapper = $stripeForm.find(".payment-form-wrapper");
        $buyMoreClicks.unbind().click(function(){
            var $that = $(this);
            if(!$paymentFormWrapper.is(':visible')){
                nurseslounge_lounge_overview.information_administrator_tab_jobs_stripe($params, function(){
                    $paymentFormWrapper.show();
                    $autoChargeToggleWrapper.hide();
                    $that.html('Close Payment Form');
                });
            }else{
                $paymentFormWrapper.hide();
                $autoChargeToggleWrapper.show();
                $that.html('Buy More Clicks');
            }
        });
        var $autoChargeToggle = $controlForm.find("#autochargeToggle");
        $autoChargeToggle.unbind().change(function(){
            var $that = $(this);
            var $autocharge = $that.is(':checked') == true ? 1 : 0;
            var $newParams = $.extend({}, $params, {autocharge:$autocharge});
            nurseslounge_lounge_overview.information_administrator_tab_jobs_autopayment_request($newParams, function($data){
                if($data.data.autocharge == 1){
                    if(!$controlForm.find('#autochargeToggle').is(':checked')){
                        $controlForm.find('#autochargeToggle').prop('checked', true);
                    }
                    if(!$stripeForm.find('#autocharge').is(':checked')){
                        $stripeForm.find('#autocharge').prop('checked', true);
                    }
                }else{
                    if($controlForm.find('#autochargeToggle').is(':checked')){
                        $controlForm.find('#autochargeToggle').prop('checked', false);
                    }
                    if($stripeForm.find('#autocharge').is(':checked')){
                        $stripeForm.find('#autocharge').prop('checked', false);
                    }
                }
            });
        });
        if($data.data.lounge.lounge_type_id == 1 || $data.data.lounge.lounge_type_id == 2){
            $autoChargeToggleWrapper.show();
            $buyMoreClicks.show();
        }
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_jobs_autopayment_request:function($params, cback){
        $.ajax({
            url: "/lounge/jobs/autopayment",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_jobs_stripe:function($params, cback){
        try{
            var $cardSaved = libs.memoryGet('nurseslounge_lounge_overview_card');
            if($cardSaved){
                $cardSaved.destroy();
            }
        }catch ($e){

        }
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $stripeForm = $jobs.find("form[name='stripe-form']");
        var $controlForm = $jobs.find("form[name='control-form']");
        var $buyMoreClicks = $controlForm.find(".buy-more-clicks");
        var $autoChargeToggleWrapper = $controlForm.find(".autocharge-toggle-wrapper");
        var $inputClicks = $stripeForm.find('input[name="clicks"]');
        var $clicksAmount = $stripeForm.find('.clicks-amount');
        var $paymentFormWrapper = $stripeForm.find('.payment-form-wrapper');
        var $onProgressWrapper = $stripeForm.find('.on-progress-checkmark-wrapper');
        var $successWrapper = $stripeForm.find('.success-checkmark-wrapper');
        var $btnContinue = $stripeForm.find('.continue');
        var $submitButton = $stripeForm.find('button[type="submit"]');
        $paymentFormWrapper.show();
        $successWrapper.hide();
        $onProgressWrapper.hide();
        $submitButton.prop('disabled', false);
        $inputClicks.unbind().change(function(){
            $clicksAmount.html('clicks = $'+($inputClicks.val() * 3)+'.00');
        });
        var $card = stripe.elements();
        var $style = {
            base: {
                'lineHeight': '1.5',
                'fontSize': '1.09em',
                'color': '#00184A',
                'fontFamily': "sans-serif",
                'height':'100%',
                'fontWeight':'100',
                'opacity': '0.9',
                '::placeholder': {
                    'color':'#636c72',
                    'opacity':'0.9'
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            },
        };
        var $cardDom = $stripeForm.find('.card:first')[0];
        var $cardEle = $card.create('card', {style:$style});
        $cardEle.mount($cardDom);
        libs.memorySave('nurseslounge_lounge_overview_card', $cardEle);
        nurseslounge_lounge_overview.information_administrator_tab_jobs_stripe_validate(function($form){
            var $objForm = libs.getObjForm($form);
            $buyMoreClicks.prop('disabled', true);
            $submitButton.prop('disabled', true);
            $paymentFormWrapper.hide();
            $onProgressWrapper.show();
            stripe.createToken($cardEle, {
                name:$objForm.name,
                address_country:'US',
                currency:'usd'
            }).then(function($res) {
                if($res.token && $res.token.id){
                    var $newParams = $.extend({}, $objForm, $res, $params, {
                        autocharge:$stripeForm.find('#autocharge').is(':checked') == true ? 1 : 0
                    });
                    nurseslounge_lounge_overview.information_administrator_tab_jobs_stripe_request($newParams, function($data){
                        if($data.status == 'success'){
                            $paymentFormWrapper.hide();
                            $onProgressWrapper.hide();
                            $successWrapper.show();
                            $btnContinue.unbind().click(function(){
                                $stripeForm[0].reset();
                                $inputClicks.change();
                                $buyMoreClicks.html('Buy More Clicks');
                                $buyMoreClicks.prop('disabled', false);
                                $successWrapper.hide();
                                $autoChargeToggleWrapper.show();
                                if($data.data.autocharge == 1){
                                    if(!$controlForm.find('#autochargeToggle').is(':checked')){
                                        $controlForm.find('#autochargeToggle').prop('checked', true);
                                    }
                                    if(!$stripeForm.find('#autocharge').is(':checked')){
                                        $stripeForm.find('#autocharge').prop('checked', true);
                                    }
                                }else{
                                    if($controlForm.find('#autochargeToggle').is(':checked')){
                                        $controlForm.find('#autochargeToggle').prop('checked', false);
                                    }
                                    if($stripeForm.find('#autocharge').is(':checked')){
                                        $stripeForm.find('#autocharge').prop('checked', false);
                                    }
                                }
                                nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_graph_form($params);
                            });
                        }else{
                            var $validator = $stripeForm.validate();
                            $validator.showErrors({"card": $data.data.msg});
                            $stripeForm.find("input[name='card']").val('');
                            $submitButton.prop('disabled', false);
                            $buyMoreClicks.prop('disabled', false);
                            $onProgressWrapper.hide();
                            $paymentFormWrapper.show();
                        }
                    });
                }else{
                    $submitButton.prop('disabled', false);
                    $buyMoreClicks.prop('disabled', false);
                    $onProgressWrapper.hide();
                    $paymentFormWrapper.show();
                }
            });
        });
        $cardEle.on('change', function($e){
            if(!$e.complete && $e.error && $e.error.message){
                var $validator = $stripeForm.validate();
                $validator.showErrors({"card": $e.error.message});
                $stripeForm.find("input[name='card']").val('');
                $stripeForm.find('.invalid-feedback').hide();
                $stripeForm.find('.error').removeClass('error');
                $stripeForm.find('.is-invalid').removeClass('is-invalid');
            }else{
                $stripeForm.find("input[name='card']").val('complete');
            }
        });
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_jobs_stripe_validate:function(cback){
        $.validator.addMethod('minStrict', function ($val, $el, $par) {
            return $val > $par;
        });
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $stripeForm = $jobs.find("form[name='stripe-form']")
        var $validator;
        try {
            $validator = $stripeForm.validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $stripeForm.validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                clicks: {
                    required: true,
                    minStrict: 99,
                    number: true
                },
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                },
                card: {
                    required: true
                }
            },
            messages: {
                clicks:{
                    required: "The clicks is required",
                    minStrict:"The clicks should be greater than 99",
                    number: "The clicks should be a number"
                },
                name:{
                    required: "The name is required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                card:{
                    required: "The card is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_administrator_tab_jobs_stripe_request:function($params, cback){
        $.ajax({
            url: "/lounge/jobs/payment",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_jobs_payment_graph_form:function($params, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $graphForm = $jobs.find("form[name='graph-form']");
        var $graphType = $graphForm.find("select[name='graphType']");
        var $filterFromDate = $graphForm.find(".filter_from_date:first");
        var $resetFromDate = $graphForm.find(".reset_from_date:first");
        var $filterToDate = $graphForm.find(".filter_to_date:first");
        var $resetToDate = $graphForm.find(".reset_to_date:first");
        var $createJob = $graphForm.find(".create-job");
        $graphType.unbind().change(function(){
            nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics($params);
        });
        $filterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
            nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics($params);
        });
        $filterToDate.datepicker('clearDates').on('changeDate', function ($e) {
            nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics($params);
        });
        $resetFromDate.unbind().click(function(){
            $filterFromDate.val("").datepicker("update");
            nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics($params);
        });
        $resetToDate.unbind().click(function(){
            $filterToDate.val("").datepicker("update");
            nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics($params);
        });
        $createJob.unbind().click(function(){
            $modal.modal('hide');
            nurseslounge_job_jobDetail.information_request_select_tab('create', 'job_information', {
                'job_information':  true,
                'job_location': true
            }, $params, function () {
                $("#nurseslounge-job-information-edit-modal").scrollTop(0);
                $("#nurseslounge-job-information-edit-modal").modal('show');
            });
        });
        var $today = new Date();
        var $firstDay =  new Date($today.getFullYear(), $today.getMonth(), 1);
        $firstDay = String($firstDay.getDate()).padStart(2, '0');
        var $lastDay =  new Date($today.getFullYear(), $today.getMonth() + 1, 0);
        $lastDay = String($lastDay.getDate()).padStart(2, '0');
        var $mm = String($today.getMonth() + 1).padStart(2, '0');
        var $yyyy = $today.getFullYear();
        $filterFromDate.val($mm+'/'+$firstDay+'/'+$yyyy).datepicker("update");
        $filterToDate.val($mm+'/'+$lastDay+'/'+$yyyy).datepicker("update");
        nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics($params);
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_jobs_payment_statistics:function($params){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $graphForm = $jobs.find("form[name='graph-form']");
        var $graphType = $graphForm.find("select[name='graphType']");
        var $filterFromDate = $graphForm.find(".filter_from_date:first");
        var $filterToDate = $graphForm.find(".filter_to_date:first");
        var $sqOne = $graphForm.find(".sq-one");
        var $sqOneText = $graphForm.find(".sq-one-text");
        var $sqOneVal = $graphForm.find(".sq-one-val");
        var $sqTwo = $graphForm.find(".sq-two");
        var $sqTwoText = $graphForm.find(".sq-two-text");
        var $sqTwoVal = $graphForm.find(".sq-two-val");
        var $sqThree = $graphForm.find(".sq-three");
        var $sqThreeText = $graphForm.find(".sq-three-text");
        var $sqThreeVal = $graphForm.find(".sq-three-val");
        var $sqFour = $graphForm.find(".sq-four");
        var $sqFourText = $graphForm.find(".sq-four-text");
        var $sqFourVal = $graphForm.find(".sq-four-val");
        var $morrisConfig;
        $params = $.extend({}, $params,
            {
                filter_from_date:$filterFromDate.val(),
                filter_to_date:$filterToDate.val(),
            }
        );
        nurseslounge_lounge_overview.information_administrator_tab_jobs_payment_statistics_request($params, function($data) {
            if($data.data.one_txt != ''){
                $sqOne.show();
            }else{
                $sqOne.hide();
            }
            $sqOneText.html($data.data.one_txt);
            $sqOneVal.html($data.data.one_val);
            if($data.data.two_txt != ''){
                $sqTwo.show();
            }else{
                $sqTwo.hide();
            }
            $sqTwoText.html($data.data.two_txt);
            $sqTwoVal.html($data.data.two_val);
            if($data.data.three_txt != ''){
                $sqThree.show();
            }else{
                $sqThree.hide();
            }
            $sqThreeText.html($data.data.three_txt);
            $sqThreeVal.html($data.data.three_val);
            if($data.data.four_txt != ''){
                $sqFour.show();
            }else{
                $sqFour.hide();
            }
            $sqFourText.html($data.data.four_txt);
            $sqFourVal.html($data.data.four_val);
            try {
                $("#nurseslounge-lounge-information-jobs-statistics-graph").empty();
            } catch (e) {

            }
            var $lineColors = ['gray', 'red', 'blue'];
            for(var $s = 0; $s < $data.data.ykeys.length; $s++){
                var $randomColor = '#'+Math.floor(Math.random()*16777215).toString(16);
                $lineColors.push($randomColor);
            }
            $morrisConfig = {
                data: $data.data.graph,
                element: 'nurseslounge-lounge-information-jobs-statistics-graph',
                xkey: 'date',
                ykeys: $data.data.ykeys,
                xLabelAngle: 45,
                parseTime: false,
                labels: $data.data.labels,
                fillOpacity: 0.6,
                hideHover: 'auto',
                behaveLikeLine: true,
                resize: true,
                pointFillColors: ['#ffffff'],
                pointStrokeColors: ['black'],
                lineColors: $lineColors
            };
            $graphType = $graphType.val();
            nurseslounge_lounge_overview.morris_graph_type($graphType, $morrisConfig)
        });
    },
    morris_graph_type:function($graphType, $morrisConfig){
        switch ($graphType) {
            case 'area':
                new Morris.Area($morrisConfig);
                break;
            case 'line':
                new Morris.Line($morrisConfig);
                break;
            case 'bar':
                new Morris.Bar($morrisConfig);
                break;
            case 'tower':
                $morrisConfig.stacked = true;
                new Morris.Bar($morrisConfig);
                break;
        }
    },
    information_administrator_tab_jobs_payment_statistics_request:function($params, cback){
        $.ajax({
            url: "/lounge/jobs/payment/statistics",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_jobs_payment_table_form:function($action, $params, $data, cback){
        var $jobsCount = $data.data.jobs_count;
        var $jobsVisitsCount = $data.data.jobs_visits_count;
        var $jobsApplicationsCount = $data.data.jobs_applications_count;
        var $jobsRequestsInfoCount = $data.data.jobs_requests_info_count;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $tableForm = $jobs.find("form[name='table-form']");
        var $datatableJobs = $tableForm.find(".datatable-jobs");
        var $datatableSearchButton = $tableForm.find(".search");
        var $datatableSearch = $tableForm.find("input[name='search']");
        var $datatableSearchBinding;
        var $totalSpan = $tableForm.find(".total");
        var $visitsSpan = $tableForm.find(".visits");
        var $applicationsSpan = $tableForm.find(".applications");
        var $requestsInfoSpan = $tableForm.find(".request-info");
        var $filterFromDate = $tableForm.find(".filter_from_date:first");
        var $filterToDate = $tableForm.find(".filter_to_date:first");
        var $resetFromDate = $tableForm.find(".reset_from_date:first");
        var $resetToDate = $tableForm.find(".reset_to_date:first");
        var $selectAll = $tableForm.find("input[name='selectAll']");
        var $selectAction = $tableForm.find(".action");
        nurseslounge_lounge_overview.information_administrator_tab_jobs_datatable(
            $datatableJobs,
            "/lounge/jobs/datatable",
            "POST",
            $params,
            function($table){
                $datatableJobs.find('.view').unbind().click(function(){
                    var $link = $(this).data('link');
                    window.open($link, '_blank', '');
                });
                $selectAll.unbind().click(function(){
                    if($selectAll.is(':checked')){
                        $datatableJobs.find('.selectRow').prop('checked', true);
                    }else{
                        $datatableJobs.find('.selectRow').prop('checked', false);
                    }
                });
                if($selectAll.is(':checked')){
                    $selectAll.prop('checked', false);
                }
                $selectAction.unbind().change(function(){
                    var $selectedRows = [];
                    $datatableJobs.find('.selectRow').each(function(){
                        var $that = $(this);
                        if($that.is(':checked')){
                            $selectedRows.push($that.data('id'));
                        }
                    });
                    if($selectAction.val() != '') {
                        $params = $.extend({},$params, {selected_rows: $selectedRows, selected_action: $selectAction.val()});
                        nurseslounge_lounge_overview.information_administrator_tab_jobs_actions($params, function () {
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                $totalSpan.html($data.data.jobs_count);
                                $visitsSpan.html($data.data.jobs_visits_count);
                                $applicationsSpan.html($data.data.jobs_applications_count);
                                $requestsInfoSpan.html($data.data.jobs_requests_info_count);
                                dataTable.reload($datatableJobs);
                            });
                        });
                    }
                });
                $selectAction.val('');
            },function($nRow){
                return $nRow;
            }, function($table){
                $datatableSearchButton.unbind().click(function () {
                    $table.search($datatableSearch.val());
                    $table.draw();
                });
                $datatableSearch.unbind().on('keypress keyup keydown blur', function () {
                    try{
                        clearTimeout($datatableSearchBinding);
                    }catch (e) {

                    }
                    $datatableSearchBinding = setTimeout(function(){
                        $table.search($datatableSearch.val());
                        $table.draw();
                    }, 1000);
                });
                $filterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
                    dataTable.reload($datatableJobs);
                });
                $filterToDate.datepicker('clearDates').on('changeDate', function ($e) {
                    dataTable.reload($datatableJobs);
                });
                $resetFromDate.unbind().click(function(){
                    $filterFromDate.val("").datepicker("update");
                    dataTable.reload($datatableJobs);
                });
                $resetToDate.unbind().click(function(){
                    $filterToDate.val("").datepicker("update");
                    dataTable.reload($datatableJobs);
                });
                $totalSpan.html($jobsCount);
                $visitsSpan.html($jobsVisitsCount);
                $applicationsSpan.html($jobsApplicationsCount);
                $requestsInfoSpan.html($jobsRequestsInfoCount).promise().done(function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
    },
    information_administrator_tab_jobs_actions:function($params, cback){
        $.ajax({
            url: "/lounge/jobs/action",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_jobs_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $jobs = $modal.find(".lounge-information-modal-container #jobs .container");
        var $tableForm = $jobs.find("form[name='table-form']");
        var $filterFromDate = $tableForm.find(".filter_from_date:first");
        var $filterToDate = $tableForm.find(".filter_to_date:first");
        var $table = $($element).DataTable({
            "order": [[1,"desc"]],
            "dom":"<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sScrollXInner": "auto",
            "bScrollCollapse": true,
            "bAutoWidth": true,
            "responsive": false,
            "scrollX": true,
            "paging": true,
            "bDestroy": true,
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "initComplete": function () {
                initComplete($table);
            },
            "cache": false,
            "pageLength": 10,
            "pagingType" : "full_numbers",
            "processing": true,
            "serverSide": true,
            "stateSave": true,
            "ajax": {
                "data":function ($d) {
                    return $.extend($d, $data, {filter_from_date: $filterFromDate.val()}, {filter_to_date: $filterToDate.val()});
                },
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },

    information_administrator_tab_degrees:function($action, $tab, $params, $data, cback){
        var $degreesCount = $data.data.degrees_count;
        var $degreesVisitsCount = $data.data.degrees_visits_count;
        var $degreesApplicationsCount = $data.data.degrees_applications_count;
        var $degreesRequestsInfoCount = $data.data.degrees_requests_info_count;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $degrees = $modal.find(".lounge-information-modal-container #degrees .container");
        var $datatableApplications = $degrees.find(".datatable-degrees");
        var $datatableSearchButton = $degrees.find(".search");
        var $datatableSearch = $degrees.find("input[name='search']");
        var $datatableSearchBinding;
        var $totalSpan = $degrees.find(".total");
        var $visitsSpan = $degrees.find(".visits");
        var $applicationsSpan = $degrees.find(".applications");
        var $requestsInfoSpan = $degrees.find(".request-info");
        var $filterFromDate = $degrees.find(".filter_from_date:first");
        var $filterToDate = $degrees.find(".filter_to_date:first");
        var $resetFromDate = $degrees.find(".reset_from_date:first");
        var $resetToDate = $degrees.find(".reset_to_date:first");
        var $selectAll = $degrees.find("input[name='selectAll']");
        var $selectAction = $degrees.find(".action");
        var $createDegree = $degrees.find(".create-degree");
        nurseslounge_lounge_overview.information_administrator_tab_degrees_datatable(
            $datatableApplications,
            "/lounge/degrees/datatable",
            "POST",
            $params,
            function($table){
                $datatableApplications.find('.view').unbind().click(function(){
                    var $link = $(this).data('link');
                    window.open($link, '_blank', '');
                });
                $selectAll.unbind().click(function(){
                    if($selectAll.is(':checked')){
                        $datatableApplications.find('.selectRow').attr('checked', true).prop('checked',true);
                    }else{
                        $datatableApplications.find('.selectRow').attr('checked', false).prop('checked',false);
                    }
                });
                if($selectAll.is(':checked')){
                    $selectAll.attr('checked', false).prop('checked',false);
                }
                $selectAction.unbind().change(function(){
                    var $selectedRows = [];
                    $datatableApplications.find('.selectRow').each(function(){
                        var $that = $(this);
                        if($that.is(':checked')){
                            $selectedRows.push($that.data('id'));
                        }
                    });
                    if($selectAction.val() != '') {
                        $params = $.extend({},$params, {selected_rows: $selectedRows, selected_action: $selectAction.val()});
                        nurseslounge_lounge_overview.information_administrator_tab_degrees_actions($params, function () {
                            nurseslounge_lounge_overview.information_lounge_get($action, $params, function($data) {
                                $totalSpan.html($data.data.degrees_count);
                                $visitsSpan.html($data.data.degrees_visits_count);
                                $applicationsSpan.html($data.data.degrees_applications_count);
                                $requestsInfoSpan.html($data.data.degrees_requests_info_count);
                                dataTable.reload($datatableApplications);
                                if($selectAll.is(':checked')){
                                    $selectAll.attr('checked', false).prop('checked',false);
                                }
                                $selectAction.val('');
                            });
                        });
                    }
                });
                $selectAction.val('');
            },function($nRow){
                return $nRow;
            }, function($table){
                $datatableSearchButton.unbind().click(function () {
                    $table.search($datatableSearch.val());
                    $table.draw();
                });
                $datatableSearch.unbind().on('keypress keyup keydown blur', function () {
                    try{
                        clearTimeout($datatableSearchBinding);
                    }catch (e) {

                    }
                    $datatableSearchBinding = setTimeout(function(){
                        $table.search($datatableSearch.val());
                        $table.draw();
                    }, 1000);
                });
                $filterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
                    dataTable.reload($datatableApplications);
                });
                $filterToDate.datepicker('clearDates').on('changeDate', function ($e) {
                    dataTable.reload($datatableApplications);
                });
                $resetFromDate.unbind().click(function(){
                    $filterFromDate.val("").datepicker("update");
                    dataTable.reload($datatableApplications);
                });
                $resetToDate.unbind().click(function(){
                    $filterToDate.val("").datepicker("update");
                    dataTable.reload($datatableApplications);
                });
                $totalSpan.html($degreesCount);
                $visitsSpan.html($degreesVisitsCount);
                $applicationsSpan.html($degreesApplicationsCount);
                $requestsInfoSpan.html($degreesRequestsInfoCount).promise().done(function(){
                    $createDegree.unbind().click(function(){
                        $modal.modal('hide');
                        nurseslounge_degree_information.information_request_select_tab('create', 'degree_information', {
                            'degree_information':  true,
                            'degree_sponsor': true
                        }, $params, function () {
                            $("#nurseslounge-degree-information-edit-modal").scrollTop(0);
                            $("#nurseslounge-degree-information-edit-modal").modal('show');
                        });
                    });
                    if(cback != undefined){
                        cback();
                    }
                });
            });
    },
    information_administrator_tab_degrees_actions:function($params, cback){
        $.ajax({
            url: "/lounge/degrees/action",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_degrees_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $degrees = $modal.find(".lounge-information-modal-container #degrees .container");
        var $filterFromDate = $degrees.find(".filter_from_date:first");
        var $filterToDate = $degrees.find(".filter_to_date:first");
        var $table = $($element).DataTable({
            "order": [[6,"desc"]],
            "dom":"<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sScrollXInner": "auto",
            "bScrollCollapse": true,
            "bAutoWidth": true,
            "responsive": false,
            "scrollX": true,
            "paging": true,
            "bDestroy": true,
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "initComplete": function () {
                initComplete($table);
            },
            "cache": false,
            "pageLength": 10,
            "pagingType" : "full_numbers",
            "processing": true,
            "serverSide": true,
            "stateSave": true,
            "ajax": {
                "data":function ($d) {
                    return $.extend($d, $data, {filter_from_date: $filterFromDate.val()}, {filter_to_date: $filterToDate.val()});
                },
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },

    information_administrator_tab_import:function($action, $tab, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $import = $modal.find(".lounge-information-modal-container #import .container");
        var $wizard = $import.find(".wizard");
        var $importDashboard = $wizard.find('#importDashboard');
        $params = $.extend({},$params, {action:$action,tab:'import'});
        libs.memorySave('import-wizard', $params);
        $wizard.smartWizard({
            selected: 0,
            theme: 'arrows',
            justified: true,
            autoAdjustHeight: false,
            backButtonSupport: false,
            cycleSteps: false,
            enableURLhash: false,
            keyboardSettings: {
                keyNavigation: false
            },
            anchorSettings: {
                anchorClickable: false,
                enableAllAnchors: false,
                markDoneStep: false,
                markAllPreviousStepsAsDone: false,
                removeDoneStepOnNavigateBack: false,
                enableAnchorOnDoneStep: false
            },
            toolbarSettings: {
                showNextButton: false,
                showPreviousButton: false
            }
        }).on("stepContent", function($e, $anchorObject, $stepIndex, $stepDirection) {
            if($stepIndex == null){
                $stepIndex = 0;
            }
            libs.memoryUpdateObj('import-wizard', {step_index:($stepIndex+1)});
            return new Promise(function($resolve, $reject){
                nurseslounge_lounge_overview.information_administrator_tab_wizard($wizard, function($data) {
                    $resolve($data);
                });
            });
        }).on("showStep", function($e, $anchorObject, $stepIndex, $stepDirection) {
            if($stepDirection == 'forward' && $stepIndex != null){
                $stepIndex = ($stepIndex + 2);
            }
            if($stepIndex == null){
                $stepIndex = 1;
            }
            nurseslounge_lounge_overview.information_administrator_tab_import_events($stepIndex, $params, $wizard);
        });
        libs.memoryUpdateObj('import-wizard', {step_index:1});
        nurseslounge_lounge_overview.information_administrator_tab_wizard($wizard, function($data){
            $importDashboard.html($data).promise().done(function(){
                nurseslounge_lounge_overview.information_administrator_tab_import_events(1, $params, $wizard, function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
        });
    },
    information_administrator_tab_wizard:function($wizard, cback){
        $.ajax({
            url: "/lounge/import/wizard",
            method: "POST",
            cache:false,
            dataType: "html",
            data:libs.memoryGet('import-wizard'),
            beforeSend: function($xhr) {
                $wizard.smartWizard("loader", "show");
            },
            success: function ($data) {
                libs.expire($data);
                $wizard.smartWizard("loader", "hide");
                cback($data);
            }
        });
    },
    information_administrator_tab_import_events:function($index, $params, $wizard, cback){
        var $importWizard = libs.memoryGet('import-wizard');
        switch ($index) {
            case 1:
                var $importDashboard = $wizard.find('#importDashboard');
                var $xmlFeedType = $wizard.find('#importDashboard select[name="xml_feed_type"]');
                var $datatableXmlFeedHistory = $wizard.find('#importDashboard .datatable-xml-feed-history:first');
                var $deleteButton = $wizard.find('#importDashboard .delete:first');
                $xmlFeedType.unbind().change(function(){
                    libs.memoryUpdateObj('import-wizard', {xml_feed_type_id:$xmlFeedType.val()});
                    $wizard.smartWizard("next");
                });
                nurseslounge_lounge_overview.information_administrator_tab_import_history_datatable(
                    $datatableXmlFeedHistory,
                    "/lounge/import/datatable",
                    "POST",
                    $params,
                    function(){
                    },function($nRow){
                        return $nRow;
                    }, function($datatableRecruitersTable) {
                });
                nurseslounge_lounge_overview.information_administrator_tab_import_events_xml_feed_history_tables($datatableXmlFeedHistory);
                $deleteButton.unbind().click(function(){
                    if(confirm("Delete this configuration")) {
                        nurseslounge_lounge_overview.information_administrator_tab_import_dashboard_get(function () {
                            libs.memorySave('import-wizard', $params);
                            libs.memoryUpdateObj('import-wizard', {step_index: 1});
                            nurseslounge_lounge_overview.information_administrator_tab_wizard($wizard, function ($data) {
                                $importDashboard.html($data).promise().done(function () {
                                    nurseslounge_lounge_overview.information_administrator_tab_import_events(1, $params, $wizard);
                                });
                            });
                        });
                    }
                });
            break;
            case 2:
                $importWizard = libs.memoryGet('import-wizard');
                var $backButton = $wizard.find('#source .back:first');
                var $analyzeButton = $wizard.find('#source .analyze:first');
                var $xmlFeedFile = $wizard.find('#source input[name="xmlFeedFile"]');
                var $updateXmlFeedButton = $wizard.find('#source .updateXmlFeed:first');
                if($importWizard.xml_feed_type_id == 1){
                    $analyzeButton.unbind().click(function(){
                        libs.memoryUpdateObj('import-wizard', {xml_feed_url:$wizard.find('#source input[name="link"]').val()});
                        $wizard.smartWizard("next");
                    });
                }
                if($importWizard.xml_feed_type_id == 2){
                    $xmlFeedFile.unbind().change(function(){
                        var $that = $(this);
                        nurseslounge_lounge_overview.information_administrator_tab_import_source_update_file($that, $importWizard, function($data){
                            if($data.status == 'success'){
                                libs.memoryUpdateObj('import-wizard', $data.data);
                                $wizard.smartWizard("next");
                            }
                        });
                    });
                    $updateXmlFeedButton.unbind().click(function() {
                        $xmlFeedFile.click();
                    });
                }
                if($importWizard.xml_feed_type_id == 3){
                    nurseslounge_lounge_overview.information_administrator_tab_import_ftp_validate(function($form){
                        var $formObj = libs.getObjForm($form);
                        libs.memoryUpdateObj('import-wizard', $formObj);
                        $wizard.smartWizard("next");
                    });
                }
                $backButton.unbind().click(function(){
                    $wizard.smartWizard("prev");
                });
            break;
            case 3:
                var $labelsFields = $wizard.find('#analyze .labels-fields:first');
                var $commandsDiv = $wizard.find('#analyze .commands:first');
                var $refreshXmlFeed = $wizard.find('#analyze .refresh-xml-feed:first');
                var $deleteXmlFeed = $wizard.find('#analyze .delete-xml-feed:first');
                var $backButton = $wizard.find('#analyze .back:first');
                var $autoconfigurationXmlFeed = $wizard.find('#analyze .autoconfiguration-xml-feed:first');
                var $xmlFeedPeriod = $wizard.find('#analyze select[name="xmlFeedPeriod"]');
                var $monthlyWrapper = $wizard.find('#analyze .xmlFeed_period_monthly_wrapper');
                var $weeklyWrapper = $wizard.find('#analyze .xmlFeed_period_weekly_wrapper');
                var $startAtWrapper = $wizard.find('#analyze .xml_feed_start_at_wrapper');
                var $startAtContainer = $wizard.find('#analyze #xml_feed_start_at_container');
                var $xmlFeedTz = $wizard.find('#analyze select[name="xmlFeedTz"]');
                var $xmlFeedStartAtTimeWrapper = $wizard.find('#analyze .xml_feed_start_at_time_wrapper');
                var $xmlFeedPeriodWeekly = $wizard.find('#analyze input[name="xmlFeedPeriodWeekly"]');
                var $weeklyDays = $wizard.find('#analyze .weekly_days');
                $monthlyWrapper.hide();
                $weeklyWrapper.hide();
                $startAtWrapper.hide();
                $refreshXmlFeed.unbind().click(function(){
                    nurseslounge_lounge_overview.information_administrator_tab_import_analyze_get(function ($data) {
                        var $status = $data.status;
                        if($status == 'error'){
                            $wizard.smartWizard("prev");
                        }else{
                            var $xmlFeed = $data.data.xml_feed;
                            libs.memoryUpdateObj('import-wizard', {root:$xmlFeed.root});
                            var $input = {
                                "options":{
                                    "associationMode": "oneToOne",
                                    "lineStyle":"square-ends"
                                },
                                "Lists": [
                                    {
                                        "name": "XmlFeed",
                                        "list": $xmlFeed.labels_availables
                                    },
                                    {
                                        "name": "NL Database",
                                        "list": $xmlFeed.job_labels
                                    }
                                ],
                                "existingLinks" : $xmlFeed.set_labels
                            };
                            $labelsFields.fieldsLinker("init",$input);
                            $commandsDiv.html(nurseslounge_lounge_overview.information_administrator_tab_import_map_commands_html($xmlFeed.map)).promise().done(function(){});
                        }
                    });
                });
                $deleteXmlFeed.unbind().click(function(){
                    nurseslounge_lounge_overview.information_administrator_tab_import_analyze_delete(function($data){
                        $refreshXmlFeed.click();
                    });
                });
                $backButton.unbind().click(function(){
                    $wizard.smartWizard("prev");
                });
                $autoconfigurationXmlFeed.unbind().click(function(){
                    var $map = $labelsFields.fieldsLinker("getLinks");
                    var $stripTags = [
                        'Job Id',
                        'Job Title',
                        'Job Signing Bonus',
                        'Job Education Level',
                        'Job Years of Experience',
                        'Job Listing Type Number',
                        'Job Employer Type Number',
                        'Job Shift',
                        'Job Shift Length',
                        'Job Schedule',
                        'Job Compensation',
                        //'Job Description',
                        'Job Email Or Url',
                        'Employer Name',
                        'Facility Name',
                        'Facility Address City',
                        'Facility Address State',
                        'Facility Address Street',
                        'Facility Address Zip Code'
                    ];
                    var $dateParse = [
                        'Job Date Posted'
                    ];
                    $.each($map.links, function($i, $v){
                        var $input = $commandsDiv.find("input[name='"+$v.from+"']");
                        if($.inArray($v.to, $stripTags) !== -1 && $input.val() == ''){
                            $input.val('=>stripTags');
                        }
                        if($.inArray($v.to, $dateParse) !== -1 && $input.val() == ''){
                            $input.val('=>dateParse');
                        }
                    });
                });
                $weeklyDays.unbind().change(function(){
                    var $weeklySelectedDays = [];
                    $weeklyDays.each(function(){
                        var $that = $(this);
                        var $val = $that.data('value');
                        if($that.prop('checked')){
                            $weeklySelectedDays.push($val);
                        }
                    });
                    $xmlFeedPeriodWeekly.val($weeklySelectedDays.join(','));
                });
                var $xmlFeedPeriodWeeklyVal = $xmlFeedPeriodWeekly.val();
                if($xmlFeedPeriodWeeklyVal != ''){
                    var $xmlFeedPeriodWeeklyDays = $xmlFeedPeriodWeeklyVal.split(',');
                    $weeklyDays.prop('checked', false);
                    $.each($xmlFeedPeriodWeeklyDays, function($i, $v){
                        $wizard.find("#analyze .weekly_days[data-value='"+$v+"']").prop('checked', true);
                    });
                }else{
                    $weeklyDays.prop('checked', false);
                }
                $xmlFeedTz.unbind().change(function(){
                    var $that = $(this);
                    var $val = $that.val();
                    if($val != ''){
                        var $now = moment().tz($val);
                        $startAtContainer.remove();
                        $xmlFeedStartAtTimeWrapper.html('' +
                            '<div class="input-group date" id="xml_feed_start_at_container" data-target-input="nearest" data-value="">' +
                            '   <input type="text" name="xmlFeedStartAt" class="form-control datetimepicker-input validate" data-target="#xml_feed_start_at_container">' +
                            '   <div class="input-group-append" data-target="#xml_feed_start_at_container" data-toggle="datetimepicker">' +
                            '       <div class="input-group-text">' +
                            '           <i class="fa fa-clock-o"></i>' +
                            '       </div>' +
                            '   </div>' +
                            '</div>').promise().done(function(){
                            $startAtContainer = $wizard.find('#analyze #xml_feed_start_at_container');
                            $startAtContainer.datetimepicker({
                                defaultDate: $now,
                                format: 'LT',
                            });
                        });
                    }
                });
                var $xmlFeedTzVal = $xmlFeedTz.val();
                if($xmlFeedTzVal != ''){
                    var $val = $startAtContainer.data('value');
                    var $utc = moment.utc($val, 'H:mm A')
                    var $now = $utc.tz($xmlFeedTzVal);
                    $startAtContainer.datetimepicker({
                        defaultDate: $now,
                        format: 'LT'
                    });
                }else{
                    var $timezone = moment.tz.guess();
                    $xmlFeedTz.val($timezone);

                    var $now = moment();
                    $startAtContainer.datetimepicker({
                        defaultDate: $now,
                        format: 'LT',
                    });
                }
                $xmlFeedPeriod.unbind().change(function(){
                    var $that = $(this);
                    var $val = $that.val();
                    switch($val){
                        case 'manually':
                            $monthlyWrapper.hide();
                            $weeklyWrapper.hide();
                            $startAtWrapper.hide();
                            break;
                        case 'daily':
                            $monthlyWrapper.hide();
                            $weeklyWrapper.hide();
                            $startAtWrapper.show();
                            break;
                        case 'monthly':
                            $monthlyWrapper.show();
                            $weeklyWrapper.hide();
                            $startAtWrapper.show();
                            break;
                        case 'weekly':
                            $monthlyWrapper.hide();
                            $weeklyWrapper.show();
                            $startAtWrapper.show();
                            break;
                    }
                });
                var $xmlFeedPeriodVal = $xmlFeedPeriod.val();
                switch($xmlFeedPeriodVal){
                    case 'manually':
                        $monthlyWrapper.hide();
                        $weeklyWrapper.hide();
                        $startAtWrapper.hide();
                        break;
                    case 'daily':
                        $monthlyWrapper.hide();
                        $weeklyWrapper.hide();
                        $startAtWrapper.show();
                        break;
                    case 'monthly':
                        $monthlyWrapper.show();
                        $weeklyWrapper.hide();
                        $startAtWrapper.show();
                        break;
                    case 'weekly':
                        $monthlyWrapper.hide();
                        $weeklyWrapper.show();
                        $startAtWrapper.show();
                        break;
                }
                nurseslounge_lounge_overview.information_administrator_tab_import_analyze_validate(function($validator, $form){
                    var $map = {links:{}};
                    try{
                        $map = $labelsFields.fieldsLinker("getLinks");
                    }catch(e){
                    }
                    var $form = libs.getObjForm($form);
                    var $xmlFeedDeleteBeforeUpdate = $form.xmlFeedDeleteBeforeUpdate;
                    var $xmlFeedDefaultListingTypeId = $form.xmlFeedDefaultListingTypeId;
                    var $xmlFeedDefaultEmployerTypeId = $form.xmlFeedDefaultEmployerTypeId;
                    var $xmlFeedPeriod = $form.xmlFeedPeriod;
                    var $xmlFeedPeriodMonthly = $form.xmlFeedPeriodMonthly;
                    var $xmlFeedPeriodWeekly = $form.xmlFeedPeriodWeekly;
                    var $xmlFeedTz = $form.xmlFeedTz;
                    var $xmlFeedStartAt = $form.xmlFeedStartAt;

                    delete $form.xmlFeedDeleteBeforeUpdate;
                    delete $form.xmlFeedDefaultListingTypeId;
                    delete $form.xmlFeedDefaultEmployerTypeId;
                    delete $form.xmlFeedPeriod;
                    delete $form.xmlFeedPeriodMonthly;
                    delete $form.xmlFeedPeriodWeekly;
                    delete $form.xmlFeedTz;
                    delete $form.xmlFeedStartAt;
                    if($map.links.length == 0){
                        $validator.showErrors({
                            "labelFields": "The links relation are required"
                        });
                    }else{
                        libs.memoryUpdateObj('import-wizard', {
                            map:{},
                            commands:{},
                            xmlFeedDeleteBeforeUpdate:null,
                            xmlFeedDefaultListingTypeId:null,
                            xmlFeedDefaultEmployerTypeId:null,
                            xmlFeedPeriod:null,
                            xmlFeedPeriodMonthly:null,
                            xmlFeedPeriodWeekly:null,
                            xmlFeedTz:null,
                            xmlFeedStartAt:null,
                        });
                        libs.memoryUpdateObj('import-wizard', {
                            map:$map,
                            commands:$form,
                            xmlFeedDeleteBeforeUpdate:$xmlFeedDeleteBeforeUpdate,
                            xmlFeedDefaultListingTypeId:$xmlFeedDefaultListingTypeId,
                            xmlFeedDefaultEmployerTypeId:$xmlFeedDefaultEmployerTypeId,
                            xmlFeedPeriod:$xmlFeedPeriod,
                            xmlFeedPeriodMonthly:$xmlFeedPeriodMonthly,
                            xmlFeedPeriodWeekly:$xmlFeedPeriodWeekly,
                            xmlFeedTz:$xmlFeedTz,
                            xmlFeedStartAt:$xmlFeedStartAt,
                        });
                        $wizard.smartWizard("next");
                    }
                });
                $refreshXmlFeed.click();
            break;
            case 4:
                var $importDashboard = $wizard.find('#importDashboard');
                var $datatableXmlFeedHistory = $wizard.find('#execute .datatable-xml-feed-history:first');
                var $runButton = $wizard.find('#execute .run:first');
                var $initButton = $wizard.find('#execute .init:first');
                var $backButton = $wizard.find('#execute .back:first');
                var $progressBarFirst = $wizard.find('#execute .progress-bar:first');
                nurseslounge_lounge_overview.information_administrator_tab_import_history_datatable(
                    $datatableXmlFeedHistory,
                    "/lounge/import/datatable",
                    "POST",
                    $params,
                    function(){
                    },function($nRow){
                        return $nRow;
                    }, function($datatableRecruitersTable) {
                });
                nurseslounge_lounge_overview.information_administrator_tab_import_events_xml_feed_history_tables($datatableXmlFeedHistory);
                $runButton.unbind().click(function(){
                    $progressBarFirst.show();
                    $runButton.hide();
                    libs.memoryUpdateObj('import-wizard', {progress_bar:true});
                    nurseslounge_lounge_overview.information_administrator_tab_import_execute_progress($wizard);
                    nurseslounge_lounge_overview.information_administrator_tab_import_execute(function(){
                        libs.memoryUpdateObj('import-wizard', {progress_bar:false});
                        dataTable.reload($datatableXmlFeedHistory);
                        $runButton.show();
                        $progressBarFirst.hide();
                    });
                });
                $initButton.unbind().click(function(){
                    $wizard.smartWizard("reset");
                });
                $backButton.unbind().click(function(){
                    $wizard.smartWizard("prev");
                });
            break;
        }
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_import_events_xml_feed_history_tables:function($datatableXmlFeedHistory){
        var $reloadXmlFeedHistoryBinding;
        dataTable.reload($datatableXmlFeedHistory);
        $reloadXmlFeedHistoryBinding = setTimeout(function(){
            if($("a[data-target='#import']").hasClass('active')){
                nurseslounge_lounge_overview.information_administrator_tab_import_events_xml_feed_history_tables($datatableXmlFeedHistory);
            }else{
                try{
                    clearTimeout($reloadXmlFeedHistoryBinding);
                }catch ($e){

                }
            }
        }, 5000);
    },
    information_administrator_tab_import_history_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $table = $($element).DataTable({
            "order": [[0,"desc"]],
            "dom":  "<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sPaginationType": "full_numbers",
            "bInfo": true,
            "bLengthChange": true,
            "autoWidth": false,
            "responsive": true,
            "bDestroy": true,
            "cache": false,
            "pagingType" : "full_numbers",
            "searching": false,
            "processing": true,
            "stateSave": false,
            "serverSide": true,
            "initComplete": function () {
                initComplete($table);
            },
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "ajax": {
                "data":$data,
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },
    information_administrator_tab_import_dashboard_get:function(cback){
        $.ajax({
            url: "/lounge/import/dashboard/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('import-wizard'),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    information_administrator_tab_import_source_update_file:function($fileInput, $params, cback){
        var $formData = new FormData();
        $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
        $formData.append('file', $fileInput[0].files[0]);
        $formData.append('key', $params.key);
        $formData.append('user_id', $params.user_id);
        $formData.append('xml_feed_type_id', $params.xml_feed_type_id);
        $formData.append('step_index', $params.step_index);
        $formData.append('tab', 'import');
        $.ajax({
            type: 'POST',
            url: '/lounge/import/source/update',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_import_ftp_validate:function(cback){
        var $validator;
        try {
            $validator = $("#source form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#source form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                ftpProtocol: {
                    required: true
                },
                ftpHost: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                ftpPort: {
                    required: false,
                    minlength: 3,
                    maxlength: 8
                },
                ftpUser: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                ftpPassword: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                ftpFile: {
                    required: true,
                    minlength: 3,
                    maxlength: 600
                }
            },
            messages: {
                ftpProtocol:{
                    required: "The protocol is required"
                },
                ftpHost: {
                    required: "The host is required",
                    minlength: "The host must have at least 3 characters",
                    maxlength: "The host cannot exceed 600 characters"
                },
                ftpPort: {
                    required: "The port is not required",
                    minlength: "The port must have at least 2 characters",
                    maxlength: "The port cannot exceed 8 characters"
                },
                ftpUser: {
                    required: "The user is not required",
                    minlength: "The user must have at least 3 characters",
                    maxlength: "The user cannot exceed 600 characters"
                },
                ftpPassword: {
                    required: "The password is not required",
                    minlength: "The password must have at least 3 characters",
                    maxlength: "The password cannot exceed 600 characters"
                },
                ftpFile: {
                    required: "The file is required",
                    minlength: "The file must have at least 3 characters",
                    maxlength: "The file cannot exceed 600 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_administrator_tab_import_analyze_get:function(cback){
        $.ajax({
            url: "/lounge/import/analyze/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('import-wizard'),
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_import_analyze_delete:function(cback){
        $.ajax({
            url: "/lounge/import/analyze/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('import-wizard'),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    information_administrator_tab_import_analyze_validate:function(cback){
        var $validator;
        try {
            $validator = $("#analyze form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#analyze form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                xmlFeedDeleteBeforeUpdate: {
                    required: true
                },
                xmlFeedDefaultListingTypeId: {
                    required: true
                },
                xmlFeedDefaultEmployerTypeId: {
                    required: true
                },
                xmlFeedPeriod:{
                    required: true
                },
                xmlFeedPeriodMonthly:{
                    required: function(){
                        var $val = $("#analyze form select[name='xmlFeedPeriod']").val();
                        return $val == 'monthly';
                    }
                },
                xmlFeedPeriodWeekly: {
                    required: function(){
                        var $val = $("#analyze form select[name='xmlFeedPeriod']").val();
                        return $val == 'weekly';
                    }
                },
                xmlFeedTz:{
                    required: function(){
                        var $val = $("#analyze form select[name='xmlFeedPeriod']").val();
                        return $val != 'manually';
                    }
                },
                xmlFeedStartAt:{
                    required: function(){
                        var $val = $("#analyze form select[name='xmlFeedPeriod']").val();
                        return $val != 'manually';
                    }
                },
                labelFields:{
                    required: false
                }
            },
            messages: {
                xmlFeedDeleteBeforeUpdate:{
                    required: "The default Update Type is required"
                },
                xmlFeedDefaultListingTypeId:{
                    required: "The default Listing Type is required"
                },
                xmlFeedDefaultEmployerTypeId: {
                    required: "The default Employer Type is required"
                },
                xmlFeedPeriod:{
                    required: "The period is required"
                },
                xmlFeedPeriodMonthly:{
                    required: "The monthly day is required"
                },
                xmlFeedPeriodWeekly:{
                    required: "The weekly days are required"
                },
                xmlFeedTz:{
                    required: "The timezone is required"
                },
                xmlFeedStartAt:{
                    required: "The start time is required"
                },
                labelFields: {
                    required: "The links relation are required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($validator, $form);
                return false;
            }
        });
    },
    information_administrator_tab_import_map_commands_html:function($data){
        var $chtml = '' +
            '<div class="col-12">';
        $($data).each(function($i, $v){
            var $command = libs.isEmptyReturnNull($v.filter_command) == null ? '' : $v.filter_command;
            $chtml += '' +
                '<div class="row">' +
                '    <div class="col-6 text-left">' +
                '        <label>'+$v.label+'</label>' +
                '    </div>' +
                '    <div class="col-6 text-left">' +
                '        <input type="text" name="'+$v.label+'" class="form-control" value="'+$command+'">' +
                '    </div>' +
                '</div>';
        });
        $chtml +='' +
            '</div>';
        return $chtml;
    },
    information_administrator_tab_import_execute:function(cback){
        $.ajax({
            url: "/lounge/import/execute",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('import-wizard'),
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_import_execute_progress:function($wizard){
        var $progressBarFirst = $wizard.find('#execute .progress-bar:first');
        var $importWizard = libs.memoryGet('import-wizard');
        $.ajax({
            url: "/lounge/import/execute/progress",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$importWizard,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success' && $importWizard.progress_bar){
                    $progressBarFirst.html($data.data.progress_percent+'%').promise().done(function(){
                        $progressBarFirst.attr('aria-valuenow', $data.data.progress_percent);
                        $progressBarFirst.width($data.data.progress_percent+'%');
                        setTimeout(function(){
                            nurseslounge_lounge_overview.information_administrator_tab_import_execute_progress($wizard);
                        }, 2500);
                    });
                }
            }
        });
    },

    information_administrator_tab_api:function($action, $tab, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $import = $modal.find(".lounge-information-modal-container #api .container");
        var $wizard = $import.find(".wizard");
        var $apiDashboard = $wizard.find('#apiDashboard');
        $params = $.extend({},$params, {action:$action,tab:'api'});
        libs.memorySave('api-wizard', $params);
        $wizard.smartWizard({
            selected: 0,
            theme: 'arrows',
            justified: true,
            autoAdjustHeight: false,
            backButtonSupport: false,
            cycleSteps: false,
            enableURLhash: false,
            keyboardSettings: {
                keyNavigation: false
            },
            anchorSettings: {
                anchorClickable: false,
                enableAllAnchors: false,
                markDoneStep: false,
                markAllPreviousStepsAsDone: false,
                removeDoneStepOnNavigateBack: false,
                enableAnchorOnDoneStep: false
            },
            toolbarSettings: {
                showNextButton: false,
                showPreviousButton: false
            }
        }).on("stepContent", function($e, $anchorObject, $stepIndex, $stepDirection) {
            if($stepIndex == null){
                $stepIndex = 0;
            }
            libs.memoryUpdateObj('api-wizard', {step_index:($stepIndex+1)});
            return new Promise(function($resolve, $reject){
                nurseslounge_lounge_overview.information_administrator_tab_api_wizard($wizard, function($data) {
                    $resolve($data);
                });
            });
        }).on("showStep", function($e, $anchorObject, $stepIndex, $stepDirection) {
            if($stepDirection == 'forward' && $stepIndex != null){
                $stepIndex = ($stepIndex + 2);
            }
            if($stepIndex == null){
                $stepIndex = 1;
            }
            nurseslounge_lounge_overview.information_administrator_tab_api_events($stepIndex, $params, $wizard);
        });
        libs.memoryUpdateObj('api-wizard', {step_index:1});
        nurseslounge_lounge_overview.information_administrator_tab_api_wizard($wizard, function($data){
            $apiDashboard.html($data).promise().done(function(){
                nurseslounge_lounge_overview.information_administrator_tab_api_events(1, $params, $wizard, function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
        });
    },
    information_administrator_tab_api_wizard:function($wizard, cback){
        $.ajax({
            url: "/lounge/api/wizard",
            method: "POST",
            cache:false,
            dataType: "html",
            data:libs.memoryGet('api-wizard'),
            beforeSend: function($xhr) {
                $wizard.smartWizard("loader", "show");
            },
            success: function ($data) {
                libs.expire($data);
                $wizard.smartWizard("loader", "hide");
                cback($data);
            }
        });
    },
    information_administrator_tab_api_events:function($index, $params, $wizard, cback){
        var $importWizard = libs.memoryGet('import-wizard');
        switch ($index) {
            case 1:
                var $apiDashboard = $wizard.find('#apiDashboard');
                var $apiType = $wizard.find('#apiDashboard select[name="api_type"]');
                var $datatableApiHistory = $wizard.find('#apiDashboard .datatable-api-history:first');
                var $deleteButton = $wizard.find('#apiDashboard .delete:first');
                $apiType.unbind().change(function(){
                    libs.memoryUpdateObj('api-wizard', {api_type_id:$apiType.val()});
                    $wizard.smartWizard("next");
                });
                nurseslounge_lounge_overview.information_administrator_tab_api_history_datatable(
                    $datatableApiHistory,
                    "/lounge/api/datatable",
                    "POST",
                    $params,
                    function(){
                    },function($nRow){
                        return $nRow;
                    }, function($datatableRecruitersTable) {

                    });
                nurseslounge_lounge_overview.information_administrator_tab_api_events_api_history_tables($datatableApiHistory);
                $deleteButton.unbind().click(function(){
                    if(confirm("Delete this configuration")) {
                        nurseslounge_lounge_overview.information_administrator_tab_api_dashboard_get(function () {
                            libs.memorySave('api-wizard', $params);
                            libs.memoryUpdateObj('api-wizard', {step_index: 1});
                            nurseslounge_lounge_overview.information_administrator_tab_api_wizard($wizard, function ($data) {
                                $apiDashboard.html($data).promise().done(function () {
                                    nurseslounge_lounge_overview.information_administrator_tab_api_events(1, $params, $wizard);
                                });
                            });
                        });
                    }
                });
                break;
            case 2:
                $importWizard = libs.memoryGet('import-wizard');
                var $backButton = $wizard.find('#source .back:first');
                var $analyzeButton = $wizard.find('#source .analyze:first');
                var $apiPeriodWeekly = $wizard.find('#source input[name="apiPeriodWeekly"]');
                var $weeklyDays = $wizard.find('#source .weekly_days');
                var $apiTz = $wizard.find('#source select[name="apiTz"]');
                var $startAtContainer = $wizard.find('#source #api_start_at_container');
                var $apiStartAtTimeWrapper = $wizard.find('#source .api_start_at_time_wrapper');
                var $apiPeriod = $wizard.find('#source select[name="apiPeriod"]');
                var $monthlyWrapper = $wizard.find('#source .api_period_monthly_wrapper');
                var $weeklyWrapper = $wizard.find('#source .api_period_weekly_wrapper');
                var $startAtWrapper = $wizard.find('#source .api_start_at_wrapper');
                var $apiTypeId = $wizard.find('#source input[name="apiTypeId"]').val();


                $weeklyDays.unbind().change(function(){
                    var $weeklySelectedDays = [];
                    $weeklyDays.each(function(){
                        var $that = $(this);
                        var $val = $that.data('value');
                        if($that.prop('checked')){
                            $weeklySelectedDays.push($val);
                        }
                    });
                    $apiPeriodWeekly.val($weeklySelectedDays.join(','));
                });
                var $apiPeriodWeeklyVal = $apiPeriodWeekly.val();
                if($apiPeriodWeeklyVal != ''){
                    var $apiPeriodWeeklyDays = $apiPeriodWeeklyVal.split(',');
                    $weeklyDays.prop('checked', false);
                    $.each($apiPeriodWeeklyDays, function($i, $v){
                        $wizard.find("#source .weekly_days[data-value='"+$v+"']").prop('checked', true);
                    });
                }else{
                    $weeklyDays.prop('checked', false);
                }
                $apiTz.unbind().change(function(){
                    var $that = $(this);
                    var $val = $that.val();
                    if($val != ''){
                        var $now = moment().tz($val);
                        $startAtContainer.remove();
                        $apiStartAtTimeWrapper.html('' +
                            '<div class="input-group date" id="api_start_at_container" data-target-input="nearest" data-value="">' +
                            '   <input type="text" name="apiStartAt" class="form-control datetimepicker-input validate" data-target="#api_start_at_container">' +
                            '   <div class="input-group-append" data-target="#api_start_at_container" data-toggle="datetimepicker">' +
                            '       <div class="input-group-text">' +
                            '           <i class="fa fa-clock-o"></i>' +
                            '       </div>' +
                            '   </div>' +
                            '</div>').promise().done(function(){
                            $startAtContainer = $wizard.find('#source #api_start_at_container');
                            $startAtContainer.datetimepicker({
                                defaultDate: $now,
                                format: 'LT',
                            });
                        });
                    }
                });
                var $apiTzVal = $apiTz.val();
                if($apiTzVal != ''){
                    var $val = $startAtContainer.data('value');
                    var $utc = moment.utc($val, 'H:mm A')
                    var $now = $utc.tz($apiTzVal);
                    $startAtContainer.datetimepicker({
                        defaultDate: $now,
                        format: 'LT',
                    });
                }else{
                    var $timezone = moment.tz.guess();
                    $apiTz.val($timezone);

                    var $now = moment();
                    $startAtContainer.datetimepicker({
                        defaultDate: $now,
                        format: 'LT',
                    });
                }
                $apiPeriod.unbind().change(function(){
                    var $that = $(this);
                    var $val = $that.val();
                    switch($val){
                        case 'manually':
                            $monthlyWrapper.hide();
                            $weeklyWrapper.hide();
                            $startAtWrapper.hide();
                            break;
                        case 'daily':
                            $monthlyWrapper.hide();
                            $weeklyWrapper.hide();
                            $startAtWrapper.show();
                            break;
                        case 'monthly':
                            $monthlyWrapper.show();
                            $weeklyWrapper.hide();
                            $startAtWrapper.show();
                            break;
                        case 'weekly':
                            $monthlyWrapper.hide();
                            $weeklyWrapper.show();
                            $startAtWrapper.show();
                            break;
                    }
                });
                var $apiPeriodVal = $apiPeriod.val();
                switch($apiPeriodVal){
                    case 'manually':
                        $monthlyWrapper.hide();
                        $weeklyWrapper.hide();
                        $startAtWrapper.hide();
                        break;
                    case 'daily':
                        $monthlyWrapper.hide();
                        $weeklyWrapper.hide();
                        $startAtWrapper.show();
                        break;
                    case 'monthly':
                        $monthlyWrapper.show();
                        $weeklyWrapper.hide();
                        $startAtWrapper.show();
                        break;
                    case 'weekly':
                        $monthlyWrapper.hide();
                        $weeklyWrapper.show();
                        $startAtWrapper.show();
                        break;
                }

                nurseslounge_lounge_overview.information_administrator_tab_api_analyze_validate($apiTypeId, function($validator, $form){
                    var $form = libs.getObjForm($form);
                    libs.memoryUpdateObj('api-wizard', {
                        apiConfiguration:$form.apiConfiguration,
                        apiDefaultEmployerTypeId:$form.apiDefaultEmployerTypeId,
                        apiDefaultListingTypeId:$form.apiDefaultListingTypeId,
                        apiDeleteBeforeUpdate:$form.apiDeleteBeforeUpdate,
                        apiPeriod:$form.apiPeriod,
                        apiPeriodMonthly:$form.apiPeriodMonthly,
                        apiPeriodWeekly:$form.apiPeriodWeekly,
                        apiStartAt:$form.apiStartAt,
                        apiTypeId:$form.apiTypeId,
                        apiTz:$form.apiTz,
                        companyIdentifier:$form.companyIdentifier,
                    });
                    $wizard.smartWizard("next");
                });
                $backButton.unbind().click(function(){
                    $wizard.smartWizard("prev");
                });
                break;
            case 3:
                var $datatableApiHistory = $wizard.find('#execute .datatable-api-history:first');
                var $runButton = $wizard.find('#execute .run:first');
                var $initButton = $wizard.find('#execute .init:first');
                var $backButton = $wizard.find('#execute .back:first');
                var $progressBarFirst = $wizard.find('#execute .progress-bar:first');
                nurseslounge_lounge_overview.information_administrator_tab_api_history_datatable(
                    $datatableApiHistory,
                    "/lounge/api/datatable",
                    "POST",
                    $params,
                    function(){
                    },function($nRow){
                        return $nRow;
                    }, function($datatableRecruitersTable) {

                    });
                nurseslounge_lounge_overview.information_administrator_tab_api_events_api_history_tables($datatableApiHistory);
                $runButton.unbind().click(function(){
                    $progressBarFirst.show();
                    $runButton.hide();
                    libs.memoryUpdateObj('api-wizard', {progress_bar:true});
                    nurseslounge_lounge_overview.information_administrator_tab_api_execute_progress($wizard);
                    nurseslounge_lounge_overview.information_administrator_tab_api_execute(function(){
                        libs.memoryUpdateObj('api-wizard', {progress_bar:false});
                        dataTable.reload($datatableApiHistory);
                        $runButton.show();
                        $progressBarFirst.hide();
                    });
                });
                $initButton.unbind().click(function(){
                    $wizard.smartWizard("reset");
                });
                $backButton.unbind().click(function(){
                    $wizard.smartWizard("prev");
                });
                break;
        }
        if(cback != undefined){
            cback();
        }
    },
    information_administrator_tab_api_history_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $table = $($element).DataTable({
            "order": [[0,"desc"]],
            "dom":  "<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sPaginationType": "full_numbers",
            "bInfo": true,
            "bLengthChange": true,
            "autoWidth": false,
            "responsive": true,
            "bDestroy": true,
            "cache": false,
            "pagingType" : "full_numbers",
            "searching": false,
            "processing": true,
            "stateSave": false,
            "serverSide": true,
            "initComplete": function () {
                initComplete($table);
            },
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "ajax": {
                "data":$data,
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },
    information_administrator_tab_api_events_api_history_tables:function($datatableApiHistory){
        var $reloadApiHistoryBinding;
        dataTable.reload($datatableApiHistory);
        $reloadApiHistoryBinding = setTimeout(function(){
            if($("a[data-target='#api']").hasClass('active')){
                nurseslounge_lounge_overview.information_administrator_tab_api_events_api_history_tables($datatableApiHistory);
            }else{
                try{
                    clearTimeout($reloadApiHistoryBinding);
                }catch ($e){

                }
            }
        }, 5000);
    },
    information_administrator_tab_api_dashboard_get:function(cback){
        $.ajax({
            url: "/lounge/api/dashboard/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('api-wizard'),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    information_administrator_tab_api_analyze_validate:function($apiTypeId, cback){
        var $validator;
        try {
            $validator = $("#source form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#source form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                companyIdentifier:{
                    required: $apiTypeId == 1
                },
                apiConfiguration: {
                    required: true
                },
                apiDeleteBeforeUpdate: {
                    required: true
                },
                apiDefaultListingTypeId: {
                    required: true
                },
                apiDefaultEmployerTypeId: {
                    required: true
                },
                apiPeriod:{
                    required: true
                },
                apiPeriodMonthly:{
                    required: function(){
                        var $val = $("#source form select[name='apiPeriod']").val();
                        return $val == 'monthly';
                    }
                },
                apiPeriodWeekly: {
                    required: function(){
                        var $val = $("#source form select[name='apiPeriod']").val();
                        return $val == 'weekly';
                    }
                },
                apiTz:{
                    required: function(){
                        var $val = $("#source form select[name='apiPeriod']").val();
                        return $val != 'manually';
                    }
                },
                apiStartAt:{
                    required: function(){
                        var $val = $("#source form select[name='apiPeriod']").val();
                        return $val != 'manually';
                    }
                }
            },
            messages: {
                companyIdentifier:{
                    required: "The company identifier is required"
                },
                apiConfiguration:{
                    required: "The api configuration is required"
                },
                apiDeleteBeforeUpdate:{
                    required: "The default Update Type is required"
                },
                apiDefaultListingTypeId:{
                    required: "The default Listing Type is required"
                },
                apiDefaultEmployerTypeId: {
                    required: "The default Employer Type is required"
                },
                apiPeriod:{
                    required: "The period is required"
                },
                apiPeriodMonthly:{
                    required: "The monthly day is required"
                },
                apiPeriodWeekly:{
                    required: "The weekly days are required"
                },
                apiTz:{
                    required: "The timezone is required"
                },
                apiStartAt:{
                    required: "The start time is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($validator, $form);
                return false;
            }
        });
    },
    information_administrator_tab_api_execute:function(cback){
        $.ajax({
            url: "/lounge/api/execute",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('api-wizard'),
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_administrator_tab_api_execute_progress:function($wizard){
        var $progressBarFirst = $wizard.find('#execute .progress-bar:first');
        var $importWizard = libs.memoryGet('api-wizard');
        $.ajax({
            url: "/lounge/api/execute/progress",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$importWizard,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success' && $importWizard.progress_bar){
                    $progressBarFirst.html($data.data.progress_percent+'%').promise().done(function(){
                        $progressBarFirst.attr('aria-valuenow', $data.data.progress_percent);
                        $progressBarFirst.width($data.data.progress_percent+'%');
                        setTimeout(function(){
                            nurseslounge_lounge_overview.information_administrator_tab_api_execute_progress($wizard);
                        }, 2500);
                    });
                }
            }
        });
    },

    information_administrator_tab_statistics:function($action, $tab, $params, $data, cback){
        var $statisticReport = $("#statistics .statistic-report:first");
        var $days = $statisticReport.find('select[name="days"]');
        var $userId = libs.memoryGet('user_id');
        $days.unbind().change(function(){
            var $that = $(this);
            var $key = $that.data('key');
            var $days = $that.val();
            $params = $.extend({}, $params,
                {
                    user_id:$userId,
                    key:$key,
                    days:$days
                }
            );
            nurseslounge_lounge_overview.information_administrator_tab_statistics_request($params, function($chtml){
                $statisticReport.html($chtml).promise().done(function(){
                    nurseslounge_lounge_overview.information_administrator_tab_statistics($action, $tab, $params, $data, cback);
                });
            });
        });
        if(cback != undefined){
            cback();
        }
        /*
        var $graphSelection = $("#statistics select[name='graphSelection']");
        var $graphType = $("#statistics select[name='graphType']");
        var $acumulate = $("#statistics select[name='acumulate']");
        var $filterFromDate = $("#statistics .filter_from_date");
        var $resetFromDate = $("#statistics .reset_from_date");
        var $filterToDate = $("#statistics .filter_to_date");
        var $resetToDate = $("#statistics .reset_to_date");
        $graphSelection.unbind().change(function(){
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $graphType.unbind().change(function(){
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $acumulate.unbind().change(function(){
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $filterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $filterToDate.datepicker('clearDates').on('changeDate', function ($e) {
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $resetFromDate.unbind().click(function(){
            $filterFromDate.val("").datepicker("update");
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $resetToDate.unbind().click(function(){
            $filterToDate.val("").datepicker("update");
            nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        });
        $filterFromDate.val($data.data.this_month[0]);
        $filterToDate.val($data.data.this_month[1]);
        nurseslounge_lounge_overview.information_administrator_tab_statistics_event($params);
        if(cback != undefined){
            cback();
        }
         */
    },
    /*
    information_administrator_tab_statistics_event:function($params){
        var $graphSelection = $("#statistics select[name='graphSelection']");
        var $graphType = $("#statistics select[name='graphType']");
        var $acumulate = $("#statistics select[name='acumulate']");
        var $filterFromDate = $("#statistics .filter_from_date");
        var $filterToDate = $("#statistics .filter_to_date");
        var $sqOne = $("#statistics .sq-one");
        var $sqOneText = $("#statistics .sq-one-text");
        var $sqOneVal = $("#statistics .sq-one-val");
        var $sqTwo = $("#statistics .sq-two");
        var $sqTwoText = $("#statistics .sq-two-text");
        var $sqTwoVal = $("#statistics .sq-two-val");
        var $sqThree = $("#statistics .sq-three");
        var $sqThreeText = $("#statistics .sq-three-text");
        var $sqThreeVal = $("#statistics .sq-three-val");
        var $sqFour = $("#statistics .sq-four");
        var $sqFourText = $("#statistics .sq-four-text");
        var $sqFourVal = $("#statistics .sq-four-val");
        var $morrisConfig;
        $params = $.extend({},$params,
            {
                graph_selection:$graphSelection.val(),
                filter_from_date:$filterFromDate.val(),
                filter_to_date:$filterToDate.val(),
                acumulate:$acumulate.val()
                }
        );
        nurseslounge_lounge_overview.information_administrator_tab_statistics_request($params, function($data){
            if($data.data.one_txt != ''){
                $sqOne.show();
            }else{
                $sqOne.hide();
            }
            $sqOneText.html($data.data.one_txt);
            $sqOneVal.html($data.data.one_val);
            if($data.data.two_txt != ''){
                $sqTwo.show();
            }else{
                $sqTwo.hide();
            }
            $sqTwoText.html($data.data.two_txt);
            $sqTwoVal.html($data.data.two_val);
            if($data.data.three_txt != ''){
                $sqThree.show();
            }else{
                $sqThree.hide();
            }
            $sqThreeText.html($data.data.three_txt);
            $sqThreeVal.html($data.data.three_val);
            if($data.data.four_txt != ''){
                $sqFour.show();
            }else{
                $sqFour.hide();
            }
            $sqFourText.html($data.data.four_txt);
            $sqFourVal.html($data.data.four_val);
            try{
                $("#statistics-graph").empty();
            }catch (e) {

            }
            $morrisConfig = {
                data:$data.data.graph,
                element:'statistics-graph',
                xkey:'date',
                ykeys:$data.data.ykeys,
                xLabelAngle: 45,
                parseTime: false,
                labels:$data.data.labels,
                fillOpacity:0.6,
                hideHover:'auto',
                behaveLikeLine:true,
                resize:true,
                pointFillColors:['#ffffff'],
                pointStrokeColors: ['black'],
                lineColors:['gray','red']
            };
            switch($graphType.val()){
                case 'area':
                    new Morris.Area($morrisConfig);
                    break;
                case 'line':
                    new Morris.Line($morrisConfig);
                    break;
                case 'bar':
                    new Morris.Bar($morrisConfig);
                    break;
                case 'tower':
                    $morrisConfig.stacked = true;
                    new Morris.Bar($morrisConfig);
                    break;
            }
        });
    },
     */
    information_administrator_tab_statistics_request:function($params, cback){
        $.ajax({
            url: "/lounge/statistics/get",
            method: "POST",
            cache:false,
            dataType: "html",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_invite:function($action, $tab, $params, $data, cback){
        var $invite = $("#invite");
        var $invitationsInput = $invite.find("input[name='invitations']");
        var $checkInvitationButton = $invite.find(".check-invitations");
        var $updateInvitationsButton = $invite.find(".update-invitations");
        var $updateInvitationsButtonFile = $invite.find(".file-update-invitations");
        var $emailsDetected = $invite.find(".emails-detected");
        var $sendMassiveInvitations = $invite.find(".send-massive-invitations");
        var $sendInviteList = $invite.find(".send-invite-list");
        var $previousEmail = $invite.find(".previous-email");
        var $previousEmailSubject = $invite.find(".previous-email-subject");
        var $previousEmailContent = $invite.find(".previous-email-content");
        var $previousEmailWrapper = $invite.find(".preview-email-wrapper");
        var $multiEmail = $invitationsInput.unbind().multiEmail({
            delete: true,
            target:$sendInviteList,
            model:'' +
                '<li class="list-group-item bg-light item" data-email="@email">' +
                '    <a href="javascript:void(0)" class="float-right email-remove">' +
                '        <img src="/bimg/NursesLounge/x-circle.png">' +
                '    </a>' +
                '    <div class="col-12 float-left exist">' +
                '       <a href="@link" target="_blank">' +
                '           <button type="button" class="btn btn-save btnAnimate mt-2 w-100">' +
                '               <i class="fa fa-eye"></i>&nbsp;' +
                '               @email already has an account.' +
                '           </button>' +
                '       </a>' +
                '   </div>' +
                '    <div class="col-12 float-left not_exist">' +
                '       <button type="button" class="btn btn-save btnAnimate mt-2 email-send w-100">' +
                '           <i class="fa fa-send"></i>&nbsp;' +
                '           send invite to @email .' +
                '       </button>' +
                '   </div>' +
                '</li>',
            removeEle:'.email-remove',
            emailSend:'.email-send',
            ajax:{
                method:'POST',
                url:'/myDashboard/myProfile/invite/exist',
                data:{
                    user_id:libs.memoryGet('user_id')
                },
                dataType:'json'
            },
            callback:function($emails){
                nurseslounge_lounge_overview.information_tab_invite_invite($params, $emails, function(){
                    setTimeout(function(){
                        nurseslounge_lounge_overview.task_list_container(function($container){
                            $params = $.extend({}, $params, {only:'owners'});
                            nurseslounge_myDashboard_myProfile.task_list($container, $params);
                        });
                    }, 1000);
                });
            },
        });
        $sendInviteList.html('');
        $multiEmail.delete();
        $multiEmail.selector;
        $checkInvitationButton.unbind().click(function () {
            if($invitationsInput.val() != ''){
                var $event = $.Event("keydown",{keyCode:32});
                $invitationsInput.trigger($event);
            }
        });
        $invitationsInput.keydown(function($e){
            var $code = $e.keyCode || $e.which;
            if($code == 13) {
                if($invitationsInput.val() != ''){
                    var $event = $.Event("keydown",{keyCode:32});
                    $invitationsInput.trigger($event);
                }
            }
        });
        $updateInvitationsButtonFile.unbind().change(function(){
            $emailsDetected.html('');
            if(this.files && this.files[0]){
                var $formData = new FormData();
                $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                $formData.append('user_id', libs.memoryGet('user_id'));
                $formData.append('key', $params.key);
                $formData.append('tab', $params.tab);
                $formData.append('file', this.files[0]);
                nurseslounge_lounge_overview.information_tab_invite_massive_update($formData, function($data){
                    var $emails = $data.data.emails;
                    var $emailsCount = $emails.length;
                    if($emailsCount > 0){
                        $emailsDetected.html('We detect ' + $data.data.emails.length + ' email(s)').promise().done(function(){
                            $updateInvitationsButtonFile.val('');
                            $sendMassiveInvitations.unbind().click(function(){
                                $("body").append(
                                    '<form name="inviteResults" method="post" action="/lounge/invite/status" target="inviteResults">'+
                                    '<input type="hidden" name="_token" value="'+$('meta[name="csrf-token"]').attr('content')+'">'+
                                    '<input type="hidden" name="user_id" value="'+libs.memoryGet('user_id')+'">'+
                                    '<input type="hidden" name="key" value="'+$params.key+'">'+
                                    '<input type="hidden" name="tab" value="'+$params.tab+'">'+
                                    '<input type="hidden" name="emails" value="'+$data.data.emails.join(',')+'">'+
                                    '</form>'
                                );
                                var $popUp = window.open("", "inviteResults");
                                $("body").find("form[name='inviteResults']").submit().remove();
                                nurseslounge_lounge_overview.information_tab_invite_invite($params, $emails, function(){
                                    $updateInvitationsButtonFile.val('');
                                    $emailsDetected.html('');
                                    $sendMassiveInvitations.prop('disabled', true);
                                    setTimeout(function(){
                                        nurseslounge_lounge_overview.task_list_container(function($container){
                                            $params = $.extend({}, $params, {only:'owners'});
                                            nurseslounge_myDashboard_myProfile.task_list($container, $params);
                                        });
                                    }, 1000);
                                    setTimeout(function(){
                                        $popUp.document.write("<script>" +
                                            "this.close()" +
                                            "<\/script>");
                                    }, 5000);
                                });
                            });
                            $sendMassiveInvitations.prop('disabled', false);
                        });
                    }else{
                        $updateInvitationsButtonFile.val('');
                        $sendMassiveInvitations.prop('disabled', true);
                    }
                });
            }
        });
        $updateInvitationsButton.unbind().click(function(){
            $updateInvitationsButtonFile.click();
        });
        $previousEmail.unbind().click(function(){
            nurseslounge_lounge_overview.information_tab_invite_invite_previous_email($params, function($data){
                $previousEmailSubject.html($data.data.subject);
                $previousEmailContent.html($data.data.content).promise().done(function(){
                    $previousEmailWrapper.fadeIn();
                });
            });
        });
        $previousEmailWrapper.hide();
        if(cback != undefined){
            cback();
        }
    },
    information_tab_invite_invite:function($params, $emails, cback){
        $.ajax({
            url: "/lounge/invite/list",
            method: "POST",
            cache: false,
            dataType: "json",
            data: $.extend({}, $params, {emails:$emails}),
            success: function ($data) {
                libs.expire($data);
                if(cback != undefined){
                    cback();
                }
            }
        });
    },
    information_tab_invite_massive_update:function($formData, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/invite/massive',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_invite_invite_previous_email:function($params, cback){
        $.ajax({
            url: "/lounge/invite/previous/view",
            method: "POST",
            cache: false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_invite_statistics:function($action, $tab, $params, $data, cback){
        var $graphSelection = $("#inviteStatistics select[name='graphSelection']");
        var $graphType = $("#inviteStatistics select[name='graphType']");
        var $acumulate = $("#inviteStatistics select[name='acumulate']");
        var $filterFromDate = $("#inviteStatistics .filter_from_date");
        var $resetFromDate = $("#inviteStatistics .reset_from_date");
        var $filterToDate = $("#inviteStatistics .filter_to_date");
        var $resetToDate = $("#inviteStatistics .reset_to_date");
        $graphSelection.unbind().change(function(){
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        $graphType.unbind().change(function(){
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        $acumulate.unbind().change(function(){
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        $filterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        $filterToDate.datepicker('clearDates').on('changeDate', function ($e) {
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        $resetFromDate.unbind().click(function(){
            $filterFromDate.val("").datepicker("update");
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        $resetToDate.unbind().click(function(){
            $filterToDate.val("").datepicker("update");
            nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        });
        var $today = new Date();
        var $firstDay =  new Date($today.getFullYear(), $today.getMonth(), 1);
        $firstDay = String($firstDay.getDate()).padStart(2, '0');
        var $lastDay =  new Date($today.getFullYear(), $today.getMonth() + 1, 0);
        $lastDay = String($lastDay.getDate()).padStart(2, '0');
        var $mm = String($today.getMonth() + 1).padStart(2, '0');
        var $yyyy = $today.getFullYear();
        $filterFromDate.val($mm+'/'+$firstDay+'/'+$yyyy).datepicker("update");
        $filterToDate.val($mm+'/'+$lastDay+'/'+$yyyy).datepicker("update");
        nurseslounge_lounge_overview.information_tab_invite_statistics_events($params);
        if(cback != undefined){
            cback();
        }
    },
    information_tab_invite_statistics_events:function($params){
        var $graphSelection = $("#inviteStatistics select[name='graphSelection']");
        var $graphType = $("#inviteStatistics select[name='graphType']");
        var $acumulate = $("#inviteStatistics select[name='acumulate']");
        var $filterFromDate = $("#inviteStatistics .filter_from_date");
        var $filterToDate = $("#inviteStatistics .filter_to_date");
        var $sqOne = $("#inviteStatistics .sq-one");
        var $sqOneText = $("#inviteStatistics .sq-one-text");
        var $sqOneVal = $("#inviteStatistics .sq-one-val");
        var $sqTwo = $("#inviteStatistics .sq-two");
        var $sqTwoText = $("#inviteStatistics .sq-two-text");
        var $sqTwoVal = $("#inviteStatistics .sq-two-val");
        var $sqThree = $("#inviteStatistics .sq-three");
        var $sqThreeText = $("#inviteStatistics .sq-three-text");
        var $sqThreeVal = $("#inviteStatistics .sq-three-val");
        var $sqFour = $("#inviteStatistics .sq-four");
        var $sqFourText = $("#inviteStatistics .sq-four-text");
        var $sqFourVal = $("#inviteStatistics .sq-four-val");
        var $morrisConfig;
        $params = $.extend({},$params,
            {
                graph_selection:$graphSelection.val(),
                filter_from_date:$filterFromDate.val(),
                filter_to_date:$filterToDate.val(),
                acumulate:$acumulate.val()
            }
        );
        nurseslounge_lounge_overview.information_tab_invite_statistics_request($params, function($data){
            if($data.data.one_txt != ''){
                $sqOne.show();
            }else{
                $sqOne.hide();
            }
            $sqOneText.html($data.data.one_txt);
            $sqOneVal.html($data.data.one_val);
            if($data.data.two_txt != ''){
                $sqTwo.show();
            }else{
                $sqTwo.hide();
            }
            $sqTwoText.html($data.data.two_txt);
            $sqTwoVal.html($data.data.two_val);
            if($data.data.three_txt != ''){
                $sqThree.show();
            }else{
                $sqThree.hide();
            }
            $sqThreeText.html($data.data.three_txt);
            $sqThreeVal.html($data.data.three_val);
            if($data.data.four_txt != ''){
                $sqFour.show();
            }else{
                $sqFour.hide();
            }
            $sqFourText.html($data.data.four_txt);
            $sqFourVal.html($data.data.four_val);
            try{
                $("#invite-statistics-graph").empty();
            }catch (e) {

            }
            $morrisConfig = {
                data:$data.data.graph,
                element:'invite-statistics-graph',
                xkey:'date',
                ykeys:$data.data.ykeys,
                xLabelAngle: 45,
                parseTime: false,
                labels:$data.data.labels,
                fillOpacity:0.6,
                hideHover:'auto',
                behaveLikeLine:true,
                resize:true,
                pointFillColors:['#ffffff'],
                pointStrokeColors: ['black'],
                lineColors:['gray','red']
            };
            if($("#invite-statistics-graph").length > 0)
            switch($graphType.val()){
                case 'area':
                    new Morris.Area($morrisConfig);
                    break;
                case 'line':
                    new Morris.Line($morrisConfig);
                    break;
                case 'bar':
                    new Morris.Bar($morrisConfig);
                    break;
                case 'tower':
                    $morrisConfig.stacked = true;
                    new Morris.Bar($morrisConfig);
                    break;
            }
        });
    },
    information_tab_invite_statistics_request:function($params, cback){
        $.ajax({
            url: "/lounge/invite/statistics/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_invite_templates:function($action, $tab, $allowTabs, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $modalAlbum = $("#nurseslounge-lounge-activity-wall-album-modal");
        var $inviteTemplates = $modal.find(".lounge-information-modal-container #inviteTemplates .container");
        var $newInvite = $inviteTemplates.find('.new-invite');
        var $inviteListForm = $inviteTemplates.find(".invite-list-form");
        var $datatableInviteTemplates = $inviteListForm.find(".datatable-invite-templates");
        var $selectAll = $inviteListForm.find("input[name='selectAll']");
        var $selectAction = $inviteListForm.find(".action");
        var $inviteTemplateForm = $inviteTemplates.find('.invite-template-form');
        var $textP = $inviteTemplateForm.find('.text-processor');
        var $textHtml = $inviteTemplateForm.find('textarea[name="content"]');
        var $imageInput = $inviteTemplateForm.find('input[name="document"]');
        var $editorDropImage = $inviteTemplateForm.find('.editor-drop-image');
        var $inviteTemplateEvent = $inviteTemplateForm.find('.form-event');
        var $inviteTemplateFormForm = $inviteTemplates.find("form:first");
        var $resetImage = $inviteTemplateForm.find(".reset-image");
        var $openAlbum = $editorDropImage.find('.open-album');
        var $attachImageOriginal = $editorDropImage.find(".attach-image");
        var $userId = libs.memoryGet('user_id');
        nurseslounge_lounge_overview.information_tab_invite_templates_datatable(
            $datatableInviteTemplates,
            "/lounge/template/datatable",
            "POST",
            $params,
            function ($table) {
                var $recordsTotal = $table.page.info().recordsTotal;
                $inviteTemplates.find('.sq-one-val').html($recordsTotal);
                $selectAll.unbind().click(function(){
                    if($selectAll.is(':checked')){
                        $datatableInviteTemplates.find('.selectRow').attr('checked', true).prop('checked',true);
                    }else{
                        $datatableInviteTemplates.find('.selectRow').attr('checked', false).prop('checked',false);
                    }
                });
                if($selectAll.is(':checked')){
                    $selectAll.attr('checked', false).prop('checked',false);
                }
                $selectAction.unbind().change(function(){
                    var $selectedRows = [];
                    $datatableInviteTemplates.find('.selectRow').each(function(){
                        var $that = $(this);
                        if($that.is(':checked')){
                            $selectedRows.push($that.data('id'));
                        }
                    });
                    if($selectAction.val() != '') {
                        $params = $.extend({},$params, {selected_rows: $selectedRows, selected_action: $selectAction.val()});
                        nurseslounge_lounge_overview.information_tab_invite_templates_actions_request($params, function () {
                            dataTable.reload($datatableInviteTemplates);
                            if($selectAll.is(':checked')){
                                $selectAll.attr('checked', false).prop('checked',false);
                            }
                            $selectAction.val('');
                        });
                    }
                }).val('');
                $datatableInviteTemplates.find('.view').unbind().click(function(){
                    var $that = $(this);
                    var $id = $that.data('id');
                    $params = $.extend({},$params, {id: $id});
                    nurseslounge_lounge_overview.information_tab_invite_templates_view_request($params, function ($data) {
                        $newInvite.data('open', 0);
                        try{
                            $datatableInviteTemplates.dataTable().fnClearTable();
                            $datatableInviteTemplates.dataTable().fnDestroy();
                        }catch($e){

                        }
                        nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, $data, cback);
                    });
                });
                $datatableInviteTemplates.find('.active').unbind().click(function(){
                    var $that = $(this);
                    var $id = $that.data('id');
                    $params = $.extend({},$params, {id: $id});
                    nurseslounge_lounge_overview.information_tab_invite_templates_active_request($params, function ($data) {
                        $newInvite.data('open', 1);
                        try{
                            $datatableInviteTemplates.dataTable().fnClearTable();
                            $datatableInviteTemplates.dataTable().fnDestroy();
                        }catch($e){

                        }
                        nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, $data, cback);
                    });
                });
            }, function ($nRow) {
                return $nRow;
            });
        $newInvite.unbind().click(function(){
            $params = $.extend({},$params, {id: 'active'});
            nurseslounge_lounge_overview.information_tab_invite_templates_view_request($params, function ($data) {
                $editorDropImage.find(".attach-image").replaceWith($attachImageOriginal).promise().done(function(){
                    try{
                        $datatableInviteTemplates.dataTable().fnClearTable();
                        $datatableInviteTemplates.dataTable().fnDestroy();
                    }catch($e){

                    }
                    nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, $data, cback);
                });
            });
        });
        if($newInvite.data('open') == 0){
            $newInvite.html('Template list').promise().done(function(){
                $inviteListForm.hide();
                $inviteTemplateForm.find('.invalid-feedback').hide();
                $inviteTemplateForm.find('.error').removeClass('error');
                $inviteTemplateForm.find('.is-invalid').removeClass('is-invalid');
                $inviteTemplateForm.show();
                $newInvite.data('open', 1);
            });
        }else{
            $newInvite.html('New template').promise().done(function(){
                $inviteTemplateForm.hide();
                $inviteListForm.show();
                dataTable.reload($datatableInviteTemplates);
                $newInvite.data('open', 0);
            });
        }
        try{
            $textP.summernote('destroy');
        }catch (e) {

        }
        var $bindingMatch;
        $textP.summernote({
            disableDragAndDrop:false,
            placeholder: 'Write your text here...',
            height: '350px',
            width: '100%',
            focus: true,
            disableResizeEditor: true,
            dialogsInBody: true,
            dialogsFade: true,
            codeviewFilter: true,
            codeviewIframeFilter: true,
            spellCheck: true,
            disableGrammar: false,
            hint: {
                match: /\B@(\w*)$/,
                search: function ($keyword, cback) {
                    try{
                        clearTimeout($bindingMatch);
                    }catch (e) {

                    }
                    $bindingMatch = setTimeout(function(){
                        nurseslounge_myDashboard_myArticles.editor_match($keyword, function($data){
                            if($data.data.friends.length > 0){
                                cback($data.data.friends);
                            }
                        });
                    }, 800);
                },
                template:function($item){
                    return $item.long_name;
                },
                content: function ($item) {
                    return $('<a href="'+$item.profile_url+'">@' + $item.long_name+'</a>')[0];
                }
            },
            styleTags: [
                'p',
                'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
            ],
            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
            popover: {
                image: [
                    ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter']],
                    ['remove', ['removeMedia']]
                ]
            },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['font', ['fontname']],
                ['font', ['bold', 'italic', 'underline']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['height', ['height']]
            ],
            callbacks: {
                onChange: function($chtml, $editable) {
                    $textHtml.val($chtml);
                },
                onImageLinkInsert: function() {
                },
                onImageUpload: function($file) {
                }
            }
        });
        Dropzone.autoDiscover = false;
        var $dropzone = libs.memoryGet('nurseslounge_lounge_overview_dropzone');
        try{
            $dropzone.destroy();
        }catch ($e) {

        }
        $dropzone = new Dropzone($editorDropImage[0], {
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            createImageThumbnails:false,
            acceptedFiles:'image/png,image/jpg,image/jpeg,image/gif',
            url: '/myDashboard/myArticles/fake',
            params:{user_id:$userId},
            method: 'post',
            clickable:[$editorDropImage[0], $editorDropImage.find('img:first')[0]],
            init: function() {
                var $that = this;
                $that.on("complete", function(){
                    $editorDropImage.find('.dz-preview').remove();
                });
                $that.on("success", function($file) {
                    var $formData = new FormData();
                    $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                    $formData.append('user_id', $userId);
                    $formData.append('key', $params.key);
                    $formData.append('file', $file);
                    var nlWallUpdate = $(window).nurseslounge_lounge_wall_get({
                        user_id:$userId,
                        key: $params.key
                    }, 'nlWallUpdate');
                    nlWallUpdate.analyze($formData, function($data){
                        if($data.status == 'error'){
                            return false;
                        }
                        $formData.append('thumb_file', libs.b64toBlob($data.data.features.thumb));
                        $formData.append('original_name', $data.data.features.original_name);
                        if(
                            $data.data.features.mime_type == 'image/png' ||
                            $data.data.features.mime_type == 'image/jpg' ||
                            $data.data.features.mime_type == 'image/jpeg' ||
                            $data.data.features.mime_type == 'image/gif'
                        ) {
                            $formData.append('preview_file', libs.b64toBlob($data.data.features.preview));
                            $formData.append('file_type', 'image');
                            $formData.append('action', 'save');
                            nlWallUpdate.save($formData, function($data){
                                var $chtml = '' +
                                    '<img '+
                                    '   src="'+$data.data.updated_file.document_root+'?resize=1280x292" ' +
                                    '   class="attach-image img-fluid" ' +
                                    '>';
                                if($data.status == 'success'){
                                    $resetImage.show();
                                    $imageInput.val($data.data.updated_file.id);
                                    $editorDropImage.find(".attach-image").replaceWith($chtml).promise().done(function(){
                                        nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, $data, cback);
                                    });
                                }
                            });
                        }
                    });
                });
            }
        });
        libs.memorySave('nurseslounge_lounge_overview_dropzone', $dropzone);
        $openAlbum.unbind().click(function(){
            $modal.modal('hide');
            setTimeout(function(){
                var nlWallAlbum = $(window).nurseslounge_lounge_wall_get({
                    user_id:$userId,
                    key: $params.key
                }, 'nlWallAlbum');
                var nlWallUpdate = $(window).nurseslounge_lounge_wall_get({
                    user_id:$userId,
                    key: $params.key
                }, 'nlWallUpdate');
                nlWallAlbum.open({
                    on_close_modal:function(){
                        $modalAlbum.modal('hide');
                            setTimeout(function() {
                                $modal.scrollTop(0);
                                $modal.modal('show');
                            }, 1000);
                        },
                    on_end_callback:function(){
                        $modalAlbum.modal('hide');
                            setTimeout(function() {
                                $modal.scrollTop(0);
                                $modal.modal('show');
                            }, 1000);
                    },
                    on_start_callback:false,
                    album_allow_tabs : {
                        'webcam_image':true,
                        'image':true,
                        'document':false,
                        'video':false,
                        'article':false
                    },
                    album_step:11,
                    album_allow_add:true,
                    album_allow_select:true
                }, function($data){
                    var $document = $data.data.updated_file;
                    nlWallUpdate.fill($document, {
                        get_data_callback:function($file){
                            var $chtml = '' +
                                '<img '+
                                '   src="'+$file.document_root+'?resize=1280x292" ' +
                                '   class="attach-image img-fluid" ' +
                                '>';
                            $resetImage.show();
                            $imageInput.val($file.id);
                            $editorDropImage.find(".attach-image").replaceWith($chtml).promise().done(function(){
                                nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, $data, cback);
                            });
                        }
                    });
                });
            }, 1000);
        });
        $resetImage.unbind().click(function(){
            var $id = $inviteTemplateForm.find('input[name="id"]').val();
            if($id != ''){
                $params = $.extend({}, $params, {id:$id});
                nurseslounge_lounge_overview.information_tab_invite_reset_image_request($params, function($data){
                    var $photoRootLounge = $data.data.photo_root_lounge;
                    $inviteTemplateForm.find('input[name="document"]').val('');
                    $editorDropImage.find(".attach-image").replaceWith('<img src="'+$photoRootLounge+'?resize=1280x292" class="attach-image img-fluid">');
                });
            }
            $resetImage.hide();
        }).hide();
        nurseslounge_lounge_overview.information_tab_invite_templates_validate(function($form){
            $params = $.extend({}, $params, libs.getObjForm($form));
            var $inviteTemplateEventAction = libs.memoryGet('nurseslounge_lounge_overview_invite_template_action');
            switch($inviteTemplateEventAction){
                case 'save':
                    nurseslounge_lounge_overview.information_tab_invite_templates_request($params, function(){
                        $editorDropImage.find(".attach-image").replaceWith($attachImageOriginal).promise().done(function(){
                            $inviteTemplateFormForm[0].reset();
                            $textP.summernote('code', '');
                            $newInvite.data('open', 1);
                            try{
                                $datatableInviteTemplates.dataTable().fnClearTable();
                                $datatableInviteTemplates.dataTable().fnDestroy();
                            }catch($e){

                            }
                            nurseslounge_lounge_overview.information_tab_invite_templates($action, $tab, $allowTabs, $params, $data, cback);
                        });
                    });
                    break;
                case 'test':
                    nurseslounge_lounge_overview.information_tab_invite_test_request($params, function () {

                    });
                    break;
            }
        });
        $inviteTemplateEvent.unbind().click(function(){
            var $that = $(this);
            libs.memorySave('nurseslounge_lounge_overview_invite_template_action', $that.data("action"));
            $inviteTemplateFormForm.submit();
        });
        if($data && $data.data && $data.data.lounge_invitation_templates){
            var $id = $data.data.lounge_invitation_templates.id;
            var $name = $data.data.lounge_invitation_templates.name;
            var $subject = $data.data.lounge_invitation_templates.subject;
            var $documentId = $data.data.lounge_invitation_templates && $data.data.lounge_invitation_templates.document_id ? $data.data.lounge_invitation_templates.document_id : '';
            var $documentRoot = $data.data.lounge_invitation_templates.document && $data.data.lounge_invitation_templates.document.document_root ? $data.data.lounge_invitation_templates.document.document_root : $attachImageOriginal.attr('src');
            var $content = $data.data.lounge_invitation_templates.content;
            $inviteTemplateForm.find('input[name="id"]').val($id);
            $inviteTemplateForm.find('input[name="name"]').val($name);
            $inviteTemplateForm.find('input[name="subject"]').val($subject);
            $inviteTemplateForm.find('input[name="document"]').val($documentId);
            $editorDropImage.find(".attach-image").replaceWith('<img src="'+$documentRoot+'" class="attach-image img-fluid">');
            $inviteTemplateForm.find('textarea[name="content"]').val($content);
            $textP.summernote('code', $content);
            if($documentId != ''){
                $resetImage.show();
            }
        }
        cback();
    },
    information_tab_invite_templates_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $table = $($element).DataTable({
            "order": [[1,"desc"]],
            "dom":"<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sScrollXInner": "auto",
            "bScrollCollapse": true,
            "bAutoWidth": true,
            "responsive": false,
            "scrollX": true,
            "paging": true,
            "bDestroy": true,
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "initComplete": function () {
                if(initComplete != undefined){
                    initComplete($table);
                }
            },
            "cache": false,
            "pageLength": 10,
            "pagingType" : "full_numbers",
            "processing": true,
            "serverSide": true,
            "stateSave": true,
            "ajax": {
                "data":function ($d) {
                    return $.extend($d, $data);
                },
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },
    information_tab_invite_templates_actions_request:function($params, cback){
        $.ajax({
            url: '/lounge/template/action',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_invite_templates_view_request:function($params, cback){
        $.ajax({
            url: '/lounge/template/view',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_invite_templates_active_request:function($params, cback){
        $.ajax({
            url: '/lounge/template/active',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_invite_templates_validate:function(cback){
        var $validator;
        try {
            var $modal = $("#nurseslounge-lounge-information-edit-modal");
            $validator = $modal.find(".lounge-information-modal-container #inviteTemplates .container form:first");
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-lounge-information-edit-modal .lounge-information-modal-container #inviteTemplates .container form:first").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                id: {
                    required: false
                },
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                subject: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                document: {
                    required: false
                },
                content: {
                    required: true
                }
            },
            messages: {
                id: {
                    required: "The id is not required"
                },
                name: {
                    required: "The template name is required",
                    minlength: "The template name must have at least 3 characters",
                    maxlength: "The template name cannot exceed 191 characters"
                },
                subject: {
                    required: "The template subject is required",
                    minlength: "The template subject must have at least 3 characters",
                    maxlength: "The template subject cannot exceed 191 characters"
                },
                document: {
                    required: "The image is not required"
                },
                content: {
                    required: "The content is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_tab_invite_templates_request:function($params, cback){
        $.ajax({
            url: '/lounge/template/set',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_invite_test_request:function($params, cback){
        $.ajax({
            url: '/lounge/template/test',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_invite_reset_image_request:function($params, cback){
        $.ajax({
            url: '/lounge/template/resetImage',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_create_logo:function($action, $tab, $allowTabs, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $inviteTemplates = $modal.find(".lounge-information-modal-container #createLogo .container");
        var $textProcessor = $inviteTemplates.find('.text-processor');
        var $content = $inviteTemplates.find('textarea[name="content"]');
        var $websites = $inviteTemplates.find('select[name="websites"]');
        var $logoScriptContainer = $modal.find("#createLogo_Script .container");
        var $copyLinkText = $logoScriptContainer.find('textarea[name="copyLinkText"]');
        var $copyLinkButton = $logoScriptContainer.find('button[name="copyLinkButton"]');
        $copyLinkButton.unbind().click(function(){
            $copyLinkText.select();
            document.execCommand("copy");
        });
        try{
            $textProcessor.summernote('destroy');
        }catch (e) {

        }
        var $chtml = '';
        $.each($data.data.websitesnames, function($i, $v){
            $chtml += '<option value="'+$i+'">'+$v+'</option>';
        });
        try{
            $websites.chosen("destroy");
        }catch (e) {}
        $websites.html($chtml).promise().done(function(){
            $websites.chosen();
            $websites.unbind().change(function(){
                var $that = $(this);
                var $val = $that.val();
                $params = $.extend({}, $params, {logoHashId:$val});
                nurseslounge_lounge_overview.information_tab_create_logo_statistics($params);
            }).change();
        });
        var $logoSelectedLogo = 'word';
        var $logoSelectedColor = 'original';
        var $logoSelectedSize = 'original';
        var $logoSelected = function ($context) {
            var $ui = $.summernote.ui;
            var $event = $ui.buttonGroup([
                $ui.button({
                    contents: 'Icon <div>' +
                        '<i class="fa fa-user">'+
                        '</div>',
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                $ui.dropdown({
                    items: [
                        '<div data-icon="only">Icon</div>',
                        '<div data-icon="word">Icon-Word</div>'
                    ],
                    callback: function ($items) {
                        $($items).find('.note-dropdown-item').unbind().click(function($e){
                            var $that = $(this);
                            var $div = $that.find('div:first');
                            $logoSelectedLogo = $div.data('icon');
                            var $code = $textProcessor.summernote('code');
                            var $src = $($code).find('#nllogo').find('img:first').attr('src');
                            $params = $.extend({}, $params, {
                                action:'selectLogo',
                                logo:$logoSelectedLogo,
                                size:$logoSelectedSize,
                                color:$logoSelectedColor,
                                src:$src
                            });
                            nurseslounge_lounge_overview.information_tab_create_logo_request($params, function($data){
                                var $imageSrc = $data.data.imageSrc;
                                var $imageSize = $data.data.imageSize;
                                $logoSelectedLogo  = $data.data.logo;
                                $logoSelectedSize  = $data.data.size;
                                $logoSelectedColor = $data.data.color;
                                var $chtml;
                                if($logoSelectedColor == 'white') {
                                    $chtml = '<div id="nllogo" style="background: black;">' +
                                        '<img src="' + $imageSrc + '" style="width:' + $imageSize.split('X')[0] + 'px;height:' + $imageSize.split('X')[1] + 'px;">' +
                                        '</div>';
                                }else{
                                    $chtml = '<div id="nllogo">' +
                                        '<img src="' + $imageSrc + '" style="width:' + $imageSize.split('X')[0] + 'px;height:' + $imageSize.split('X')[1] + 'px;">' +
                                        '</div>';
                                }
                                $textProcessor.summernote('code', $chtml);
                            });
                        });
                    }
                })
            ]);
            return $event.render();
        }
        var $size = function ($context) {
            var $ui = $.summernote.ui;
            var $event = $ui.buttonGroup([
                $ui.button({
                    contents: 'Size <div>' +
                    '<span style="background-color:black;height:9px;margin: 0px 2px;">&nbsp;</span>'+
                    '<span style="background-color:black;height:6px;margin: 0px 2px;">&nbsp;</span>'+
                    '<span style="background-color:black;height:1px;margin: 0px 2px;">&nbsp;</span>' +
                    '</div>',
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                $ui.dropdown({
                    items: [
                        '<div data-size="original">Original<div style="background-color:black;height:2px;">&nbsp;&nbsp;&nbsp;</div></div>',
                        '<div data-size="small">Small<div style="background-color:black;height:2px;">&nbsp;&nbsp;&nbsp;</div></div>',
                        '<div data-size="medium">Medium</div><div style="background-color:black;height:5px;">&nbsp;&nbsp;&nbsp;</div>',
                        '<div data-size="large">Large</div><div style="background-color:black;height:10px;">&nbsp;&nbsp;&nbsp;</div>',
                    ],
                    callback: function ($items) {
                        $($items).find('.note-dropdown-item').unbind().click(function($e){
                            var $that = $(this);
                            var $div = $that.find('div:first');
                            $logoSelectedSize = $div.data('size');
                            var $code = $textProcessor.summernote('code');
                            var $src = $($code).find('#nllogo').find('img:first').attr('src');
                            $params = $.extend({}, $params, {
                                action:'resizeTo',
                                logo:$logoSelectedLogo,
                                size:$logoSelectedSize,
                                color:$logoSelectedColor,
                                src:$src
                            });
                            nurseslounge_lounge_overview.information_tab_create_logo_request($params, function($data){
                                var $imageSrc = $data.data.imageSrc;
                                var $imageSize = $data.data.imageSize;
                                $logoSelectedLogo  = $data.data.logo;
                                $logoSelectedSize  = $data.data.size;
                                $logoSelectedColor = $data.data.color;
                                var $chtml;
                                if($logoSelectedColor == 'white'){
                                    $chtml = '<div id="nllogo" style="background: black;">' +
                                        '<img src="'+$imageSrc+'" style="width:'+$imageSize.split('X')[0]+'px;height:'+$imageSize.split('X')[1]+'px;">' +
                                        '</div>';
                                }else{
                                    $chtml = '<div id="nllogo">' +
                                        '<img src="'+$imageSrc+'" style="width:'+$imageSize.split('X')[0]+'px;height:'+$imageSize.split('X')[1]+'px;">' +
                                        '</div>';
                                }
                                $textProcessor.summernote('code', $chtml);
                            });
                        });
                    }
                })
            ]);
            return $event.render();
        }
        var $logoColor = function ($context) {
            var $ui = $.summernote.ui;
            var $event = $ui.buttonGroup([
                $ui.button({
                    contents: 'Color <div>' +
                        '<span style="background-color:black;width: 2px;height:100%;">&nbsp;&nbsp;&nbsp;</span>' +
                        '<span style="background-color:white;width: 2px;height:100%;">&nbsp;&nbsp;&nbsp;</span>' +
                        '<span style="background-color:gray;width: 2px;height:100%;">&nbsp;&nbsp;&nbsp;</span>' +
                        //'<span style="background-color:blue;width: 2px;height:100%;">&nbsp;&nbsp;&nbsp;</span>' +
                        //'<span style="background-color:red;width: 2px;height:100%;">&nbsp;&nbsp;&nbsp;</span>' +
                        //'<span style="background-color:yellow;width: 2px;height:100%;">&nbsp;&nbsp;&nbsp;</span>' +
                        '</div>',
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                $ui.dropdown({
                    items: [
                        '<div style="color:black;"   data-color="original">Original</div>',
                        '<div style="color:black;"   data-color="dark">Black</div>',
                        '<div style="color:black;"   data-color="grey">Dark Grey</div>',
                        '<div style="color:black;"   data-color="light">Light Grey</div>',
                        '<div style="color:black;"   data-color="white">White</div>',
                        //'<div data-color="original">Original</div>',
                        //'<div style="color:blue;"   data-color="blue">Blue</div>',
                        //'<div style="color:red;"    data-color="red">Red</div>',
                        //'<div style="color:brown;" data-color="brown">Brown</div>',
                        //'<div style="color:green;"  data-color="green">Green</div>',
                        //'<div style="color:purple;" data-color="purple">Purple</div>',
                        //'<div style="color:yellow;" data-color="yellow">Yellow</div>',
                    ],
                    callback: function ($items) {
                        $($items).find('.note-dropdown-item').unbind().click(function($e){
                            var $that = $(this);
                            var $div = $that.find('div:first');
                            $logoSelectedColor = $div.data('color');
                            var $code = $textProcessor.summernote('code');
                            var $src = $($code).find('#nllogo').find('img:first').attr('src');
                            $params = $.extend({}, $params, {
                                action:'changeColor',
                                logo:$logoSelectedLogo,
                                size:$logoSelectedSize,
                                color:$logoSelectedColor,
                                src:$src
                            });
                            nurseslounge_lounge_overview.information_tab_create_logo_request($params, function($data){
                                var $imageSrc = $data.data.imageSrc;
                                var $imageSize = $data.data.imageSize;
                                $logoSelectedLogo  = $data.data.logo;
                                $logoSelectedSize  = $data.data.size;
                                $logoSelectedColor = $data.data.color;
                                var $chtml;
                                if($logoSelectedColor == 'white'){
                                    $chtml = '<div id="nllogo" style="background: black;">' +
                                        '<img src="'+$imageSrc+'" style="width:'+$imageSize.split('X')[0]+'px;height:'+$imageSize.split('X')[1]+'px;">' +
                                        '</div>';
                                }else{
                                    $chtml = '<div id="nllogo">' +
                                        '<img src="'+$imageSrc+'" style="width:'+$imageSize.split('X')[0]+'px;height:'+$imageSize.split('X')[1]+'px;">' +
                                        '</div>';
                                }
                                $textProcessor.summernote('code', $chtml);
                            });
                        });
                    }
                })
            ]);
            return $event.render();
        }
        $textProcessor.summernote({
            codemirror: {
                mode: 'htmlmixed',//text/html
                //htmlMode: true,
                lineNumbers: true,
                theme: 'monokai'
            },
            disableDragAndDrop:true,
            placeholder: 'Write your text here...',
            height: '200px',
            width: '100%',
            focus: false,
            disableResizeEditor: true,
            dialogsInBody: false,
            dialogsFade: false,
            codeviewFilter: true,
            codeviewIframeFilter: true,
            spellCheck: false,
            disableGrammar: true,
            toolbar: [
                ['sizeButton', ['size']],
                ['logoSelected', ['logoSelected']],
                ['logoColor', ['logoColor']],
                //['codemirror', ['codeview']],
            ],
            buttons: {
                size: $size,
                logoSelected: $logoSelected,
                logoColor: $logoColor
            },
            callbacks: {
                onCodeviewToggled:function(){
                    try{
                        var $editor = $('textarea.note-codable').data('cmEditor');
                        var totalLines = $editor.lineCount();
                        var totalChars = $editor.getTextArea().value.length;
                        $editor.autoFormatRange({line:0, ch:0}, {line:totalLines, ch:totalChars});
                        $editor.scrollTo(0,0);
                    }catch ($e){
                    }
                },
                onInit:function(){
                    if($.trim($content.val()) != ''){
                        $textProcessor.summernote('pasteHTML', $content.val());
                        //$textP.summernote('codeview.activate');
                        //$textP.summernote('codeview.toggle');
                    }
                },
                onChange: function($chtml, $editable) {
                    //$content.val($chtml);
                },
            }
        });
        nurseslounge_lounge_overview.information_create_logo_validate($params, function($form){
            var $form = libs.getObjForm($form);
            var $code = $textProcessor.summernote('code');
            var $src = $('<div>'+$code+'</div>').find('#nllogo img:first').attr('src');
            if($src == undefined){
                $modal.find(".logo-invalid-feedback").show();
                return false;
            }
            $("#createLogo form:first input[name='websiteName']").val('');
            $textProcessor.summernote('code', '');
            $params = $.extend({}, $params, {
                action:'createCode',
                websiteName:$form.websiteName,
                logo:$logoSelectedLogo,
                size:$logoSelectedSize,
                color:$logoSelectedColor,
                src:$src
            });
            nurseslounge_lounge_overview.information_tab_create_logo_request($params, function($data){
                var $url = $data.data.url;
                $url = '<script src="'+$url+'" id="nllogo"></script>';
                if($url.split('?')[1] != ''){
                    $copyLinkText.val($url);
                }
                var $websitesnames = $data.data.websites_names;
                var $chtml = '';
                $.each($websitesnames, function($i, $v){
                    $chtml += '<option value="'+$i+'">'+$v+'</option>';
                });
                var $logoHashId = $data.data.logoHashId;
                try{
                    $websites.chosen("destroy");
                }catch (e) {}
                $websites.html($chtml).promise().done(function(){
                    $websites.val($logoHashId);
                    $websites.chosen();
                    $websites.unbind().change(function(){
                        var $that = $(this);
                        var $val = $that.val();
                        $params = $.extend({}, $params, {logoHashId:$val});
                        nurseslounge_lounge_overview.information_tab_create_logo_statistics($params);
                    }).change();
                });
            });
        });
        cback();
    },
    information_create_logo_validate:function($params, cback){
        var $validator;
        try {
            $validator = $("#createLogo form:first").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#createLogo form:first").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                websiteName: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    remote: {
                        url: "/lounge/create/embed/logo/exist",
                        type: "post",
                        data: {
                            key: $params.key,
                            user_id: $params.user_id,
                            websiteName: function(){ return $("#createLogo form:first input[name='websiteName']").val(); }
                        }
                    }
                },
            },
            messages: {
                websiteName: {
                    required: "The website name is required",
                    minlength: "The website name must have at least 3 characters",
                    maxlength: "The website name cannot exceed 191 characters",
                    remote:"The website name exist, choose another"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_tab_create_logo_request:function($params, cback){
        $.ajax({
            url: "/lounge/create/embed/logo",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_create_logo_statistics:function($params){
           var $modal = $("#nurseslounge-lounge-information-edit-modal");
           var $createLogo = $modal.find("#createLogo");
           var $visitGraphType = $createLogo.find("select[name='visitGraphType']");
           var $visitsFilterFromDate = $createLogo.find(".visits_filter_from_date:first");
           var $visitsResetFromDate = $createLogo.find(".visits_reset_from_date:first");
           var $visitsFilterToDate = $createLogo.find(".visits_filter_to_date:first");
           var $visitsResetToDate = $createLogo.find(".visits_reset_to_date:first");

           $visitGraphType.unbind().change(function(){
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $visitsFilterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $visitsResetFromDate.unbind().click(function(){
               $visitsFilterFromDate.val("").datepicker("update");
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $visitsFilterToDate.datepicker('clearDates').on('changeDate', function ($e) {
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $visitsResetToDate.unbind().click(function(){
               $visitsFilterToDate.val("").datepicker("update");
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });

           var $redirectGraphType = $createLogo.find("select[name='redirectGraphType']");
           var $redirectFilterFromDate = $createLogo.find(".redirect_filter_from_date:first");
           var $redirectResetFromDate = $createLogo.find(".redirect_reset_from_date:first");
           var $redirectFilterToDate = $createLogo.find(".redirect_filter_to_date:first");
           var $redirectResetToDate = $createLogo.find(".redirect_reset_to_date:first");

           $redirectGraphType.unbind().change(function(){
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $redirectFilterFromDate.datepicker('clearDates').on('changeDate', function ($e) {
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $redirectResetFromDate.unbind().click(function(){
               $redirectFilterFromDate.val("").datepicker("update");
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $redirectFilterToDate.datepicker('clearDates').on('changeDate', function ($e) {
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });
           $redirectResetToDate.unbind().click(function(){
               $redirectFilterToDate.val("").datepicker("update");
               nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
           });

           var $today = new Date();
           var $firstDay =  new Date($today.getFullYear(), $today.getMonth(), 1);
           $firstDay = String($firstDay.getDate()).padStart(2, '0');
           var $lastDay =  new Date($today.getFullYear(), $today.getMonth() + 1, 0);
           $lastDay = String($lastDay.getDate()).padStart(2, '0');
           var $mm = String($today.getMonth() + 1).padStart(2, '0');
           var $yyyy = $today.getFullYear();
           $visitsFilterFromDate.val($mm+'/'+$firstDay+'/'+$yyyy).datepicker("update");
           $visitsFilterToDate.val($mm+'/'+$lastDay+'/'+$yyyy).datepicker("update");
           $redirectFilterFromDate.val($mm+'/'+$firstDay+'/'+$yyyy).datepicker("update");
           $redirectFilterToDate.val($mm+'/'+$lastDay+'/'+$yyyy).datepicker("update");
           nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph($params);
    },
    graphBinding:null,
    information_tab_create_logo_statistics_graph:function($params){
        //This function was creating because datepickers fire without event
        try{
            clearTimeout(nurseslounge_lounge_overview.graphBinding);
        }catch ($e){

        }
        nurseslounge_lounge_overview.graphBinding = setTimeout(function(){
            nurseslounge_lounge_overview.information_tab_create_logo_statistics_graph_binding($params);
        }, 1000);
    },
    information_tab_create_logo_statistics_graph_binding:function($params){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $inviteTemplates = $modal.find(".lounge-information-modal-container #createLogo .container");
        var $websites = $inviteTemplates.find('select[name="websites"]');
        var $visits = $inviteTemplates.find('.visits');
        var $uniqueVisits = $inviteTemplates.find('.unique-visits');
        var $redirect = $inviteTemplates.find('.redirect');
        var $uniqueRedirect = $inviteTemplates.find('.unique-redirect');
        var $delete = $inviteTemplates.find('.delete');
        var $copyLinkText = $inviteTemplates.find('textarea[name="copyLinkText"]');
        nurseslounge_lounge_overview.information_tab_get_logo_visits($params, function($data) {
            var $imageSrc = $data.data.imageSrc;
            var $imageSize = $data.data.imageSize;
            var $url = $data.data.url;
            var $oneVal = $data.data.one_val;
            var $twoVal = $data.data.two_val;
            var $threeVal = $data.data.three_val;
            var $fourVal = $data.data.four_val;

            var $previousLogo = $(".previous-logo");
            try {
                $previousLogo.summernote('destroy');
            } catch (e) {

            }
            $previousLogo.summernote({
                disableDragAndDrop: true,
                placeholder: '',
                height: '200px',
                width: '100%',
                focus: false,
                disableResizeEditor: true,
                dialogsInBody: false,
                dialogsFade: false,
                codeviewFilter: true,
                codeviewIframeFilter: true,
                spellCheck: false,
                disableGrammar: true,
                toolbar: [],
            });


                $visits.html($oneVal);
                $uniqueVisits.html($twoVal);
                $redirect.html($threeVal);
                $uniqueRedirect.html($fourVal);

                //Logo And Image
                var $chtml = '<div id="nllogo">' +
                    '<img src="' + $imageSrc + '" style="width:' + $imageSize.split('X')[0] + 'px;height:' + $imageSize.split('X')[1] + 'px;">' +
                    '</div>';
                $previousLogo.summernote('code', $chtml);
                $url = '<script src="' + $url + '" id="nllogo"></script>';
                if($url.split('?')[1] != ''){
                    $copyLinkText.val($url);
                }

            $delete.unbind().click(function(){
                nurseslounge_lounge_overview.information_tab_delete_logo($params, function($data){
                    var $url = $data.data.url;
                    $url = '<script src="'+$url+'" id="nllogo"></script>';
                    if($url.split('?')[1] != ''){
                        $copyLinkText.val($url);
                    }
                    var $websitesnames = $data.data.websites_names;
                    var $chtml = '';
                    $.each($websitesnames, function($i, $v){
                        $chtml += '<option value="'+$i+'">'+$v+'</option>';
                    });
                    var $logoHashId = $data.data.logoHashId;
                    try{
                        $websites.chosen("destroy");
                    }catch (e) {}
                    $websites.html('');
                    $websites.html($chtml).promise().done(function(){
                        $websites.val($logoHashId);
                        $websites.chosen();
                        $websites.unbind().change(function(){
                            $previousLogo.summernote('code', '');
                            $inviteTemplates.find('.visits').html(0);
                            $inviteTemplates.find('.unique-visits').html(0);
                            $inviteTemplates.find('.redirect').html(0);
                            $inviteTemplates.find('.unique-redirect').html(0);
                            var $that = $(this);
                            var $val = $that.val();
                            $params = $.extend({}, $params, {logoHashId:$val});
                            nurseslounge_lounge_overview.information_tab_create_logo_statistics($params);
                        }).change();
                    });
                });
            });
        });
    },
    information_tab_delete_logo:function($params, cback){
        $.ajax({
            url: "/lounge/logo/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_get_logo_visits:function($params, cback){
        $.ajax({
            url: "/lounge/logo/statistics",
            method: "POST",
            cache:false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_buy_ads:function($action, $tab, $allowTabs, $params, $data, cback){
        var $userId = $params.user_id;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $buyAds = $modal.find(".lounge-information-modal-container #buyAds .container");
        var $newImageForm = $buyAds.find('form[name="new-image-form"]');
        var $dropImage = $newImageForm.find('.drop-image');
        var $defaultItem = $newImageForm.find('.default-item');
        var $degrees = $newImageForm.find('select[name="degrees"]');
        var $buyImpressions = $newImageForm.find('.buy-impressions');
        Dropzone.autoDiscover = false;
        var $dropzone = libs.memoryGet('nurseslounge_lounge_overview_dropzone');
        try{
            $dropzone.destroy();
        }catch ($e) {

        }
        $dropzone = new Dropzone($dropImage[0], {
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            createImageThumbnails:false,
            acceptedFiles:'image/png,image/jpg,image/jpeg,image/gif',
            url: '/myDashboard/myArticles/fake',
            params:{user_id:$userId},
            method: 'post',
            clickable:[$dropImage[0], $dropImage.find('img:first')[0]],
            init: function() {
                var $that = this;
                $that.on("complete", function(){
                    $dropImage.find('.dz-preview').remove();
                });
                $that.on("success", function($file) {
                    var $formData = new FormData();
                    $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                    $formData.append('user_id', $userId);
                    $formData.append('key', $params.key);
                    $formData.append('file', $file);
                    nurseslounge_lounge_overview.information_tab_buy_ads_files_request($formData, function($data){
                        var $loungeAdId = $data.data.lounge_ad_id;
                        var $publicImageRoot = $data.data.public_image_root;
                        $dropImage.find('img:first').attr('src', $publicImageRoot);
                        $defaultItem.data('image_id', $loungeAdId);
                        $defaultItem.data('src', $publicImageRoot);
                        $degrees.prop('disabled', false);
                        $buyImpressions.prop('disabled', false);
                        try{
                            $degrees.chosen('destroy');
                        }catch (e) {}
                        $degrees.chosen();
                        $degrees.unbind();
                        $degrees.change(function(){
                            var $imageId = $defaultItem.data('image_id');
                            $params = $.extend({}, $params, {image_id:$imageId, degrees:$degrees.val()});
                            nurseslounge_lounge_overview.information_tab_buy_ads_degree_type_request($params, function($data){
                                var $publicImageRoot = $data.data.public_image_root;
                                var $loungeAdId = $data.data.lounge_ad_id;
                                $defaultItem.data('image_id', $loungeAdId);
                                $defaultItem.data('src', $publicImageRoot);
                            });
                        });
                    });
                });
            }
        });
        libs.memorySave('nurseslounge_lounge_overview_dropzone', $dropzone);
        try{
            $degrees.chosen('destroy');
        }catch (e) {}
        $degrees.find('option').prop('selected', false);
        $degrees.prop('disabled', true);
        $degrees.chosen();
        $buyImpressions.prop('disabled', true);
        $buyImpressions.unbind().click(function(){
            var $defaultItem = $newImageForm.find('.default-item')
            var $imageId = $defaultItem.data('image_id');
            var $src = $defaultItem.data('src');
            nurseslounge_lounge_overview.information_tab_buy_ads_impression_form($params, $imageId, $src, function(){
                nurseslounge_lounge_overview.information_tab_buy_ads($action, $tab, $allowTabs, $params, $data);
            });
        });
        $dropImage.find('img:first').attr('src', '/bimg/NursesLounge/dragAndDrop.png');
        nurseslounge_lounge_overview.information_tab_buy_ads_list($params);
        if(cback != undefined){
            cback();
        }
    },
    information_tab_buy_ads_files_request:function($formData, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/buyAds/updateImage',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_buy_ads_degree_type_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/buyAds/updateDegrees',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_buy_ads_impression_form:function($params, $imageId, $src, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $buyAds = $modal.find(".lounge-information-modal-container #buyAds .container");
        var $adsListForm = $buyAds.find('form[name="ads-list-form"]');
        var $newImageForm = $buyAds.find('form[name="new-image-form"]');
        var $paymentForm = $buyAds.find("form[name='stripe-form']");
        var $paymentFormWrapper = $paymentForm.find('.payment-form-wrapper');
        var $paymentFormImage = $paymentForm.find('.payment-form-image');
        var $onProgressWrapper = $paymentForm.find('.on-progress-checkmark-wrapper');
        var $successWrapper = $paymentForm.find('.success-checkmark-wrapper');
        var $inputImpressions = $paymentForm.find('input[name="impressions"]');
        var $impressionsAmount = $paymentForm.find('.impressions-amount');
        var $btnContinue = $paymentForm.find('.continue');
        var $submitButton = $paymentForm.find('button[type="submit"]');
        var $back = $paymentForm.find('.back');
        var $promo = $paymentForm.find('input[name="promo"]');

        $back.unbind().click(function(){
            $adsListForm.show();
            $newImageForm.show();
            $paymentForm.hide();
        });

        try{
            var $cardSaved = libs.memoryGet('nurseslounge_lounge_overview_card');
            if($cardSaved){
                $cardSaved.destroy();
            }
        }catch ($e){

        }
        $adsListForm.hide();
        $newImageForm.hide();
        $paymentFormImage.attr('src', $src);

        $paymentFormWrapper.show();
        $onProgressWrapper.hide();
        $successWrapper.hide();

        $submitButton.prop('disabled', false);
        $inputImpressions.unbind().change(function(){
            var $impressions = ((($inputImpressions.val() / 2500) * 50000)/100);
            $impressionsAmount.html('$'+$impressions.toFixed(2));
            $promo.keydown();
        });

        var $promoBinding;
        $promo.unbind().on('keyup keydown keypress blur', function(){
            var $code = $(this).val();
            $params = $.extend({}, $params, {code:$code});
            try{
                clearTimeout($promoBinding);
            }catch ($e) {

            }
            $promoBinding = setTimeout(function(){
                nurseslounge_lounge_overview.information_tab_buy_ads_promo($params, function($data){
                    var $promo = $data.data.promo_code;
                    var $discountType = $promo && $promo.discount_type ? $promo.discount_type : null;
                    var $discount = $promo && $promo.discount ? $promo.discount : null;
                    $params = $.extend({}, $params, {discount_type:$discountType, discount:$discount});
                    var $impressions = ((($inputImpressions.val() / 2500) * 50000)/100);
                    if($discountType && $discount){
                        switch ($discountType){
                            case 'percent':
                                $discount = ($discount * $impressions)/100;
                                $impressions = $impressions - $discount;
                                $impressionsAmount.html('$'+$impressions.toFixed(2));
                                break;
                            case 'money':
                                $impressions = $impressions - $discount;
                                $impressionsAmount.html('$'+$impressions.toFixed(2));
                                break;
                        }
                    }else{
                        $impressionsAmount.html('$'+$impressions.toFixed(2));
                    }
                });
            }, 800);
        }).keydown();

        var $card = stripe.elements();
        var $style = {
            base: {
                'lineHeight': '1.5',
                'fontSize': '1.09em',
                'color': '#00184A',
                'fontFamily': "sans-serif",
                'height':'100%',
                'fontWeight':'100',
                'opacity': '0.9',
                '::placeholder': {
                    'color':'#636c72',
                    'opacity':'0.9'
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            },
        };
        var $cardDom = $paymentForm.find('.card:first')[0];
        var $cardEle = $card.create('card', {style:$style});
        $cardEle.mount($cardDom);
        libs.memorySave('nurseslounge_lounge_overview_card', $cardEle);
        nurseslounge_lounge_overview.information_tab_buy_ads_validate(function($form){
            var $objForm = libs.getObjForm($form);
            $submitButton.prop('disabled', true);
            $paymentFormWrapper.hide();
            $onProgressWrapper.show();
            stripe.createToken($cardEle, {
                name:$objForm.name,
                address_country:'US',
                currency:'usd'
            }).then(function($res) {
                if($res.token && $res.token.id){
                    var $newParams = $.extend({}, $objForm, $res, $params, {image_id:$imageId});
                    nurseslounge_lounge_overview.information_tab_buy_ads_impressions_request($newParams, function($data){
                        if($data.status == 'success'){
                            $paymentFormWrapper.hide();
                            $onProgressWrapper.hide();
                            $successWrapper.show();
                            $btnContinue.unbind().click(function(){
                                nurseslounge_lounge_overview.information_tab_buy_ads_list($params);
                                $submitButton.prop('disabled', false);
                                $paymentForm[0].reset();
                                $paymentForm.hide();
                                $successWrapper.hide();
                                $newImageForm.show();
                                $adsListForm.show();
                                if(cback != undefined){
                                    cback();
                                }
                            });
                        }else{
                            var $validator = $paymentForm.validate();
                            $validator.showErrors({"card": $data.data.msg});
                            $paymentForm.find("input[name='card']").val('');
                            $submitButton.prop('disabled', false);
                            $onProgressWrapper.hide();
                            $paymentFormWrapper.show();
                        }
                    });
                }else{
                    $submitButton.prop('disabled', false);
                    $onProgressWrapper.hide();
                    $paymentFormWrapper.show();
                }
            });
        });
        $cardEle.on('change', function($e){
            if(!$e.complete && $e.error && $e.error.message){
                var $validator = $paymentForm.validate();
                $validator.showErrors({"card": $e.error.message});
                $paymentForm.find("input[name='card']").val('');
                $paymentForm.find('.invalid-feedback').hide();
                $paymentForm.find('.error').removeClass('error');
                $paymentForm.find('.is-invalid').removeClass('is-invalid');
            }else{
                $paymentForm.find("input[name='card']").val('complete');
            }
        });
        $paymentForm.show();
    },
    information_tab_buy_ads_promo:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/buyAds/promo',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_buy_ads_impressions_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/buyAds/payment',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_buy_ads_validate:function(cback){
        $.validator.addMethod('minStrict', function ($val, $el, $par) {
            return $val >= $par;
        });
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $buyAds = $modal.find(".lounge-information-modal-container #buyAds .container");
        var $paymentForm = $buyAds.find("form[name='stripe-form']")
        var $validator;
        try {
            $validator = $paymentForm.validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $paymentForm.validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                impressions: {
                    required: true,
                    minStrict: 2500,
                    number: true
                },
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                },
                card: {
                    required: true
                }
            },
            messages: {
                impressions:{
                    required: "The impressions is required",
                    minStrict:"The impressions should be greater than 5000",
                    number: "The impressions should be a number"
                },
                name:{
                    required: "The name is required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                card:{
                    required: "The card is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_tab_buy_ads_list:function($params){
        var $reload;
        var $loaded = false;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $buyAds = $modal.find(".lounge-information-modal-container #buyAds .container");
        var $adsListWrapper = $buyAds.find('.ads-list-wrapper');
        var $paginationNav = $buyAds.find('.pagination-nav');
        var $resultInfo = $buyAds.find(".result-info-count:first");
        var $paginationObj;
        var $saveParams = $params;
        try{
            $paginationObj = libs.memoryGet('lounges_ads_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: 1,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/lounge/buyAds/list",
            locator: 'data.ads',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$params,
                beforeSend: function() {
                    $adsListWrapper.html(nurseslounge_lounge_overview.information_tab_buy_ads_list_item_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-lounge-ads-preload');
                $resultInfo.removeClass('nurseslounge-lounge-ads-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Ads</span>');
                var $chtml = nurseslounge_lounge_overview.information_tab_buy_ads_list_item_html($data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $adsListWrapper.html('').html($chtml).promise().done(function () {
                        nurseslounge_lounge_overview.information_tab_buy_ads_list_item_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('lounges_ads_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_lounge_overview.information_tab_buy_ads_list($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    information_tab_buy_ads_list_item_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++){
            $chtml+= '' +
                '    <div class="row preview">' +
                '        <div class="col-4 text-center pt-5 mb-5 nurseslounge-lounge-ads-preload">' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="col-4 text-center pt-5 mb-5">' +
                '            <div class="row">' +
                '                <div class="col-12 nurseslounge-lounge-ads-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '            </div>' +
                '            <div class="row">' +
                '                <div class="col-12 nurseslounge-lounge-ads-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '            </div>' +
                '            <div class="row">' +
                '                <div class="col-12 nurseslounge-lounge-ads-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-4 text-center pt-5 mb-5 nurseslounge-lounge-ads-preload">' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '    </div>';
        }
        return $chtml;
    },
    information_tab_buy_ads_list_item_html:function($loungeAds){
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        $.each($loungeAds, function($i, $v){
            var $img = $v.public_image_root;
            var $checked = $v.active == 1 ? 'checked' : '';
            $chtml+='' +
                '    <div class="row item" data-image_id="'+$v.id+'" data-src="'+$img+'">' +
                '        <div class="col-4">' +
                '           <div class="col-12 text-center pt-5 mb-5 border img-wrapper">' +
                '               <img src="'+$img+'" class="img-fluid">' +
                '           </div>' +
                '        </div>' +
                '        <div class="col-4">' +
                '           <div class="col-12 text-center pt-5 pb-5 mb-5 border">' +
                '               <div class="row">' +
                '                   <div class="col-12">' +
                '                       <input class="switch" type="checkbox" '+$checked+'>' +
                '                   </div>' +
                '               </div>' +
                '               <div class="row">' +
                '                   <div class="col-12">' +
                '                       <p class="text-left mt-2">Help us prioritize this ad to nurses. <br> Which degree(s) should the nurse already have to qualify for this advertised degree?</p>' +
                '                   </div>' +
                '               </div>' +
                '               <div class="row pb-4">' +
                '                   <div class="col-12">' +
                '                       <div class="form-input">' +
                '                           <div class="form-group">' +
                '                               <select data-placeholder="Choose one or more" class="form-control" multiple  name="degrees">' +
                                                    nurseslounge_lounge_overview.information_tab_buy_ads_list_item_degrees_html($v.all_degrees, $v.degrees) +
                '                               </select>' +
                '                           </div>' +
                '                       </div>' +
                '                   </div>' +
                '               </div>' +
                '           </div>' +
                '        </div>' +
                '        <div class="col-4">' +
                '           <div class="col-12 text-center py-0 border">' +
                '               <table class="table borderless mb-2">' +
                '                   <tr>' +
                '                       <td class="text-left font-weight-bold">Remaining Impressions:</td>' +
                '                       <td>'+$v.impressions+'</td>' +
                '                   </tr>' +
                '                   <tr>' +
                '                       <td class="text-left font-weight-bold">Purchase Date:</td>' +
                '                       <td>'+$v.created_at+'</td>' +
                '                   </tr>' +
                '                   <tr>' +
                '                       <td class="text-left font-weight-bold">Purchase Amount:</td>' +
                '                       <td>'+$v.real_amount+'</td>' +
                '                   </tr>' +
                '                   <tr>' +
                '                       <td class="text-left font-weight-bold">Purchase Quantity:</td>' +
                '                       <td>'+$v.quantity+'</td>' +
                '                   </tr>' +
                '                   <tr>' +
                '                       <td colspan="2">' +
                '                           <button type="button" class="btn btn-save btnAnimate buy-more-impressions">Buy More Impressions</button>' +
                '                       </td>' +
                '                   </tr>' +
                '               </table>' +
                '           </div>' +
                '       </div>' +
                '    </div>';
        });
        return $chtml;
    },
    information_tab_buy_ads_list_item_degrees_html:function($allDegrees, $selectedDegrees){
        var $selection = [];
        $.each($selectedDegrees, function($i, $v){
            $selection.push($v.degree.type);
        });
        $selection.sort();
        $selection = $.unique($selection);
        var $chtml = '';
        $.each($allDegrees, function($i, $v){
            if($.inArray($v, $selection)  > -1){
                $chtml += '<option value="'+$v+'" selected>'+$v+'</option>';
            }else{
                $chtml += '<option value="'+$v+'">'+$v+'</option>';
            }
        });
        return $chtml;
    },
    information_tab_buy_ads_list_item_events:function($params){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $buyAds = $modal.find(".lounge-information-modal-container #buyAds .container");
        var $adsListWrapper = $buyAds.find('.ads-list-wrapper');
        var $degrees = $adsListWrapper.find('select[name="degrees"]');
        var $switch = $adsListWrapper.find('.switch');
        var $buyMoreImpressions = $adsListWrapper.find('.buy-more-impressions');
        try{
            $switch.bootstrapToggle('destroy');
        }catch (e) {}
        $switch.bootstrapToggle();
        $switch.unbind();
        $switch.change(function(){
            var $that = $(this);
            var $imageId = $that.parents('.item:first').data('image_id');
            $params = $.extend({}, $params, {image_id:$imageId, active:$that.is(':checked')});
            nurseslounge_lounge_overview.information_tab_buy_ads_active_request($params, function($data){
                if($data.data.active == 0){
                    $that.bootstrapToggle('off', true);
                }else{
                    $that.bootstrapToggle('on', true);
                }
            });
        });
        try{
            $degrees.chosen('destroy');
        }catch (e) {}
        $degrees.chosen();
        $degrees.unbind();
        $degrees.change(function(){
            var $that = $(this);
            var $imageId = $that.parents('.item:first').data('image_id');
            $params = $.extend({}, $params, {image_id:$imageId, degrees:$degrees.val()});
            nurseslounge_lounge_overview.information_tab_buy_ads_degree_type_request($params, function($data){
                var $loungeAdId = $data.data.lounge_ad_id;
                $that.parents('.item:first').data('image_id', $loungeAdId);
            });
        });
        $buyMoreImpressions.unbind().click(function(){
            var $that = $(this);
            var $imageId = $that.parents('.item:first').data('image_id');
            var $src = $that.parents('.item:first').data('src');
            nurseslounge_lounge_overview.information_tab_buy_ads_impression_form($params, $imageId, $src);
        });
    },
    information_tab_buy_ads_active_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/buyAds/active',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_sponsor_degrees:function($action, $tab, $allowTabs, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $sponsorDegrees = $modal.find(".lounge-information-modal-container #sponsorDegrees .container");
        var $datatableApplications = $sponsorDegrees.find(".datatable-sponsor-degrees");
        var $datatableSearch = $sponsorDegrees.find("input[name='search']");
        var $datatableSearchButton = $sponsorDegrees.find(".search");
        var $datatableSearchBinding;
        nurseslounge_lounge_overview.information_tab_sponsor_degrees_datatable(
            $datatableApplications,
            "/lounge/sponsorDegrees/datatable",
            "POST",
            $params,
            function($table){
                $datatableApplications.find('.option').unbind().click(function(){
                    var $that = $(this);
                    var $degreeId = $that.data('id');
                    var $degreeName = $that.data('name');
                    nurseslounge_lounge_overview.information_tab_sponsor_degrees_buy_form($params, $degreeId, $degreeName);
                });
            },function($nRow){
                return $nRow;
            }, function($table){
                $datatableSearchButton.unbind().click(function () {
                    $table.search($datatableSearch.val());
                    $table.draw();
                });
                $datatableSearch.unbind().on('keypress keyup keydown blur', function () {
                    try{
                        clearTimeout($datatableSearchBinding);
                    }catch (e) {

                    }
                    $datatableSearchBinding = setTimeout(function(){
                        $table.search($datatableSearch.val());
                        $table.draw();
                    }, 1000);
                });
            });
        if(cback != undefined){
            cback();
        }
    },
    information_tab_sponsor_degrees_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $table = $($element).DataTable({
            "order": [[1,"desc"]],
            "dom":"<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sScrollXInner": "auto",
            "bScrollCollapse": true,
            "bAutoWidth": true,
            "responsive": false,
            "scrollX": true,
            "paging": true,
            "bDestroy": true,
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "initComplete": function () {
                initComplete($table);
            },
            "cache": false,
            "pageLength": 10,
            "pagingType" : "full_numbers",
            "processing": true,
            "serverSide": true,
            "stateSave": true,
            "ajax": {
                "data":function ($d) {
                    return $.extend($d, $data);
                },
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },
    information_tab_sponsor_degrees_buy_form:function($params, $degreeId, $degreeName){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $sponsorDegrees = $modal.find(".lounge-information-modal-container #sponsorDegrees .container");
        var $sponsorDegreesList = $sponsorDegrees.find('form[name="sponsor-degrees-list-form"]');
        var $paymentForm = $sponsorDegrees.find("form[name='stripe-form']");
        var $fromDate = $paymentForm.find(".from_date:first");
        var $resetFromDate = $paymentForm.find(".reset_from_date:first");
        var $paymentFormWrapper = $paymentForm.find('.payment-form-wrapper');
        var $paymentFormImage = $paymentForm.find('.degree-name');
        var $onProgressWrapper = $paymentForm.find('.on-progress-checkmark-wrapper');
        var $successWrapper = $paymentForm.find('.success-checkmark-wrapper');
        var $days = $paymentForm.find('select[name="days"]');
        var $impressionsDays = $paymentForm.find('.impressions-days');
        var $btnContinue = $paymentForm.find('.continue');
        var $submitButton = $paymentForm.find('button[type="submit"]');
        var $back = $paymentForm.find('.back');
        var $promo = $paymentForm.find('input[name="promo"]');

        $back.unbind().click(function(){
            $sponsorDegreesList.show();
            $paymentForm.hide();
        });

        $fromDate.datepicker();
        $resetFromDate.unbind().click(function(){
            $fromDate.val("").datepicker("update");
        });

        try{
            var $cardSaved = libs.memoryGet('nurseslounge_lounge_overview_card');
            if($cardSaved){
                $cardSaved.destroy();
            }
        }catch ($e){

        }
        $sponsorDegreesList.hide();
        $paymentFormImage.html($degreeName);

        $paymentFormWrapper.show();
        $onProgressWrapper.hide();
        $successWrapper.hide();

        $submitButton.prop('disabled', false);
        $days.unbind().change(function(){
            var $that = $(this);
            var $val = $that.val();
            var $impressions;
            if($val == 365){
                $impressions = 6000;
            }else{
                $impressions = Math.round((($val/30) * 500) * 100)/100;
            }
            $impressionsDays.html('$'+$impressions.toFixed(2));
            $promo.keydown();
        });

        var $promoBinding;
        $promo.unbind().on('keyup keydown keypress blur', function(){
            var $code = $(this).val();
            $params = $.extend({}, $params, {code:$code});
            try{
                clearTimeout($promoBinding);
            }catch ($e) {

            }
            $promoBinding = setTimeout(function(){
                nurseslounge_lounge_overview.information_tab_sponsor_degrees_buy_promo($params, function($data){
                    var $promo = $data.data.promo_code;
                    var $discountType = $promo && $promo.discount_type ? $promo.discount_type : null;
                    var $discount = $promo && $promo.discount ? $promo.discount : null;
                    $params = $.extend({}, $params, {discount_type:$discountType, discount:$discount});
                    var $_days = $days.val();
                    var $impressions;
                    if($_days == 365){
                        $impressions = 6000;
                    }else{
                        $impressions = Math.round((($_days/30) * 500) * 100)/100;
                    }
                    if($discountType && $discount){
                        switch ($discountType){
                            case 'percent':
                                $discount = ($discount * $impressions)/100;
                                $impressions = $impressions - $discount;
                                $impressionsDays.html('$'+$impressions.toFixed(2));
                                break;
                            case 'money':
                                $impressions = $impressions - $discount;
                                $impressionsDays.html('$'+$impressions.toFixed(2));
                                break;
                        }
                    }else{
                        $impressionsDays.html('$'+$impressions.toFixed(2));
                    }
                });
            }, 800);
        }).keydown();

        var $card = stripe.elements();
        var $style = {
            base: {
                'lineHeight': '1.5',
                'fontSize': '1.09em',
                'color': '#00184A',
                'fontFamily': "sans-serif",
                'height':'100%',
                'fontWeight':'100',
                'opacity': '0.9',
                '::placeholder': {
                    'color':'#636c72',
                    'opacity':'0.9'
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            },
        };
        var $cardDom = $paymentForm.find('.card:first')[0];
        var $cardEle = $card.create('card', {style:$style});
        $cardEle.mount($cardDom);
        libs.memorySave('nurseslounge_lounge_overview_card', $cardEle);
        nurseslounge_lounge_overview.information_tab_sponsor_degrees_buy_validate(function($form){
            var $objForm = libs.getObjForm($form);
            $submitButton.prop('disabled', true);
            $paymentFormWrapper.hide();
            $onProgressWrapper.show();
            stripe.createToken($cardEle, {
                name:$objForm.name,
                address_country:'US',
                currency:'usd'
            }).then(function($res) {
                if($res.token && $res.token.id){
                    var $newParams = $.extend({}, $objForm, $res, $params, {degree_id:$degreeId});
                    nurseslounge_lounge_overview.information_tab_sponsor_degrees_buy_request($newParams, function($data){
                        if($data.status == 'success'){
                            $paymentFormWrapper.hide();
                            $onProgressWrapper.hide();
                            $successWrapper.show();
                            $btnContinue.unbind().click(function(){
                                $submitButton.prop('disabled', false);
                                $paymentForm[0].reset();
                                $paymentForm.hide();
                                $successWrapper.hide();
                                $sponsorDegreesList.show();
                                $sponsorDegreesList.find(".search").click();
                            });
                        }else{
                            var $validator = $paymentForm.validate();
                            $validator.showErrors({"card": $data.data.msg});
                            $paymentForm.find("input[name='card']").val('');
                            $submitButton.prop('disabled', false);
                            $onProgressWrapper.hide();
                            $paymentFormWrapper.show();
                        }
                    });
                }else{
                    $submitButton.prop('disabled', false);
                    $onProgressWrapper.hide();
                    $paymentFormWrapper.show();
                }
            });
        });
        $cardEle.on('change', function($e){
            if(!$e.complete && $e.error && $e.error.message){
                var $validator = $paymentForm.validate();
                $validator.showErrors({"card": $e.error.message});
                $paymentForm.find("input[name='card']").val('');
                $paymentForm.find('.invalid-feedback').hide();
                $paymentForm.find('.error').removeClass('error');
                $paymentForm.find('.is-invalid').removeClass('is-invalid');
            }else{
                $paymentForm.find("input[name='card']").val('complete');
            }
        });
        $paymentForm.show();
    },
    information_tab_sponsor_degrees_buy_promo:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/sponsorDegrees/promo',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_sponsor_degrees_buy_validate:function(cback){
        $.validator.addMethod('minStrict', function ($val, $el, $par) {
            return $val >= $par;
        });
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $sponsorDegrees = $modal.find(".lounge-information-modal-container #sponsorDegrees .container");
        var $paymentForm = $sponsorDegrees.find("form[name='stripe-form']")
        var $validator;
        try {
            $validator = $paymentForm.validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $paymentForm.validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                from_date: {
                    required: true
                },
                days: {
                    required: true,
                },
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                },
                card: {
                    required: true
                }
            },
            messages: {
                from_date:{
                    required: "The start date is required"
                },
                days:{
                    required: "The days is required"
                },
                name:{
                    required: "The name is required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                card:{
                    required: "The card is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_tab_sponsor_degrees_buy_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/sponsorDegrees/payment',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_tab_spotlight_jobs:function($action, $tab, $allowTabs, $params, $data, cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $spotlightJobButton = $spotlightJobs.find(".spotlight-job");
        var $stripeForm = $spotlightJobs.find("form[name='stripe-form']");
        var $spotlightJobsListForm = $spotlightJobs.find("form[name='spotlight-jobs-list-form']");
        var $spotlightJobsBack = $spotlightJobs.find(".back");
        var $datatableApplications = $spotlightJobs.find(".datatable-spotlight-jobs");
        var $datatableSearch = $spotlightJobs.find("input[name='search']");
        var $datatableSearchButton = $spotlightJobs.find(".search");
        var $datatableSearchBinding;
        nurseslounge_lounge_overview.information_tab_spotlight_jobs_datatable(
            $datatableApplications,
            "/lounge/spotlightJobs/datatable",
            "POST",
            $params,
            function($table){
                $datatableApplications.find('.option').unbind().click(function(){
                    var $that = $(this);
                    var $spotlightId = $that.data('id');
                    nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_clicks($params, $spotlightId);
                });
                $datatableApplications.find('.edit').unbind().click(function(){
                    var $that = $(this);
                    var $spotlightId = $that.data('id');
                    nurseslounge_lounge_overview.information_tab_spotlight_jobs_edit($params, $spotlightId);
                });
                var $switch = $datatableApplications.find('.switch');
                $switch.unbind();
                try{
                    $switch.bootstrapToggle('destroy');
                }catch (e) {}
                $switch.bootstrapToggle();
                $switch.change(function(){
                    var $that = $(this);
                    var $spotlightId = $that.data('id');
                    var $onOff = $that.is(':checked');
                    var $newParams = $.extend({}, $params, {id:$spotlightId, checked:$onOff});
                    nurseslounge_lounge_overview.information_tab_spotlight_jobs_active_request($newParams, function($data){
                        $that.prop('checked', $data.data.checked);
                    });
                });
            },function($nRow){
                return $nRow;
            }, function($table){
                $datatableSearchButton.unbind().click(function () {
                    $table.search($datatableSearch.val());
                    $table.draw();
                });
                $datatableSearch.unbind().on('keypress keyup keydown blur', function () {
                    try{
                        clearTimeout($datatableSearchBinding);
                    }catch (e) {

                    }
                    $datatableSearchBinding = setTimeout(function(){
                        $table.search($datatableSearch.val());
                        $table.draw();
                    }, 1000);
                });
            });
        $spotlightJobButton.unbind().click(function(){
            $spotlightJobsListForm.hide();
            $stripeForm.show();
            nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_clicks($params, null);
        });
        $spotlightJobsBack.unbind().click(function(){
            $stripeForm.hide();
            $spotlightJobsListForm.show();
            dataTable.reload($datatableApplications);
        });
        if(cback != undefined){
            cback();
        }
    },
    information_tab_spotlight_jobs_datatable:function($element, $url, $method, $data, drawCallback, fnRowCallback, initComplete){
        var $table = $($element).DataTable({
            "order": [[1,"desc"]],
            "dom":"<'row'<'col-sm-3'l><'col-sm-3'f><'col-sm-6'p>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "sScrollXInner": "auto",
            "bScrollCollapse": true,
            "bAutoWidth": true,
            "responsive": false,
            "scrollX": true,
            "paging": true,
            "bDestroy": true,
            "drawCallback": function () {
                drawCallback($table);
            },
            "fnRowCallback": function($nRow){
                fnRowCallback($nRow);
            },
            "initComplete": function () {
                initComplete($table);
            },
            "cache": false,
            "pageLength": 10,
            "pagingType" : "full_numbers",
            "processing": true,
            "serverSide": true,
            "stateSave": true,
            "ajax": {
                "data":function ($d) {
                    return $.extend($d, $data);
                },
                "url":$url,
                "type":$method,
                "datatype":"json"
            }
        });
        $table.columns.adjust().draw();
    },
    information_tab_spotlight_jobs_buy_clicks:function($params, $spotlightId){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $stripeForm = $spotlightJobs.find("form[name='stripe-form']");
        var $spotlightJobsListForm = $spotlightJobs.find("form[name='spotlight-jobs-list-form']");
        if($spotlightId){
            $params = $.extend({}, $params, {id:$spotlightId});
            nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_clicks_request($params, function($data){
                nurseslounge_lounge_overview.information_tab_spotlight_jobs_events($params, $data);
                $spotlightJobsListForm.hide();
                $stripeForm.show();
            });
        }else{
            nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_clicks_request($params, function($data) {
                nurseslounge_lounge_overview.information_tab_spotlight_jobs_events($params, $data);
            });
        }
    },
    information_tab_spotlight_jobs_buy_clicks_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/spotlightJobs/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_spotlight_jobs_events:function($params, $data){
        var $spotlightJobsData = $data && $data.data && $data.data.spotlight_jobs ? $data.data.spotlight_jobs : null;
        var $logoRootLounge = $data && $data.data && $data.data.logo_root_lounge ? $data.data.logo_root_lounge : null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $spotlightJobsList = $spotlightJobs.find('form[name="spotlight-jobs-list-form"]');
        var $stripeForm = $spotlightJobs.find("form[name='stripe-form']");
        var $paymentFormWrapper = $stripeForm.find('.payment-form-wrapper');
        var $onProgressWrapper = $stripeForm.find('.on-progress-checkmark-wrapper');
        var $successWrapper = $stripeForm.find('.success-checkmark-wrapper');
        var $clicks = $stripeForm.find('input[name="clicks"]');
        var $impressionsDays = $stripeForm.find('.clicks-amount');
        var $btnContinue = $stripeForm.find('.continue');
        var $submitButton = $stripeForm.find('button[type="submit"]');
        var $id = $stripeForm.find('input[name="id"]');
        var $facilityName = $stripeForm.find('input[name="facilityName"]');
        var $cityState = $stripeForm.find('input[name="cityState"]');
        var $title = $stripeForm.find('input[name="title"]');
        var $shift = $stripeForm.find('input[name="shift"]');
        var $signingBonus = $stripeForm.find('input[name="signingBonus"]');
        var $compensation = $stripeForm.find('input[name="compensation"]');
        var $contactEmailUrl = $stripeForm.find('input[name="contactEmailUrl"]');
        var $destinationLevel = $stripeForm.find('select[name="destinationLevel"]');
        var $specialties = $stripeForm.find('select[name="specialties"]');
        var $location = $stripeForm.find('select[name="location"]');
        var $yearsOfExperience = $stripeForm.find('select[name="yearsOfExperience"]');
        var $logo = $stripeForm.find(".logo");
        var $previewText = $stripeForm.find(".preview-text");
        var $promo = $stripeForm.find('input[name="promo"]');

        $id.val("");
        $facilityName.val("");
        $cityState.val("");
        $title.val("");
        $shift.val("");
        $signingBonus.val("");
        $compensation.val("");
        $contactEmailUrl.val("");
        $logo.attr('src', $logoRootLounge);

        if($spotlightJobsData){
            $id.val($spotlightJobsData.id);
            $facilityName.val($spotlightJobsData.facility_name);
            $cityState.val($spotlightJobsData.city_state);
            $title.val($spotlightJobsData.title);
            $shift.val($spotlightJobsData.shift);
            $signingBonus.val($spotlightJobsData.signing_bonus);
            $compensation.val($spotlightJobsData.compensation);
            $contactEmailUrl.val($spotlightJobsData.contact_email_url);
        }

        if(
            $title.val() == "" &&
            $shift.val() == "" &&
            $signingBonus.val() == "" &&
            $compensation.val() == "" &&
            $facilityName.val() == "" &&
            $cityState.val() == ""
        ){
            $previewText.html('');
        }else{
            $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
        }

        $facilityName.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $cityState.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $title.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $shift.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $signingBonus.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $compensation.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });

        try{
            $destinationLevel.chosen('destroy');
        }catch (e) {}
        $destinationLevel.chosen();
        if($spotlightJobsData.target){
            $destinationLevel.val(JSON.parse($spotlightJobsData.target).destinationLevel).trigger("chosen:updated");
        }else{
            $destinationLevel.val('').trigger("chosen:updated");
        }
        $destinationLevel.unbind();

        try{
            $specialties.chosen('destroy');
        }catch (e) {}
        $specialties.chosen();
        if($spotlightJobsData.target){
            $specialties.val(JSON.parse($spotlightJobsData.target).specialties).trigger("chosen:updated");
        }else{
            $specialties.val('').trigger("chosen:updated");
        }
        $specialties.unbind();

        try{
            $location.chosen('destroy');
        }catch (e) {}
        $location.chosen();
        if($spotlightJobsData.target){
            $location.val(JSON.parse($spotlightJobsData.target).location).trigger("chosen:updated");
        }else{
            $location.val('').trigger("chosen:updated");
        }
        $location.unbind();

        try{
            $yearsOfExperience.chosen('destroy');
        }catch (e) {}
        $yearsOfExperience.chosen();
        if($spotlightJobsData.target){
            $yearsOfExperience.val(JSON.parse($spotlightJobsData.target).yearsOfExperience).trigger("chosen:updated");
        }else {
            $yearsOfExperience.val('').trigger("chosen:updated");
        }
        $yearsOfExperience.unbind();


        try{
            var $cardSaved = libs.memoryGet('nurseslounge_lounge_overview_card');
            if($cardSaved){
                $cardSaved.destroy();
            }
        }catch ($e){

        }

        $paymentFormWrapper.show();
        $onProgressWrapper.hide();
        $successWrapper.hide();

        $submitButton.prop('disabled', false);
        $clicks.unbind().change(function(){
            var $that = $(this);
            var $val = $that.val();
            var $impressions = ($val * 5);
            $impressionsDays.html('$'+$impressions.toFixed(2));
            $promo.keydown();
        });

        var $promoBinding;
        $promo.unbind().on('keyup keydown keypress blur', function(){
            var $code = $(this).val();
            $params = $.extend({}, $params, {code:$code});
            try{
                clearTimeout($promoBinding);
            }catch ($e) {

            }
            $promoBinding = setTimeout(function(){
                nurseslounge_lounge_overview.information_tab_spotlight_jobs_promo($params, function($data){
                    var $promo = $data.data.promo_code;
                    var $discountType = $promo && $promo.discount_type ? $promo.discount_type : null;
                    var $discount = $promo && $promo.discount ? $promo.discount : null;
                    $params = $.extend({}, $params, {discount_type:$discountType, discount:$discount});
                    var $impressions = ($clicks.val() * 5);
                    if($discountType && $discount){
                        switch ($discountType){
                            case 'percent':
                                $discount = ($discount * $impressions)/100;
                                $impressions = $impressions - $discount;
                                $impressionsDays.html('$'+$impressions.toFixed(2));
                                break;
                            case 'money':
                                $impressions = $impressions - $discount;
                                $impressionsDays.html('$'+$impressions.toFixed(2));
                                break;
                        }
                    }else{
                        $impressionsDays.html('$'+$impressions.toFixed(2));
                    }
                });
            }, 800);
        }).keydown();

        var $card = stripe.elements();
        var $style = {
            base: {
                'lineHeight': '1.5',
                'fontSize': '1.09em',
                'color': '#00184A',
                'fontFamily': "sans-serif",
                'height':'100%',
                'fontWeight':'100',
                'opacity': '0.9',
                '::placeholder': {
                    'color':'#636c72',
                    'opacity':'0.9'
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            },
        };
        var $cardDom = $stripeForm.find('.credit-card:first')[0];
        var $cardEle = $card.create('card', {style:$style});
        $cardEle.mount($cardDom);
        libs.memorySave('nurseslounge_lounge_overview_card', $cardEle);
        nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_validate(function($form){
            var $objForm = libs.getObjForm($form);
            $submitButton.prop('disabled', true);
            $paymentFormWrapper.hide();
            $onProgressWrapper.show();
            stripe.createToken($cardEle, {
                name:$objForm.name,
                address_country:'US',
                currency:'usd'
            }).then(function($res) {
                if($res.token && $res.token.id){
                    var $newParams = $.extend({}, $objForm, $res, $params);
                    nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_request($newParams, function($data){
                        if($data.status == 'success'){
                            $paymentFormWrapper.hide();
                            $onProgressWrapper.hide();
                            $successWrapper.show();
                            $btnContinue.unbind().click(function(){
                                $paymentFormWrapper.show();
                                $submitButton.prop('disabled', false);
                                $stripeForm[0].reset();
                                $stripeForm.hide();
                                $successWrapper.hide();
                                $spotlightJobsList.show();
                                $spotlightJobsList.find(".search").click();
                            });
                        }else{
                            var $validator = $stripeForm.validate();
                            $validator.showErrors({"card": $data.data.msg});
                            $stripeForm.find("input[name='card']").val('');
                            $submitButton.prop('disabled', false);
                            $onProgressWrapper.hide();
                            $paymentFormWrapper.show();
                        }
                    });
                }else{
                    $submitButton.prop('disabled', false);
                    $onProgressWrapper.hide();
                    $paymentFormWrapper.show();
                }
            });
        });
        $cardEle.on('change', function($e){
            if(!$e.complete && $e.error && $e.error.message){
                var $validator = $stripeForm.validate();
                $validator.showErrors({"card": $e.error.message});
                $stripeForm.find("input[name='card']").val('');
                $stripeForm.find('.invalid-feedback').hide();
                $stripeForm.find('.error').removeClass('error');
                $stripeForm.find('.is-invalid').removeClass('is-invalid');
            }else{
                $stripeForm.find("input[name='card']").val('complete');
            }
        });
    },
    information_tab_spotlight_jobs_promo:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/spotlightJobs/promo',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_spotlight_jobs_buy_validate:function(cback){
        $.validator.addMethod('minStrict', function ($val, $el, $par) {
            return $val >= $par;
        });
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $stripeForm = $spotlightJobs.find("form[name='stripe-form']")
        var $validator;
        try {
            $validator = $stripeForm.validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $stripeForm.validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                facilityName: {
                    required: true
                },
                cityState: {
                    required: true
                },
                title: {
                    required: true
                },
                shift: {
                    required: false
                },
                signingBonus: {
                    required: false
                },
                compensation: {
                    required: false
                },
                contactEmailUrl: {
                    required: true
                },
                destinationLevel: {
                    required: true
                },
                specialties: {
                    required: true
                },
                location: {
                    required: true
                },
                yearsOfExperience: {
                    required: true
                }
            },
            messages: {
                facilityName: {
                    required: "The facility name is required"
                },
                cityState: {
                    required: "The city, state is required"
                },
                title:{
                    required: "The title is required"
                },
                shift:{
                    required: "The shift is not required"
                },
                signingBonus:{
                    required: "The signing bonus is not required"
                },
                compensation:{
                    required: "The compensation is not required"
                },
                contactEmailUrl:{
                    required: "The contact email or url is required"
                },
                destinationLevel:{
                    required: "The destination level is required"
                },
                specialties:{
                    required: "The specialties is required"
                },
                location:{
                    required: "The location is required"
                },
                yearsOfExperience:{
                    required: "The years of experience is required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_tab_spotlight_jobs_buy_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/spotlightJobs/payment',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_spotlight_jobs_active_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/spotlightJobs/active',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_spotlight_jobs_edit:function($params, $spotlightId){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $stripeForm = $spotlightJobs.find("form[name='stripe-form']");
        var $spotlightJobsListForm = $spotlightJobs.find("form[name='spotlight-jobs-list-form']");
        var $spotlightEditForm = $spotlightJobs.find("form[name='spotlight-jobs-edit']");
        $params = $.extend({}, $params, {id:$spotlightId});
        nurseslounge_lounge_overview.information_tab_spotlight_jobs_buy_clicks_request($params, function($data){
            nurseslounge_lounge_overview.information_tab_spotlight_jobs_edit_events($params, $data);
            $spotlightJobsListForm.hide();
            $stripeForm.hide();
            $spotlightEditForm.show();
        });
    },
    information_tab_spotlight_jobs_edit_events:function($params, $data){
        var $spotlightJobsData = $data && $data.data && $data.data.spotlight_jobs ? $data.data.spotlight_jobs : null;
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $stripeForm = $spotlightJobs.find("form[name='stripe-form']");
        var $spotlightJobsListForm = $spotlightJobs.find("form[name='spotlight-jobs-list-form']");
        var $spotlightJobsEditForm = $spotlightJobs.find('form[name="spotlight-jobs-edit"]');
        var $id = $spotlightJobsEditForm.find('input[name="id"]');
        var $facilityName = $spotlightJobsEditForm.find('input[name="facilityName"]');
        var $cityState = $spotlightJobsEditForm.find('input[name="cityState"]');
        var $title = $spotlightJobsEditForm.find('input[name="title"]');
        var $shift = $spotlightJobsEditForm.find('input[name="shift"]');
        var $signingBonus = $spotlightJobsEditForm.find('input[name="signingBonus"]');
        var $compensation = $spotlightJobsEditForm.find('input[name="compensation"]');
        var $contactEmailUrl = $spotlightJobsEditForm.find('input[name="contactEmailUrl"]');
        var $back = $spotlightJobsEditForm.find('.back');
        var $datatableSearchButton = $spotlightJobs.find(".search");
        var $logo = $spotlightJobs.find(".logo");
        var $previewText = $spotlightJobs.find(".preview-text");

        $id.val("");
        $facilityName.val("");
        $cityState.val("");
        $title.val("");
        $shift.val("");
        $signingBonus.val("");
        $compensation.val("");
        $contactEmailUrl.val("");
        $id.val($spotlightJobsData.id);
        $facilityName.val($spotlightJobsData.facility_name);
        $cityState.val($spotlightJobsData.city_state);
        $title.val($spotlightJobsData.title);
        $shift.val($spotlightJobsData.shift);
        $signingBonus.val($spotlightJobsData.signing_bonus);
        $compensation.val($spotlightJobsData.compensation);
        $contactEmailUrl.val($spotlightJobsData.contact_email_url);
        $logo.attr('src', $spotlightJobsData.lounge.logo_root_lounge);

        if(
            $title.val() == "" &&
            $shift.val() == "" &&
            $signingBonus.val() == "" &&
            $compensation.val() == "" &&
            $facilityName.val() == "" &&
            $cityState.val() == ""
        ){
            $previewText.html('');
        }else{
            $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
        }

        $facilityName.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $cityState.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $title.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $shift.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $signingBonus.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });
        $compensation.unbind().on('keyup keydown', function(){
            if(
                $title.val() == "" &&
                $shift.val() == "" &&
                $signingBonus.val() == "" &&
                $compensation.val() == "" &&
                $facilityName.val() == "" &&
                $cityState.val() == ""
            ){
                $previewText.html('');
            }else{
                $previewText.html($title.val()+' - '+$shift.val()+' - '+$signingBonus.val()+' - '+$compensation.val()+' - '+$facilityName.val()+' - '+$cityState.val());
            }
        });

        nurseslounge_lounge_overview.information_tab_spotlight_jobs_edit_validate(function($form){
            var $objForm = libs.getObjForm($form);
            var $newParams = $.extend({}, $objForm, $params);
            nurseslounge_lounge_overview.information_tab_spotlight_jobs_edit_request($newParams, function(){
                $stripeForm.hide();
                $spotlightJobsEditForm.hide();
                $spotlightJobsListForm.show();
                $datatableSearchButton.click();
            });
        });
        $back.unbind().click(function(){
            $stripeForm.hide();
            $spotlightJobsEditForm.hide();
            $spotlightJobsListForm.show();
            $datatableSearchButton.click();
        });
    },
    information_tab_spotlight_jobs_edit_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/spotlightJobs/set',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_tab_spotlight_jobs_edit_validate:function(cback){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $spotlightJobs = $modal.find(".lounge-information-modal-container #spotlightJobs .container");
        var $stripeForm = $spotlightJobs.find("form[name='spotlight-jobs-edit']")
        var $validator;
        try {
            $validator = $stripeForm.validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $stripeForm.validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                facilityName: {
                    required: true
                },
                cityState: {
                    required: true
                },
                title: {
                    required: true
                },
                shift: {
                    required: false
                },
                signingBonus: {
                    required: false
                },
                compensation: {
                    required: false
                },
                contactEmailUrl: {
                    required: true
                },
            },
            messages: {
                facilityName: {
                    required: "The facility name is required"
                },
                cityState: {
                    required: "The city, state is required"
                },
                title:{
                    required: "The title is required"
                },
                shift:{
                    required: "The shift is not required"
                },
                signingBonus:{
                    required: "The signing bonus is not required"
                },
                compensation:{
                    required: "The compensation is not required"
                },
                contactEmailUrl:{
                    required: "The contact email or url is required"
                },
                destinationLevel:{
                    required: "The destination level is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    claim_lounge:function($container, $params){
        var $modal = $("#nurseslounge-claim-lounges-modal");
        var $claimLoungeContainer = $container.find('.claim-lounge-container:first');
        var $claimLoungeButton = $claimLoungeContainer.find('.claim-lounge:first');
        var $modalTitle = $modal.find(".modal-title");
        var $modalBody = $modal.find(".modal-body");
        $claimLoungeButton.unbind().click(function(){
            nurseslounge_lounge_overview.claim_lounge_form_request($params, function($chtml){
                $modalTitle.html('Contact us to own this Lounge');
                $modalBody.html($chtml).promise().done(function(){
                    nurseslounge_lounge_overview.claim_lounge_validate(function($form){
                        $params = $.extend({}, $params, libs.getObjForm($form));
                        nurseslounge_lounge_overview.claim_lounge_request($params, function(){
                            $modal.modal('hide');
                        });
                    });
                    $modal.find("form input[name='phone']").mask('+(00) 000-000-0000');
                    $modal.modal('show');
                });
            });
        });
    },
    claim_lounge_form_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/claim/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    claim_lounge_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-claim-lounges-modal form:first").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-claim-lounges-modal form:first").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                name: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                },
                phone: {
                    required: true,
                    minlength: 2,
                    maxlength: 18
                },
                company: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                jobTitle: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                message: {
                    required: false
                }
            },
            messages: {
                name: {
                    required: "The name is required",
                    minlength: "The name must have at least 3 characters",
                    maxlength: "The name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid"
                },
                phone: {
                    required: "The phone is required",
                    minlength: "The phone must have at least 3 characters",
                    maxlength: "The phone cannot exceed 191 characters",
                },
                company: {
                    required: "The company is required",
                    minlength: "The company must have at least 3 characters",
                    maxlength: "The company cannot exceed 191 characters",
                },
                jobTitle: {
                    required: "The job title is required",
                    minlength: "The job title must have at least 3 characters",
                    maxlength: "The job title cannot exceed 191 characters",
                },
                message: {
                    required: "The message is not required",
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    claim_lounge_request:function($params, cback){
        $.ajax({
            url: "/lounge/claim/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-lounge-information .nurseslounge-lounge-information-right .banners")
        });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-lounge-information .nurseslounge-lounge-information-right .lounge-ads")
        });
    },
    lounge_ads_engine:function($config){
        var $userId = libs.memoryGet('user_id');
        var $ads = $config.ads.not('.slick-initialized');
        try {
            $ads.slick('unslick');
        } catch (e) {
        }
        var $widget = $ads.parents('.lounge-ads-container:first');
        var $adsName = 'ADS';
        var $adsCookie = nurseslounge_myDashboard_accountSettings.readCookie($adsName);
        $.ajax({
            url: "/lounge/ads",
            method: "POST",
            cache: false,
            dataType: "json",
            data: {
                user_id: $userId,
                lounge_ads:$adsCookie
            },
            success: function ($data) {
                libs.expire($data);
                $ads.width($widget.width());
                var $chtml = '';
                if ($data.status == 'success') {
                    $.each($data.data.lounge_ads, function($i, $v){
                        if($i == 0){
                            $adsCookie = nurseslounge_myDashboard_accountSettings.readCookie($adsName);
                            if($adsCookie && $adsCookie != ''){
                                $adsCookie = JSON.parse($adsCookie);
                            }else{
                                $adsCookie = {};
                            }
                            if($adsCookie && $adsCookie[$v.id] && parseInt($adsCookie[$v.id]) > 0){
                                $adsCookie[$v.id] = 1 + parseInt($adsCookie[$v.id]);
                            }else{
                                $adsCookie[$v.id] = 1;
                            }
                            nurseslounge_myDashboard_accountSettings.createCookie($adsName,JSON.stringify($adsCookie),1);
                        }
                        $chtml+='<div class="col-12 open-url cursor-pointer" data-id="'+$v.id+'" data-key="'+$v.lounge.key+'">';
                        $chtml+='   <img src="'+$v.public_image_root+'" class="img-fluid">';
                        $chtml+='</div>';
                    });
                    libs.checkImageLoad($($chtml).find('img'), function(){
                        $ads.width($widget.width());
                        $ads.html($chtml).promise().done(function(){
                            if($data.data.lounge_ads.length > 0){
                                $config.ads.parent().show();
                            }else{
                                $config.ads.parent().hide();
                            }
                            $ads.on('init', function () {
                                $ads.find('.open-url').unbind().click(function(){
                                    var $key = $(this).data('key');
                                    window.open(window.location.protocol +'//'+ window.location.hostname + "/lounge/"+$key, '_blank', '');
                                });
                            }).on('beforeChange', function($e, $slick, $cS, $nS){
                                    var $slickSlide = $(".slick-slide[data-slick-index='"+$nS+"'");
                                    var $id = $slickSlide.find('.open-url').data('id');
                                    $adsCookie = nurseslounge_myDashboard_accountSettings.readCookie($adsName);
                                    if($adsCookie && $adsCookie != ''){
                                        $adsCookie = JSON.parse($adsCookie);
                                    }else{
                                        $adsCookie = {};
                                    }
                                    if($adsCookie && $adsCookie[$id] && parseInt($adsCookie[$id]) > 0){
                                        $adsCookie[$id] = 1 + parseInt($adsCookie[$id]);
                                    }else{
                                        $adsCookie[$id] = 1;
                                    }
                                    nurseslounge_myDashboard_accountSettings.createCookie($adsName,JSON.stringify($adsCookie),10);
                            }).slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                autoplay: true,
                                autoplaySpeed: 5000,
                                arrows: false,
                                dots: false,
                                pauseOnHover: false
                            });
                        });
                    });
                }
            }
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-lounge-information .nurseslounge-lounge-information-right");
        cback($container);
    },
    //Claim Lounge
    claim_lounge_container:function(cback){
        var $container = $("#nurseslounge-lounge-information .nurseslounge-lounge-information-right");
        cback($container);
    },
    //Meet our recruiters
    information_meet_our_recruiters:function(cback){
        cback({
            'container':$("#nurseslounge-lounge-information .nurseslounge-lounge-information-right .meet-our-recruiters")
        });
    },
    information_meet_our_recruiters_engine:function($config){
        var $modal = $("#nurseslounge-meet-recruiters-modal");
        var $recruiter = $config.container.find('.recruiter');
        $recruiter.unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            var $recruiterUserId = $that.data('recruiteruserid');
            var $params = $.extend({}, {key:$key, user_id:libs.memoryGet('user_id'), recruiter_user_id:$recruiterUserId});
            nurseslounge_lounge_overview.information_meet_our_recruiters_request($params, function($chtml){
                var $requestInfoModal = $modal.find(".request-info-modal-container");
                $requestInfoModal.html($chtml).promise().done(function(){
                    var $otherFacilityDiv = $modal.find('.other-facility');
                    var $selectFacility = $modal.find('select[name="facility"]');
                    var $otherFacility = $modal.find('input[name="otherFacility"]');
                    $selectFacility.unbind().change(function(){
                        var $that = $(this);
                        var $val = $that.val();
                        if($val != ''){
                            if($val == 'Other'){
                                if($otherFacilityDiv.hasClass('d-none')){
                                    $otherFacilityDiv.removeClass('d-none');
                                }
                            }else{
                                if(!$otherFacilityDiv.hasClass('d-none')){
                                    $otherFacilityDiv.addClass('d-none');
                                }
                            }
                            $otherFacility.val('');
                        }
                    });
                    $modal.find("form").find("input[name='phone']").mask('+(00) 000-000-0000');
                    nurseslounge_lounge_overview.information_meet_our_recruiters_validate(function($form){
                        $params = $.extend({}, $params, libs.getObjForm($form));
                        nurseslounge_lounge_overview.information_meet_our_recruiters_request_set($params, function($data){
                            $modal.modal('hide');
                        });
                    });
                    $modal.modal('show');
                });
            });
        });
        libs.refreshTooltips();
    },
    information_meet_our_recruiters_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-meet-recruiters-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-meet-recruiters-modal form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                name:{
                    required: true
                },
                email:{
                    required: true,
                    email: true
                },
                phone:{
                    required: false
                },
                jobTitle:{
                    required: false
                },
                facility:{
                    required: false
                },
                otherFacility:{
                    required: false
                },
                message:{
                    required: false
                }
            },
            messages: {
                name:{
                    required: "The name is required"
                },
                email:{
                    required: "The email is required",
                    email: "The email is invalid"
                },
                phone:{
                    required: "The phone is not required"
                },
                jobTitle:{
                    required: "The job title is not required"
                },
                facility:{
                    required: "The facility is not required"
                },
                otherFacility: {
                    required: "The other facility is not required"
                },
                message: {
                    required: "The message is not required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_meet_our_recruiters_request:function($params, cback){
        $.ajax({
            url:'/lounge/requestRecruiterInfo/get',
            method: "POST",
            cache:false,
            dataType: "html",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    information_meet_our_recruiters_request_set:function($params, cback){
        $.ajax({
            url: "/lounge/requestRecruiterInfo/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Report
    report_container:function(cback){
        var $container = $("#nurseslounge-lounge-information .nurseslounge-lounge-information-right .report");
        cback($container);
    },
    report:function($container, $params){
        nurseslounge_lounge_overview.report_request($params, function($chtml){
            $container.html($chtml).promise().done(function(){
                libs.refreshTooltips();
            });
        });
    },
    report_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/lounge/report/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
};
